/* RUN ONCE PER PAGE (2026-10-31): some templates include this file twice (the rebuild theme lists it in the header and in
   the chat sections); a second copy re-bound every listener below, so one swipe stepped two photos and one tap toggled twice. */
if (!window.__swbV2FileRan) { window.__swbV2FileRan = true;
/* MENU USE FOR THE TRACKER (2026-10-21): t.js records these as 'ui' events, so a menu opened and closed without a
   link click, and how deep someone went, is visible in the data (megaDepth 1 = a brand, 2 = a series). */
var megaDepth = 0;
var sheetDepth = 0;
function lpUi(name, action, label, depth) {
  try {
    document.dispatchEvent(new CustomEvent('lp:ui', { detail: { name: name, action: action, label: label || '', depth: depth || 0 } }));
  } catch (e) {
    /* ignore */
  }
}
/* ======================================================================================================================
   SWB HOME v2 — behaviour
   Theme #200092287359. Additive: nothing here touches an original script.

   Three jobs:
     1. MOTION      scroll reveal + pointer 3D tilt (both purely progressive)
     2. THE PICKER  brand -> model choice, remembered, broadcast
     3. THE RAIL    swap in real product cards for the chosen watch via ?view=newrow

   The picker is the page's spine: everything below the hero personalises off the chosen watch. The choice is kept in
   sessionStorage so it survives a click into a PDP and back, and is broadcast as a DOM event so any section can listen
   without knowing about any other section.
   ====================================================================================================================== */
(function () {
  'use strict';

  /* One execution per page, however many sections asked for the file. Anything below this line registers document
     level listeners, and a second pass would double every one of them. */
  if (window.swbV2Booted) return;
  window.swbV2Booted = true;

  var STORE_KEY = 'swbV2Watch';
  /* new-swb-home (2026-10-05): this is new-swb-theme's assets/swb-v2.js running on the LIVE theme, where product,
     collection and cart pages keep the live header and the live switch module. LIVE_COMPAT changes four things:
       1. the cart attributes (switch-module-*) are the truth for the watch, so a choice made in the live switch
          module on a product or collection page is what the new menu shows on the next page
       2. a watch picked in the new menu also clears switch-module-filter, as the live module does when it cannot
          resolve one, so a collection never stays filtered for the previous watch
       3. pop-ups and drawers keep the live behaviour (no add-on drawer flip, no product-page drawer moves)
       4. no chat: no dock, no drawer yield, no strap help */
  var LIVE_COMPAT = true;

  /* VIDEO SIZE BY SCREEN (2026-10-03). Every product film is Shopify's 1080p rendition (~9MB); a phone downloaded the
     full file for a picture 390px wide (8.6MB measured on the materials page). Shopify keeps 720p and 480p renditions
     at the same address with a different quality tag, so the URL is rewritten before the browser fetches it: 480p on
     phones (1.9MB, the same file measured), 720p on tablets, 1080p unchanged on desktop. Covers markup sources and
     sources set later by any script (setAttribute and .src). */
  var vidTier = window.matchMedia('(max-width: 749px)').matches ? 'SD-480p-1.5Mbps' : window.matchMedia('(max-width: 1199px)').matches ? 'HD-720p-4.5Mbps' : '';
  if (window.swbLiveContent) vidTier = ''; // new-swb-home: live-content pages keep their videos exactly as live
  function vidUrl(u) {
    return vidTier && typeof u === 'string' && u.indexOf('HD-1080p-7.2Mbps') > -1 ? u.replace('HD-1080p-7.2Mbps', vidTier) : u;
  }
  if (vidTier) {
    try {
      var vd = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, 'src');
      Object.defineProperty(HTMLMediaElement.prototype, 'src', { configurable: true, get: vd.get, set: function (v) { vd.set.call(this, vidUrl(v)); } });
      var sd = Object.getOwnPropertyDescriptor(HTMLSourceElement.prototype, 'src');
      Object.defineProperty(HTMLSourceElement.prototype, 'src', { configurable: true, get: sd.get, set: function (v) { sd.set.call(this, vidUrl(v)); } });
      var sa = Element.prototype.setAttribute;
      Element.prototype.setAttribute = function (n, v) {
        if ((n === 'src' || n === 'data-src') && (this.tagName === 'VIDEO' || this.tagName === 'SOURCE')) v = vidUrl(v);
        return sa.call(this, n, v);
      };
    } catch (e) { /* old browser: full size, as before */ }
    var fixVids = function () {
      document.querySelectorAll('video[src*="HD-1080p"], video[data-src*="HD-1080p"], video source[src*="HD-1080p"]').forEach(function (el) {
        ['src', 'data-src'].forEach(function (a) { var u = el.getAttribute(a); if (u && u.indexOf('HD-1080p') > -1) el.setAttribute(a, u); });
        var v = el.tagName === 'SOURCE' ? el.parentElement : el;
        if (v && v.networkState === 1 && v.readyState === 0) v.load();
      });
    };
    fixVids();
    document.addEventListener('DOMContentLoaded', fixVids);
  }

  /* Fetched product cards each carry the loyalty badge's ~10 KB <style> block (snippet loyalty-points-badge, a shared
     theme file). The page already has one copy; parsing it again per card was dead work. Drop the repeats. */
  /* A copy only counts while it is still ON the page: when the rail reloads for a new watch, the cards that held the
     surviving copy are replaced, and dropping the new one as a "duplicate" left the cards unstyled with no gap between
     them (2026-10-02). So the map keeps the element, and a copy whose element is gone is kept and becomes the one. */
  /* Runs AFTER new content is on the page: keeps the first copy of each <style> that is actually in the document and
     removes the later ones. Run before insertion it dropped the new copy while the old one was about to be replaced. */
  function dedupeStyles(root) {
    var seen = {};
    [].forEach.call(document.querySelectorAll('style'), function (st) {
      var k = st.textContent;
      if (k.length < 400) return; // small inline styles are not the problem; leave them alone
      if (seen[k]) { if (!root || root.contains(st)) st.parentNode.removeChild(st); }
      else seen[k] = 1;
    });
  }
  window.swbV2DedupeStyles = dedupeStyles;
  var EVENT = 'swb-v2:watch';
  var PANEL_EVENT = 'swb-v2:panel';

  /* Announce that a panel is opening. Everything else that can be open listens and closes itself. Keeping this as a
     document event means the header, the picker popover and the search bar stay independent of each other. */
  function announcePanel(name) {
    document.dispatchEvent(new CustomEvent(PANEL_EVENT, { detail: name }));
  }

  /* --------------------------------------------------------------------------------------------------------------
     0. mark that JS is alive. The reveal styles are gated on this class so a thrown error can never leave the page
     permanently invisible — without .v2-js, nothing is hidden in the first place.
     -------------------------------------------------------------------------------------------------------------- */
  document.documentElement.classList.add('v2-js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------------------------------------------------------------------------------------------
     1. MOTION
     -------------------------------------------------------------------------------------------------------------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.v2-reveal:not([data-v2-seen])');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.setAttribute('data-v2-seen', '');
        el.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach(function (el, i) {
      el.setAttribute('data-v2-seen', '');
      // stagger within a group, capped so a long rail never waits seconds
      var d = Math.min(i % 8, 7) * 55;
      el.style.setProperty('--v2-delay', d + 'ms');
      io.observe(el);
    });
  }

  /* ported from the draft theme 2026-10-26 (asked: "bring the nice scrolling animations to the home version") */
  /* MOTION PASS (2026-10-13, asked: "Claude Motion like features in the scrolling", full theme only). Claude Motion
     builds explainers out of code: words that land one after another, numbers that count to their value, lines
     that draw themselves. The same grammar here, played once as each part reaches the screen:
       - section headings build up word by word (each word rises out of its own clip);
       - a score or rating counts up from zero, in the market's own number format, without changing its width;
       - the underline of a "view all" link draws itself in after its heading (CSS, keyed on the reveal).
     Nothing is hidden without JS or with reduced motion, and a heading that a script rewrites later (the rails'
     "for your watch" titles) is left alone. */
  function initMotionPass(root) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var de = document.documentElement;
    de.classList.add('v2-motion');
    /* FAST SCROLL KEEPS UP (2026-10-29, asked: "if the page loads and I quickly scroll down, you miss the animations or
       they don't load on time"). A thumb flick moves several screens a second, so a scene that waited for 12% of the
       screen and then took ~1.5s to cascade left blank space under the visitor, and a section flown past between two
       frames was never seen by the observer at all and stayed hidden. Now each part starts the moment it enters, a
       part that arrives during a fast scroll plays a short version (no cascade wait, ~0.35s), and one check per frame
       while scrolling starts anything that has already reached or passed the screen. */
    var vel = 0, lastY = window.scrollY, lastT = 0, fastUntil = 0, pend = [], ticking = false;
    function fast() { return vel > 1.2 || Date.now() < fastUntil; }
    function play(el) {
      var i = pend.indexOf(el);
      if (i > -1) pend.splice(i, 1);
      if (el.classList.contains('is-play') || el.classList.contains('is-on')) return;
      if (fast() || el.getBoundingClientRect().bottom < 0) el.classList.add('is-quick');
      if (el.hasAttribute('data-v2-count')) { countUp(el); el.classList.add('is-on'); return; }
      if (el.classList.contains('v2-scene')) {
        el.classList.add('is-play');
        // once played, the scene steps away entirely, so hovers and later re-renders behave as they always did
        setTimeout(function () { el.classList.remove('v2-scene', 'is-play', 'is-quick'); }, el.classList.contains('is-quick') ? 900 : 2600);
      } else el.classList.add('is-on');
    }
    function check() {
      ticking = false;
      var vh = window.innerHeight;
      /* read every rect first, then write: play() adds classes, and a rect read after a class write forces a fresh
         layout, so the old read-write-read loop laid the page out once per pending element per frame (2026-11-02 audit:
         3.2 s of getBoundingClientRect during a 9 s scroll on a 4x-slowed phone, 3 fps). */
      var hit = pend.slice().filter(function (el) { return el.getBoundingClientRect().top < vh; });
      hit.forEach(play);
    }
    window.addEventListener('scroll', function () {
      var now = Date.now(), y = window.scrollY, dt = now - lastT;
      if (dt > 0 && dt < 200) { vel = Math.abs(y - lastY) / dt; if (vel > 1.2) fastUntil = now + 250; }
      lastY = y; lastT = now;
      if (pend.length && !ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        play(e.target);
      });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0 });

    (root || document).querySelectorAll('.v2-root .v2-h2:not([data-v2-words]):not([data-v2-rail-title]):not([data-v2-viewed-title])').forEach(function (h) {
      if (h.closest('.v2-hdr, .v2-chat, [data-v2-sheet]')) return;
      h.setAttribute('data-v2-words', '');
      var n = 0;
      (function split(node) {
        [].slice.call(node.childNodes).forEach(function (c) {
          if (c.nodeType === 1) { split(c); return; }
          if (c.nodeType !== 3 || !c.nodeValue.trim()) return;
          var frag = document.createDocumentFragment();
          c.nodeValue.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement('span');
            w.className = 'v2-w';
            var i = document.createElement('span');
            i.className = 'v2-wi';
            i.style.setProperty('--wi', n++);
            i.textContent = part;
            w.appendChild(i);
            frag.appendChild(w);
          });
          c.parentNode.replaceChild(frag, c);
        });
      })(h);
      if (n > 14) { h.removeAttribute('data-v2-words'); return; } // a long title reads better arriving whole
      h.classList.add('v2-kin');
      pend.push(h);
      io.observe(h);
    });

    /* SECTIONS ARRIVE AS SCENES (2026-10-13, asked: "use the motion techniques in a fancy way of loading modules").
       Each homepage section is staged like a Motion scene the first time it reaches the screen, in one order:
       the eyebrow is written out, the heading builds word by word, pictures open behind a wipe while they settle
       from a slight zoom, the cards cascade in one after another with a small spring, the buttons come last. The
       timing lives in CSS (swb-v2.css, SCENES); this only marks the sections, numbers the cards and starts each
       scene. Sections with their own scroll-driven motion (occasions, materials film, bundle picture) keep it. */
    var SKIP = /swb-v2-(hero|usp|trust)\b|group-footer|group-header|swb-v2-occasions|swb-v2-materials/;
    var CARDS = '.nr-i, .v2-acard, .v2-post, .v2-rv, .v2-hfaq__item, .v2-dd__card, .v2-pick__field';
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        sio.unobserve(e.target);
        play(e.target);
      });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0 });
    (root || document).querySelectorAll('main > .shopify-section').forEach(function (sec) {
      if (sec.classList.contains('v2-scene') || SKIP.test(sec.className) || !sec.querySelector('.v2-root')) return;
      // already on screen when the script runs: no scene, nothing may vanish in front of the visitor
      var b = sec.getBoundingClientRect();
      if (b.top < window.innerHeight * 0.85) return;
      sec.classList.add('v2-scene');
      // the old fade-up is finished in advance, so nothing is hidden when the scene hands back
      sec.querySelectorAll('.v2-reveal').forEach(function (el) { el.setAttribute('data-v2-seen', ''); el.classList.add('is-in'); });
      sec.querySelectorAll(CARDS).forEach(function (c, i) { c.style.setProperty('--si', Math.min(i, 8)); });
      pend.push(sec);
      sio.observe(sec);
    });

    function countUp(el) {
      var txt = el.textContent.trim();
      var m = txt.match(/^(\d+)([.,])(\d{1,2})$/);
      var target, dec = '', decs = 0, sep = '';
      if (m) { target = parseFloat(m[1] + '.' + m[3]); dec = m[2]; decs = m[3].length; }
      else if (/^\d{1,3}([.,\u202f\u00a0 ]\d{3})+$|^\d+$/.test(txt)) { sep = (txt.match(/[.,\u202f\u00a0 ]/) || [''])[0]; target = parseInt(txt.replace(/\D/g, ''), 10); }
      else return;
      el.style.minWidth = el.getBoundingClientRect().width + 'px';
      el.style.display = el.style.display || 'inline-block';
      function fmt(v) {
        if (dec) return v.toFixed(decs).replace('.', dec);
        var s = String(Math.round(v));
        return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : s;
      }
      var t0 = 0, dur = 1100;
      function step(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / dur);
        el.textContent = fmt(target * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(step); else el.textContent = txt;
      }
      requestAnimationFrame(step);
    }
    (root || document).querySelectorAll('.v2-score__n, .v2-pick__trust b').forEach(function (el) {
      if (el.hasAttribute('data-v2-count')) return;
      el.setAttribute('data-v2-count', '');
      pend.push(el);
      io.observe(el);
    });
  }

  /* HOMEPAGE PICTURES ARRIVE BEFORE YOU DO (2026-10-13, asked: "when I scroll down the images should already be
     loaded; now you see the modules slowly loading in the images"). The browser only fetches a lazy picture when it
     is almost on screen, and pictures in a sideways rail not until that rail is swiped, so every section painted its
     images in front of the visitor. Once the first screen has loaded and the page is idle, each homepage section
     fetches its pictures as soon as it comes within ~2.5 screens, a rail all at once. Not everything at load: that is
     ~5MB on a phone and would compete with the first screen. */
  function initWarmImages() {
    // every page since 2026-10-14 (was the homepage only): collection grids fetch their pictures ahead of the scroll too
    if (!('IntersectionObserver' in window)) return;
    function warm(sec) {
      sec.querySelectorAll('img[loading="lazy"]').forEach(function (im, i) {
        if (i > 24) return;
        im.loading = 'eager';
        im.decoding = 'async';
      });
    }
    function start() {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          warm(e.target);
        });
      }, { rootMargin: '0px 0px 250% 0px' });
      document.querySelectorAll('main .shopify-section').forEach(function (s) { io.observe(s); });
    }
    var go = function () { (window.requestIdleCallback || setTimeout)(start, { timeout: 1500 }); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }

  /* PHONE CHROME ON THE HOMEPAGE (2026-10-13, see the PHONE PASS in swb-v2.css). Two classes on <html>, phones only:
     v2-ann-away while the visitor scrolls down (the announcement bar steps aside; 126px of pinned chrome was 20% of a
     640px screen), v2-tsb-off while the picker card is in view (the Trusted Shops badge covered its pills and fields). */
  function initPhoneChrome() {
    if (!document.querySelector('.shopify-section--swb-v2-hero')) return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    var de = document.documentElement;
    var card = document.querySelector('.v2-pick--band');
    if (card && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { de.classList.toggle('v2-tsb-off', es[0].isIntersecting); }, { threshold: 0.05 }).observe(card);
    }
  }

  /* SOMETHING IS HAPPENING (2026-10-14, asked: "on mobile when I press an option the page can be slow to load and there
     is no feedback, it looks frozen"). The moment a tap will leave the page (a same-site link, the picker's button, any
     navigation the browser announces with pagehide/beforeunload), a thin bar runs along the top of the screen and the
     tapped control dims a little, until the next page paints. Nothing is shown for taps that stay on the page. */
  function initNavFeedback() {
    var de = document.documentElement, timer = 0;
    function on(el) {
      de.classList.add('v2-nav');
      if (el) el.classList.add('v2-nav__tapped');
      clearTimeout(timer);
      timer = setTimeout(off, 12000); // a navigation that never came (blocked, cancelled): the bar must not stay
    }
    function off() {
      de.classList.remove('v2-nav');
      Array.prototype.forEach.call(document.querySelectorAll('.v2-nav__tapped'), function (e) { e.classList.remove('v2-nav__tapped'); });
    }
    document.addEventListener('click', function (ev) {
      if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
      var a = ev.target.closest && ev.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href) || a.target === '_blank' || a.hasAttribute('download')) return;
      if (a.origin && a.origin !== location.origin) return;
      if (a.pathname === location.pathname && a.search === location.search && a.hash) return;
      // bubble phase: a link some script handles in place (a tab, a chip that filters without leaving) has
      // cancelled the click by now, and the tapped link is dimmed before the browser starts leaving
      on(a);
    }, false);
    window.addEventListener('beforeunload', function () { on(null); });
    window.addEventListener('pagehide', function () { on(null); });
    // back from the bfcache: the page is shown again with the bar still up
    window.addEventListener('pageshow', function (e) { if (e.persisted) off(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) setTimeout(off, 300); });
  }

  /* PICTURES FADE IN (2026-10-14, "elements pop in while you wait, give a cleaner experience", every page). A picture
     that is still loading when the script boots, or arrives later (a fetched rail), gets a short fade when it lands
     instead of popping into place. Pictures already complete at boot are left alone, so nothing that is visible ever
     blinks. The hero and the cart drawer run their own transitions. Safety: after 6 seconds everything shows. */
  function initImageFade() {
    var de = document.documentElement;
    function mark(root) {
      (root || document).querySelectorAll('main img:not(.v2-fade):not(.v2-hero *):not(cart-drawer *)').forEach(function (im) {
        if (im.complete && im.naturalWidth) return;
        im.classList.add('v2-fade');
      });
    }
    document.addEventListener('load', function (ev) {
      var t = ev.target;
      if (t && t.tagName === 'IMG' && t.classList.contains('v2-fade')) t.classList.add('is-in');
    }, true);
    document.addEventListener('error', function (ev) {
      var t = ev.target;
      if (t && t.tagName === 'IMG') t.classList.add('is-in');
    }, true);
    mark();
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { mark(); }, 120); }).observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { de.classList.add('v2-fade-off'); }, 6000);
  }

  /* FLOATING CONTROLS STEP ASIDE AT THE FOOTER (2026-10-14, "the filter button still appears above the footer"). The
     theme's filter pill watches ITS footer section, which this theme hides under the new footer, so it never got the
     signal. One observer on the new footer sets html.v2-foot-in; the CSS hides every floating filter there. */
  function initFootAware() {
    var foot = document.querySelector('.shopify-section--swb-v2-footer, .v2-foot');
    if (!foot || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      document.documentElement.classList.toggle('v2-foot-in', es[0].isIntersecting);
    }, { rootMargin: '50px 0px' }).observe(foot);
  }

  function initTilt(root) {
    if (reduceMotion) return;
    // A tilt driven by a pointer is meaningless on touch, and listening there costs scroll performance.
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    (root || document).querySelectorAll('.v2-tilt:not([data-v2-tilt])').forEach(function (el) {
      el.setAttribute('data-v2-tilt', '');
      var max = parseFloat(el.getAttribute('data-tilt-max') || '7');
      var frame = 0;

      el.addEventListener('pointermove', function (ev) {
        if (frame) return; // coalesce to one write per frame
        frame = requestAnimationFrame(function () {
          frame = 0;
          var r = el.getBoundingClientRect();
          if (!r.width || !r.height) return;
          var px = (ev.clientX - r.left) / r.width - 0.5;
          var py = (ev.clientY - r.top) / r.height - 0.5;
          el.classList.add('is-live');
          el.style.setProperty('--ry', (px * max * 2).toFixed(2) + 'deg');
          el.style.setProperty('--rx', (-py * max * 2).toFixed(2) + 'deg');
          // pointer position for the specular sheen. Same rAF write, so it costs nothing extra.
          el.style.setProperty('--mx', ((px + 0.5) * 100).toFixed(1) + '%');
          el.style.setProperty('--my', ((py + 0.5) * 100).toFixed(1) + '%');
        });
      });

      el.addEventListener('pointerleave', function () {
        if (frame) {
          cancelAnimationFrame(frame);
          frame = 0;
        }
        el.classList.remove('is-live'); // restores the slow settle transition
        el.style.setProperty('--ry', '0deg');
        el.style.setProperty('--rx', '0deg');
      });
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     2. THE PICKER
     -------------------------------------------------------------------------------------------------------------- */
  function readWatch() {
    if (LIVE_COMPAT) {
      var holder = document.querySelector('[data-v2-watch]');
      var cm = holder && holder.getAttribute('data-saved-model'), cu = holder && holder.getAttribute('data-saved-url');
      if (cm && cu) {
        try {
          var mine = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
          if (mine && mine.url === cu) return mine;
          var cw = { brand: holder.getAttribute('data-saved-brand') || '', model: cm, url: cu };
          sessionStorage.setItem(STORE_KEY, JSON.stringify(cw));
          return cw;
        } catch (e) {
          return { brand: holder.getAttribute('data-saved-brand') || '', model: cm, url: cu };
        }
      }
    }
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {
      return null; // private mode / blocked storage: the page still works, it just does not remember
    }
    /* Nothing in this tab, but the CART may still hold the choice from a previous visit: that is where the rest of
       the store keeps it and it is what the header pill is already rendered from. Without this the header named a
       watch while the rail beneath it had reverted to the generic bestsellers, on the same screen. */
    var el = document.querySelector('[data-v2-watch][data-saved-model]');
    if (el) {
      var w = {
        brand: el.getAttribute('data-saved-brand') || '',
        model: el.getAttribute('data-saved-model') || '',
        url: el.getAttribute('data-saved-url') || ''
      };
      if (w.model && w.url) {
        try {
          sessionStorage.setItem(STORE_KEY, JSON.stringify(w));
        } catch (e) {
          /* ignore */
        }
        return w;
      }
    }
    return null;
  }

  /* The rest of the store (the landing pages especially) reads the watch from CART ATTRIBUTES, which is how the
     original switch module stored it. Mirroring the choice there keeps the island pill, the hero picker and every
     page that already reads switch-module-model in agreement, instead of inventing a second source of truth.
     Fire and forget: if the cart write fails the page still works, it just does not persist across sessions.

     The BRAND is written too. The original switch module always wrote switch-module-brand, and the pages that
     match on it (reviews "use my watch", the loyalty picker, the Universal PDP) skip their preselect entirely
     without it.

     The stamp starts as whatever the server rendered into the header. Restoring a saved watch on page load
     re-writes the same record, and before this every page view POSTed /cart/update.js for nothing. Now only a
     record that really differs goes out, which on a legacy cart (model and url but no brand) is exactly one
     repair write. */
  function stampOf(b, m, u) {
    return (b || '') + '|' + (m || '') + '|' + (u || '');
  }
  var cartSyncing = (function () {
    var el = document.querySelector('[data-v2-watch]');
    if (!el) return null; // no header on this template: we cannot know what the cart holds, so write
    return stampOf(el.getAttribute('data-saved-brand'), el.getAttribute('data-saved-model'), el.getAttribute('data-saved-url'));
  })();
  function postCartAttributes(attrs) {
    try {
      // keepalive: a pick is often followed at once by a navigation, which would otherwise cancel the write
      fetch('/cart/update.js', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      })['catch'](function () {});
    } catch (e) {
      /* ignore */
    }
  }
  function syncCartAttributes(w) {
    /* A cleared watch has to be written too. Returning early here is what made Clear a no-op that undid itself on
       the next page load, because the cart is the thing readWatch() falls back to. */
    if (!w || !w.model) {
      if (cartSyncing === '||') return; // the cart holds nothing already
      cartSyncing = '||';
      postCartAttributes({ 'switch-module-brand': '', 'switch-module-model': '', 'switch-module-url': '', 'switch-module-filter': '' });
      return;
    }
    var stamp = stampOf(w.brand, w.model, w.url);
    if (stamp === cartSyncing) return; // same choice again, do not re-POST
    cartSyncing = stamp;
    postCartAttributes({
      'switch-module-brand': w.brand || '',
      'switch-module-model': w.model,
      'switch-module-url': w.url || '',
      'switch-module-filter': ''
    });
  }

  /* `quiet` marks a write that is not a fresh choice by the visitor: restoring the saved watch on page load, or
     echoing a pick the page itself just applied. It is still stored and broadcast (the pill and the rail follow),
     but window.swbV2.quiet() reports it so swb-v2-watch.js does not hand it back to the page's own
     switchModuleLandingPageSelect hook, which would re-apply, re-fetch and scroll on every page load. */
  var writingQuietly = false;
  function writeWatch(w, quiet) {
    /* t = when the visitor made this choice. The header's inline seed uses it to tell a pick from seconds ago (whose
       cart write may still be in flight) from a tab gone stale since another tab chose again. A quiet write is not
       a new choice, so it keeps the time of the one it restates. quiet === 'echo' is a real new choice that a page's
       own picker has already applied: timestamped as new, but still not handed back to the page. */
    if (w) {
      var prevT = 0;
      if (quiet === true) {
        try {
          var prev = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
          if (prev && prev.url === w.url) prevT = prev.t || 0;
        } catch (e) {
          /* ignore */
        }
      }
      w.t = quiet === true ? prevT : Date.now();
    }
    try {
      if (w) sessionStorage.setItem(STORE_KEY, JSON.stringify(w));
      else sessionStorage.removeItem(STORE_KEY);
    } catch (e) {
      /* ignore */
    }
    syncCartAttributes(w);
    /* The header's data-saved-* attributes are what readWatch() falls back to when this tab has nothing. They were
       rendered from the cart when the page loaded, so after Clear they still named the old watch and the very next
       readWatch() brought it back, into the tab and from there into the cart again. Keep them in step. */
    var holder = document.querySelector('[data-v2-watch]');
    if (holder) {
      [['data-saved-brand', w && w.brand], ['data-saved-model', w && w.model], ['data-saved-url', w && w.url]].forEach(
        function (p) {
          if (p[1]) holder.setAttribute(p[0], p[1]);
          else holder.removeAttribute(p[0]);
        }
      );
    }
    writingQuietly = !!quiet;
    try {
      document.dispatchEvent(new CustomEvent(EVENT, { detail: w || null }));
    } finally {
      writingQuietly = false;
    }
  }

  /* Put every switch module back to its opening state. setupPicker never listened for the watch event, so without
     this a cleared watch would leave the selects still showing the model that had just been thrown away. */
  function resetPickers() {
    document.querySelectorAll('[data-v2-pick]').forEach(function (form) {
      var b = form.querySelector('[data-v2-brand]');
      var m = form.querySelector('[data-v2-model]');
      var g = form.querySelector('[data-v2-go]');
      if (b) b.selectedIndex = 0;
      if (m) {
        // rebuilt rather than assigned as html, so a model name with a quote in it cannot break the option
        m.innerHTML = '';
        var o = document.createElement('option');
        o.value = '';
        o.textContent = m.getAttribute('data-placeholder') || '';
        m.appendChild(o);
        m.disabled = true;
      }
      if (g) g.disabled = true;
      form.querySelectorAll('[data-v2-quick].is-on').forEach(function (q) {
        q.classList.remove('is-on');
      });
    });
  }

  /* The button only exists to undo something, so it is not offered when there is nothing to undo. */
  /* A Clear button belongs to the picker it sits in, not to the page. Showing it on the strength of a watch stored
     in a PREVIOUS session put a "Wissen" under a picker whose own two selects were sitting empty, which reads as a
     button offering to undo something the visitor has not done. It now appears only where there is visibly
     something to clear: a model actually chosen in that picker's own controls. */
  function syncClear(w) {
    document.querySelectorAll('[data-v2-clear]').forEach(function (b) {
      var pick = b.closest ? b.closest('[data-v2-pick]') : null;
      if (pick) {
        var model = pick.querySelector('[data-v2-model]');
        b.hidden = !(model && model.value);
        return;
      }
      b.hidden = !w;
    });
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest ? ev.target.closest('[data-v2-clear]') : null;
    if (!b) return;
    ev.preventDefault();
    resetPickers();
    writeWatch(null);
  });
  document.addEventListener(EVENT, function (ev) {
    syncClear(ev.detail);
  });

  /* There are two pickers now: the hero and the one in the header island. This used to querySelector a single
     element, so whichever came second was never wired up. */
  function initPicker(root) {
    (root || document).querySelectorAll('[data-v2-pick]:not([data-v2-ready])').forEach(setupPicker);
  }

  function setupPicker(form) {
    form.setAttribute('data-v2-ready', '');

    var srcId = form.getAttribute('data-v2-source') || '';
    var dataEl = document.getElementById(srcId);
    /* "auto": a second picker on the page borrows the brand list that is already there (the hero's, else the
       header's), rather than emitting the same menu loop again. */
    if (!dataEl && srcId === 'auto') {
      dataEl = document.querySelector('script[id^="v2-brands-"]:not([id^="v2-brands-hdr-"])') || document.querySelector('script[id^="v2-brands-hdr-"]');
    }
    /* a picker whose own list is not on the page (the homepage hero, 2026-10-20 speed: it rebuilt the whole brand menu
       for 135 ms) reads the header's; that list calls the brand link "h" */
    if (!dataEl) dataEl = document.querySelector('script[id^="v2-brands-hdr-"]');
    var DATA = [];
    try {
      DATA = dataEl ? JSON.parse(dataEl.textContent) : [];
      DATA = DATA.map(function (b) { if (b && !b.u && b.h) { var c = {}; for (var k in b) c[k] = b[k]; c.u = b.h; return c; } return b; });
    } catch (e) {
      DATA = [];
    }

    /* APPLE'S OLDEST MODELS IN THE SWITCH MODULE TOO (2026-10-30, asked: "in the switch module I don't see the oudere
       modellen option for Apple Watch, don't want to miss out on revenue"). The same entry the phone menu's picker adds
       (initSheetPicker): Series 1 to 6 have no collection of their own, so one option right after Series 7 leads to the
       Apple Watch straps page. Only this picker's own copy of the list. */
    (function () {
      var lg = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
      var OLD = { nl: 'Series 1 t/m 6', de: 'Series 1 bis 6', fr: 'Series 1 à 6', es: 'Series 1 a 6' }[lg] || 'Series 1 to 6';
      DATA.forEach(function (d) {
        if (!d || !d.m || !d.m.length || !/apple/i.test(d.b) || !d.u || d.u === '#') return;
        if (d.m.some(function (m) { return /series [1-6]\b/i.test(m.t); })) return;
        var at = -1;
        d.m.forEach(function (m, j) { if (/series 7\s*$/i.test(m.t)) at = j; });
        var ref = at >= 0 ? d.m[at] : d.m[d.m.length - 1];
        d.m = d.m.slice();
        d.m.splice(at >= 0 ? at + 1 : d.m.length, 0, { t: d.b + ' ' + OLD, u: d.u, s: ref.s });
      });
    })();

    var brandSel = form.querySelector('[data-v2-brand]');
    var modelSel = form.querySelector('[data-v2-model]');
    var go = form.querySelector('[data-v2-go]');
    var quick = [].slice.call(form.querySelectorAll('[data-v2-quick]'));
    function isAccHere() { try { return !!(window.swbIsAccPage && window.swbIsAccPage()); } catch (e) { return false; } }
    /* STAY WITH THE HOUSE BRAND (2026-10-30, asked: "I went from home to Strap-it, Strap-it to collection pages, used
       the switch module, and it sent me to the new page: send them to the right collection with the same filters"). On
       a house brand's own pages (XoXo, Bandz, Strap-it, REQIOR and their material/strap collections) a chosen watch
       opens that model's collection filtered to the brand, but only when the model has products of that brand (the
       count-only ?view=mb-facets answers which vendor value and how many); otherwise, or after 1.5 s, the plain one. */
    function houseBrand() {
      var hm = location.pathname.match(/\/collections\/([^/?#]+)/);
      if (!hm || isAccHere()) return '';
      var h = hm[1];
      return /xoxo/i.test(h) ? 'xoxo' : /bandz/i.test(h) ? 'bandz' : /strap-?it/i.test(h) ? 'strap-it' : /reqior|reqoir/i.test(h) ? 'reqior' : '';
    }
    function goKeepingBrand(url, hb) {
      var base = String(url).split('?')[0], done = false;
      var leave = function (to) { if (done) return; done = true; window.location.href = to; };
      setTimeout(function () { leave(url); }, 1500);
      fetch(base + '?view=mb-facets', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var vs = (j && j.filters && j.filters['filter.p.vendor']) || [];
          var hit = vs.filter(function (v) { return String(v.v).toLowerCase().indexOf(hb) === 0 && v.c > 0; })[0];
          leave(hit ? base + '?filter.p.vendor=' + encodeURIComponent(hit.v) : url);
        })
        .catch(function () { leave(url); });
    }
    if (!brandSel || !modelSel) return;
    /* A borrowed list (the header's) is in ITS order, not the order of server-rendered options: the hero's option
       values are positions in the hero's own loop, so "Apple Watch" pointed at Samsung's models (usability audit
       2026-10-21). Rebuild the options from the payload actually used, keeping the selected brand by name. */
    var borrowed = dataEl && dataEl.id !== srcId;
    if (borrowed && brandSel.options.length > 1 && DATA.length) {
      var keep = brandSel.selectedIndex > 0 ? brandSel.options[brandSel.selectedIndex].textContent.trim().toLowerCase() : '';
      while (brandSel.options.length > 1) brandSel.remove(1);
      DATA.forEach(function (d, i) {
        var o = document.createElement('option');
        o.value = String(i);
        o.textContent = d.b;
        if (keep && String(d.b).trim().toLowerCase() === keep) o.selected = true;
        brandSel.appendChild(o);
      });
    }
    // a borrowed list arrives without server-rendered brand options; build them from the same payload
    if (brandSel.options.length <= 1 && DATA.length) {
      DATA.forEach(function (d, i) {
        var o = document.createElement('option');
        o.value = String(i);
        o.textContent = d.b;
        brandSel.appendChild(o);
      });
    }

    /* The shortcut chips are just a faster way to set the first select. They are matched by NAME against the payload
       rather than by index, because the chip list is authored in the editor and the payload order comes from the
       link lists; an index would silently point at the wrong brand the moment either changes. */
    function pickBrandByName(name) {
      var want = String(name || '').toLowerCase().trim();
      for (var i = 0; i < DATA.length; i++) {
        if (String(DATA[i].b).toLowerCase().trim() === want) return i;
      }
      return -1;
    }
    quick.forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var idx = pickBrandByName(btn.getAttribute('data-v2-quick'));
        if (idx < 0) return;
        brandSel.value = String(idx);
        fillModels(idx, null);
        quick.forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
        });
        sync();
        try {
          modelSel.focus();
        } catch (e) {
          /* ignore */
        }
      });
    });

    /* The group each model is shown under. Normally the brand menu's own series. When the menu gives a brand one
       catch-all group (Apple: every model under "Series"), the family comes from the model name instead, trailing
       number removed: Apple Watch Series 12 -> "Apple Watch Series", Ultra 4 -> "Apple Watch Ultra", SE stays SE. */
    function seriesOf(list) {
      var names = {};
      list.forEach(function (m) { if (m.s) names[m.s] = 1; });
      var one = Object.keys(names).length === 1 && list.length > 4;
      return list.map(function (m) {
        if (!one) return m.s || '';
        return String(m.t || '').replace(/\s+\d+(\s.*)?$/, '').trim();
      });
    }
    window.swbV2SeriesOf = seriesOf;
    function fillModels(brandIdx, preselectUrl) {
      var brand = DATA[brandIdx];
      modelSel.innerHTML = '';
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = modelSel.getAttribute('data-placeholder') || 'Model';
      modelSel.appendChild(ph);

      if (!brand) {
        modelSel.disabled = true;
        return;
      }
      /* SERIES AS HEADINGS (asked 2026-09-30): models that belong to a series in the brand menu are grouped under it
         in an <optgroup>, which every browser draws as a bold, unselectable label with its options indented below.
         Models the menu lists on their own stay plain options. `s` comes from the menu's group item. */
      var grp = null, grpName = null;
      var fams = seriesOf(brand.m);
      brand.m.forEach(function (m, mi) {
        m = { t: m.t, u: m.u, s: fams[mi] };
        var o = document.createElement('option');
        o.value = m.u;
        o.textContent = m.t;
        if (preselectUrl && m.u === preselectUrl) o.selected = true;
        if (m.s) {
          if (m.s !== grpName) {
            grp = document.createElement('optgroup');
            grp.label = m.s;
            grpName = m.s;
            modelSel.appendChild(grp);
          }
          grp.appendChild(o);
        } else {
          grp = null;
          grpName = null;
          modelSel.appendChild(o);
        }
      });
      modelSel.disabled = false;
    }

    brandSel.addEventListener('change', function () {
      fillModels(brandSel.value === '' ? -1 : parseInt(brandSel.value, 10), null);
      sync();
    });
    modelSel.addEventListener('change', sync);
    // a watch chosen in ANOTHER picker moves this one's selects; its brand tiles must follow too (2026-10-06)
    document.addEventListener(EVENT, function () {
      setTimeout(function () {
        if (!quick.length) return;
        var qn2 = DATA[parseInt(brandSel.value, 10)] ? String(DATA[parseInt(brandSel.value, 10)].b).toLowerCase().trim() : '';
        quick.forEach(function (b) {
          b.classList.toggle('is-on', !!qn2 && String(b.getAttribute('data-v2-quick')).toLowerCase().trim() === qn2);
        });
      }, 0);
    });

    // `quiet === true` only from the restore below; as a change listener this receives the Event
    function sync(quiet) {
      // the logo tile for the chosen brand lights up however the brand was chosen (tile, dropdown or saved watch)
      if (quick.length) {
        var qn = DATA[parseInt(brandSel.value, 10)] ? String(DATA[parseInt(brandSel.value, 10)].b).toLowerCase().trim() : '';
        quick.forEach(function (b) {
          b.classList.toggle('is-on', !!qn && String(b.getAttribute('data-v2-quick')).toLowerCase().trim() === qn);
        });
      }
      var bi = brandSel.value === '' ? -1 : parseInt(brandSel.value, 10);
      var brand = DATA[bi];
      var url = modelSel.value;
      // "#" is what Shopify returns for a menu entry with no link; never persist a watch that points nowhere
      if (url === '#') url = '';
      /* BRAND WITHOUT A MODEL (2026-10-13, tracker: 1,345 homepage sessions used the old selector's brand-level
         "show all" link; two thirds of phone visitors never scroll past the first quarter). A brand alone now
         makes the button live too, pointing at the brand's own collection ("Alle Garmin bandjes"); a model
         narrows it back to the model's collection with the button's original label. */
      var burl = brand && brand.u && brand.u !== '#' ? brand.u : '';
      if (go) {
        if (!go.getAttribute('data-v2-label')) go.setAttribute('data-v2-label', go.innerHTML);
        go.disabled = !url && !burl;
        /* ON AN ACCESSORY PAGE (2026-10-29, owner: "when I press different model the pop up says bekijk bandjes instead
           of accessories"): the button is worded for accessories, and a brand alone filters THIS page to that brand
           instead of leaving for the brand's straps. A model already re-filters the page through the watch event. */
        var acc = isAccHere();
        var L2 = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
        var accBrandUrl = acc && brand ? location.pathname + '?filter.p.m.custom.brand_collection_filter=' + encodeURIComponent(brand.b) : '';
        go.setAttribute('data-v2-brand-url', !url && burl ? (acc ? accBrandUrl : burl) : '');
        go.setAttribute('data-v2-brand-name', !url && burl ? brand.b : '');
        var lbl = go.querySelector('[data-v2-go-label]');
        if (!url && burl) {
          var T2 = acc
            ? { nl: 'Alle %b accessoires', de: 'Alles %b Zubehör', fr: 'Tous les accessoires %b', es: 'Todos los accesorios %b', en: 'All %b accessories' }
            : { nl: 'Alle %b bandjes', de: 'Alle %b Armbänder', fr: 'Tous les bracelets %b', es: 'Todas las correas %b', en: 'All %b straps' };
          var txt = (T2[L2] || T2.en).replace('%b', brand.b);
          if (lbl) lbl.textContent = txt; else go.textContent = txt;
        } else if (acc) {
          var T3 = { nl: 'Bekijk accessoires', de: 'Zubehör ansehen', fr: 'Voir les accessoires', es: 'Ver accesorios', en: 'View accessories' };
          if (lbl) lbl.textContent = T3[L2] || T3.en; else go.textContent = T3[L2] || T3.en;
        } else if (go.getAttribute('data-v2-label')) {
          go.innerHTML = go.getAttribute('data-v2-label');
        }
      }
      if (!brand || !url) return;
      var opt = modelSel.options[modelSel.selectedIndex];
      writeWatch({ brand: brand.b, model: opt ? opt.textContent : '', url: url }, quiet === true);
    }

    if (go) {
      go.addEventListener('click', function (ev) {
        if (!modelSel.value) {
          ev.preventDefault();
          var bu = go.getAttribute('data-v2-brand-url');
          if (bu) { go.classList.add('v2-nav__tapped'); var hb1 = houseBrand(); if (hb1) goKeepingBrand(bu, hb1); else window.location.href = bu; }
          return;
        }
        /* Choosing a model already re-fetched the bestsellers rail for that watch: `sync()` writes the watch and
           initRail reloads on the event, measured at roughly 0.8s. Navigating away at this point threw that work
           out and left the visitor on a bare collection page, which is why it looked as though the page never
           responded to the picker at all.

           So when the rail is on this page, the button now takes them TO it rather than off the page. The rail's
           own "view all" link is still the way to the full collection. Anywhere the rail does not exist (the
           picker also lives in the header on every other template) the old navigation is exactly right. */
        /* 2026-10-02 (asked): every picker goes to the model's collection page, the hero one too. Scrolling to the
           rail read as the button not doing what it says. The rail still updates in the background for when the
           visitor comes back. */
        ev.preventDefault();
        go.classList.add('v2-nav__tapped');
        if (isAccHere()) {
          var bi2 = brandSel.value === '' ? -1 : parseInt(brandSel.value, 10), o2 = modelSel.options[modelSel.selectedIndex];
          if (DATA[bi2]) { writeWatch({ brand: DATA[bi2].b, model: o2 ? o2.textContent : '', url: modelSel.value }); return; }
        }
        var hb0 = houseBrand();
        if (hb0) { goKeepingBrand(modelSel.value, hb0); return; }
        window.location.href = modelSel.value;
      });
    }

    /* RESTORE A PREVIOUS CHOICE
       Matched on the model URL, not on the brand name. The brand name works only for a choice made in this tab;
       when the watch is recovered from the CART instead - which is every page load after a previous visit, and the
       same record the header pill is already rendered from - readWatch has no brand to give and returns an empty
       string. Nothing matched it, so the header named a model while the picker underneath sat completely empty.
       That is what was happening on the sale page.

       The URL is unique to a model, so scanning for it always finds the right brand. sync() afterwards enables the
       button and rewrites the record with the brand filled in, so the gap repairs itself on first load. */
    function selectSaved(saved) {
      if (!saved || !saved.url) return false;
      /* URL first, brand only as a fallback. Brand-first looked cheaper but is wrong: a record whose brand matches
         while its url does not - a menu that has since been reorganised, a model retired - selected the brand and
         then left the model list on its placeholder. Finding the model is the point; the brand is just where it
         happens to live. */
      var found = -1;
      for (var bi2 = 0; bi2 < DATA.length && found < 0; bi2++) {
        var dm = DATA[bi2].m || []; // a brand without a model list must never stop the page's script (2026-10-23)
        for (var mi = 0; mi < dm.length; mi++) {
          if (dm[mi].u === saved.url) {
            found = bi2;
            break;
          }
        }
      }
      for (var i = 0; i < DATA.length && found < 0; i++) {
        if (saved.brand && DATA[i].b === saved.brand) found = i;
      }
      if (found < 0) return false;
      brandSel.value = String(found);
      fillModels(found, saved.url);
      if (go) go.disabled = !modelSel.value;
      return true;
    }
    if (selectSaved(readWatch())) sync(true);

    /* Follow a watch chosen anywhere else on the page (the other picker, the sheet, a landing page's own picker).
       Without this the popover still offered the previous model under a pill that already named the new one.
       Selection only: sync() is not called, the record has already been written by whoever chose it. */
    document.addEventListener(EVENT, function (ev) {
      var d = ev.detail;
      if (d && d.url && d.url !== modelSel.value) selectSaved(d);
    });
    if (!modelSel.options.length) fillModels(-1, null);
    if (go) go.disabled = !modelSel.value;
  }

  /* --------------------------------------------------------------------------------------------------------------
     3. THE RAIL
     Fetches ?view=newrow, which returns bare product cards with no layout. Two traps this guards:
       - a MISSING alternate template is not a 404: Shopify serves the whole collection page with a 200, so a
         response containing "<html" means "that template is not on this theme" and must be discarded.
       - the fragment is HTML from our own storefront; it is injected with innerHTML deliberately, and the URL is
         always built from a collection path we control plus a fixed view/sort, never from user input.
     -------------------------------------------------------------------------------------------------------------- */
  /* What a product card in these rows is actually asked to fill. The theme builds each card's `sizes` from
     main-collection's section settings, which do not exist in a layout-less collection view or inside our own
     sections, so it arrives malformed ("calc(100vw /  - 40px)"). A browser throws an invalid `sizes` away and falls
     back to 100vw, which pulls a full width image into a 260px slot. */
  var GRID_SIZES = '(max-width: 699px) 44vw, (max-width: 999px) 30vw, 260px';

  function repairSizes(scope) {
    if (!scope) return;
    var imgs = scope.querySelectorAll ? scope.querySelectorAll('img[sizes]') : [];
    [].forEach.call(imgs, function (im) {
      // the tell-tale of the empty setting: a division with nothing on the right of it
      if ((im.getAttribute('sizes') || '').indexOf('/  ') > -1) {
        im.setAttribute('sizes', GRID_SIZES);
      }
    });
  }

  /* "Popular for your Apple Watch Apple Watch Series 10". The rail was fed brand + model, but a model string often
     already carries its brand ("Apple Watch Series 10") while others do not ("Galaxy Watch 7 44mm" under Samsung).
     Prefix only when the model does not already begin with the brand. */
  function watchLabel(w) {
    if (!w) return '';
    var b = (w.brand || '').trim();
    var m = (w.model || '').trim();
    if (!m) return b;
    if (b && m.toLowerCase().indexOf(b.toLowerCase()) === 0) return m;
    return b ? b + ' ' + m : m;
  }

  /* The band heading is the page's confirmation that the store understood which watch this is. Before a choice it
     asks; after one it reports, with the model as the emphasised part. Driven by the same watch event every other
     switch module listens to, so it can never disagree with the pill in the island.

     boot() runs again for every section the theme editor re-renders, so the document level listener is registered
     once and only the repaint is repeated. Without that guard each re-render would stack another listener. */
  var pickBandBound = false;
  function initPickBand() {
    var h = document.querySelector('[data-v2-pickband-h]');
    if (!h) return;
    var ask = h.getAttribute('data-empty') || '';
    var say = h.getAttribute('data-set') || '';

    function paint(w) {
      if (w && w.model) {
        h.textContent = say + ' ';
        var b = document.createElement('b');
        b.textContent = w.model; // textContent, so a model name can never inject markup
        h.appendChild(b);
      } else {
        h.textContent = ask;
      }
    }

    if (!pickBandBound) {
      pickBandBound = true;
      document.addEventListener(EVENT, function (ev) {
        var el = document.querySelector('[data-v2-pickband-h]');
        if (el) paint(ev.detail);
      });
    }
    paint(readWatch());
  }

  function initRail(root) {
    window.v2RailBoot = 1; // the section's parse-time safety net stands down: the reveal is ours from here
    (root || document).querySelectorAll('[data-v2-rail]:not([data-v2-ready])').forEach(function (rail) {
      rail.setAttribute('data-v2-ready', '');
      var slot = rail.querySelector('[data-v2-rail-slot]');
      if (slot) setTimeout(function () {
        // a fetch that hangs must not hold the skeleton: after 6s the row shows whatever it has
        if (slot.hasAttribute('data-v2-pending')) { slot.removeAttribute('data-v2-pending'); slot.classList.add('v2-rail-in'); }
      }, 6000);
      var titleEl = rail.querySelector('[data-v2-rail-title]');
      var titleTpl = titleEl ? titleEl.getAttribute('data-template') || '' : '';
      var baseTitle = titleEl ? (titleEl.getAttribute('data-base') || titleEl.textContent) : ''; /* data-base: the plain title when the server already put the watch in it */
      var fallback = rail.getAttribute('data-fallback') || '';
      var sort = rail.getAttribute('data-sort') || '';
      var limit = parseInt(rail.getAttribute('data-limit') || '0', 10);
      var reveal = rail.hasAttribute('data-reveal');
      var allEl = rail.querySelector('[data-v2-rail-all]');
      var token = 0;
      /* the row is finished: the cards are the final ones and, where the lead turns into a lifestyle tile, that
         tile has its photograph (or has given up on one). Only then does the skeleton hand over, in one fade. */
      function ready() {
        if (!slot || !slot.hasAttribute('data-v2-pending')) return;
        var t0 = Date.now();
        (function wait() {
          var lead = slot.hasAttribute('data-v2-life-lead') ? slot.querySelector('.nr-i') : null;
          /* ...and its lifestyle photo has been looked up and decoded, or ruled out (2026-10-29, asked: "the first row
             flickers"): the row was shown with the packshot and the lead card turned into the photo tile 0.1-0.6s later */
          var settled = !lead || (lead.classList.contains('is-settled') && (!lead.hasAttribute('data-v2-vibe') || lead.hasAttribute('data-v2-vibe-done')));
          if (!settled && Date.now() - t0 < 1800) return setTimeout(wait, 60);
          var img = lead && lead.classList.contains('is-life') ? lead.querySelector('img') : null;
          var go = function () {
            if (!slot.hasAttribute('data-v2-pending')) return;
            slot.removeAttribute('data-v2-pending');
            slot.classList.add('v2-rail-in');
            /* ONE ENTRANCE (2026-10-29, asked: flicker). While the scroll scene plays it holds this fade back
               (animation: none !important); when the scene steps away 2.6s later the held-back fade ran after all and
               every card faded in a second time. The class goes once its own fade would be over, so nothing is left
               to replay. */
            setTimeout(function () { slot.classList.remove('v2-rail-in'); }, 900);
          };
          if (img && img.decode && !img.complete) img.decode().then(go, go);
          else go();
          setTimeout(go, 1200);
        })();
      }

      function load(collectionUrl, label) {
        if (!slot || !collectionUrl) return;
        var mine = ++token;
        var url = collectionUrl.split('?')[0].replace(/\/$/, '');
        url += '?view=newrow' + (sort ? '&sort_by=' + encodeURIComponent(sort) : '');

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) {
            return r.ok ? r.text() : '';
          })
          .then(function (html) {
            if (mine !== token) return; // a newer choice already won
            if (!html || html.indexOf('<html') > -1) return ready(); // template absent on this theme -> keep what is shown
            if (html.replace(/\s/g, '') === '') return ready(); // empty collection renders nothing
            if (limit > 0) {
              var tpl = document.createElement('template');
              tpl.innerHTML = html;
              var cards = tpl.content.querySelectorAll('.nr-i');
              // unfamiliar markup: keep whatever is already on screen rather than emptying the band
              if (!cards.length) return ready();

              repairSizes(tpl.content);

              slot.innerHTML = '';
              // styles the fetched row carries outside its cards (grid gap, card layout) come along; keeping only the
              // cards left a reloaded row with no spacing between them
              [].forEach.call(tpl.content.querySelectorAll('style'), function (st) { if (!st.closest('.nr-i')) slot.appendChild(st); });
              /* VARIETY FIRST. Best-selling order put one Milanese band first in four colours for an Apple Watch
                 (it is the top seller), which read as a broken row. One card per design leads (the title without its
                 colour in brackets), and the other colours of those designs follow after. */
              var seenStem = {}, lead = [], rest = [];
              [].forEach.call(cards, function (cd) {
                var tt = cd.querySelector('.product-card__title');
                var stem = tt ? tt.textContent.split('(')[0].replace(/\s+/g, ' ').trim().toLowerCase() : Math.random();
                (seenStem[stem] ? rest : lead).push(cd);
                seenStem[stem] = 1;
              });
              var ordered = lead.concat(rest);
              for (var c = 0; c < ordered.length && c < limit; c++) slot.appendChild(ordered[c]);
              dedupeStyles(slot);
            } else {
              var tplAll = document.createElement('template');
              tplAll.innerHTML = html;
              slot.innerHTML = '';
              slot.appendChild(tplAll.content);
              dedupeStyles(slot);
              repairSizes(slot);
              // the same variety-first order when the whole row is used (see above)
              var seen2 = {}, lead2 = [], rest2 = [];
              [].forEach.call(slot.querySelectorAll('.nr-i'), function (cd) {
                var tt = cd.querySelector('.product-card__title');
                var stem = tt ? tt.textContent.split('(')[0].replace(/\s+/g, ' ').trim().toLowerCase() : Math.random();
                (seen2[stem] ? rest2 : lead2).push(cd);
                seen2[stem] = 1;
              });
              var par = (lead2[0] || {}).parentNode;
              if (par) lead2.concat(rest2).forEach(function (cd) { par.appendChild(cd); });
            }
            if (allEl) {
              allEl.setAttribute('href', url.split('?')[0] + (sort ? '?sort_by=' + encodeURIComponent(sort) : ''));
            }
            if (reveal) rail.hidden = false;

            if (titleEl && titleTpl && label) titleEl.textContent = titleTpl.replace('%s', label);
            else if (titleEl && !label) titleEl.textContent = baseTitle;
            initReveal(slot);
            initLife(slot);
            // the .scroll-area that the arrows drive was just destroyed and rebuilt
            initCarousel(rail.closest('[data-v2-carousel]') || rail);
            ready();
          })
          .catch(function () {
            /* leave the server-rendered fallback in place */
            ready();
          });
      }

      // the server rendered cards carry the same malformed sizes, and they are the first paint
      repairSizes(slot);

      var w = readWatch();
      /* the server already rendered this watch's best sellers (sections/swb-home-v2-rail.liquid, swb_cache): finish the
         row as a fetch would, without the fetch (2026-10-17) */
      var pre = rail.getAttribute('data-v2-prefilled-for');
      var wPath = w && w.url ? String(w.url).split('?')[0].replace(/\/$/, '').replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/collections\/)/i, '') : '';
      if (pre && wPath === pre && slot) {
        token++;
        if (reveal) rail.hidden = false;
        initReveal(slot);
        initLife(slot);
        initCarousel(rail.closest('[data-v2-carousel]') || rail);
        ready();
      } else if (w && w.url) load(w.url, watchLabel(w));
      else if (fallback) load(fallback, '');
      else ready();

      document.addEventListener(EVENT, function (ev) {
        var d = ev.detail;
        if (d && d.url) load(d.url, watchLabel(d));
        else if (fallback) load(fallback, '');
      });
    });
  }


  /* --------------------------------------------------------------------------------------------------------------
     4. CAROUSEL ARROWS
     The product rows are a native horizontal scroller, which is right on touch but leaves a mouse user with no
     affordance at all: horizontal scrolling needs shift+wheel and nothing on screen says the row continues.

     The scroller is NOT a fixed element. initRail replaces the slot's innerHTML on every watch change, so the
     .scroll-area that exists now is not the one that will exist later. Everything below therefore looks the
     scroller up at the moment it is needed, and the scroll listener is bound in the CAPTURE phase on the stable
     wrapper: scroll events do not bubble, but they do run through capture, so one listener survives every swap.
     -------------------------------------------------------------------------------------------------------------- */
  function scrollerOf(car) {
    return car.querySelector('.scroll-area') || car.querySelector('[data-v2-carousel-view]');
  }

  /* --------------------------------------------------------------------------------------------------------------
     4c. THE LEAD CARD'S LIFESTYLE PHOTO
     The wrapper carries the fourth image's URLs; the card inside it belongs to the theme and is not ours to edit, so
     the swap happens here. One extra request, on one card, and only where the section setting asked for it.
     -------------------------------------------------------------------------------------------------------------- */
  function initLife(root) {
    if (!document.documentElement.classList.contains('v2-cardlook')) return; // live cards 1:1: no lifestyle lead card (2026-10-15)
    /* NO GUESSED LIFESTYLE PHOTO (2026-10-15, asked: "no images with text should appear there"). Both routes took the
       product's FOURTH photo and assumed it was a lifestyle shot; on many products it is an infographic with text
       (Mi Band 5: "applicable to Xiaomi 5th generation"). The lead card stays the packshot card every other card is. */
    (root || document).querySelectorAll('[data-v2-life], [data-v2-life-lead] .nr-i').forEach(function (c) {
      c.classList.add('is-settled');
      /* the row's cards are 3/4 of a phone wide but ship the grid's "44vw" sizes, so the browser picked a 171px file for a
         294px card (measured 2026-10-15): tell it the real width so the srcset gives a sharp one */
      c.querySelectorAll('img[sizes]').forEach(function (i) { i.setAttribute('sizes', '(max-width: 699px) 76vw, (max-width: 999px) 40vw, 300px'); });
    });
    /* THE VIBE PHOTO ON THE LEAD CARD, WHOLE AND NEVER AN INFOGRAPHIC (2026-10-15, asked: "the first product is not the
       full image of the vibe image" and earlier "no images with text"): only a photo the product itself marks as
       lifestyle (alt or file name says lifestyle, or the design team's D- prefix), at least 800px wide, shown whole in
       the full-card editorial tile (.nr-i.is-life); the packshot stays as the second photo. Nothing is guessed from a position. */
    var vscope = root || document;
    var vrows = [].slice.call(vscope.querySelectorAll('[data-v2-life-lead]'));
    if (vscope.nodeType === 1 && vscope.matches && vscope.matches('[data-v2-life-lead]')) vrows.unshift(vscope);
    vrows.forEach(function (row) {
      var card = row.querySelector('.nr-i');
      if (!card || card.hasAttribute('data-v2-vibe')) return;
      card.setAttribute('data-v2-vibe', '');
      var pc = card.querySelector('product-card[handle]');
      var handle = pc && pc.getAttribute('handle');
      if (!handle) { var a = card.querySelector('a[href*="/products/"]'); if (a) handle = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#]/)[0]; }
      var done = function () { card.setAttribute('data-v2-vibe-done', ''); };
      if (!handle) return done();
      fetch('/products/' + handle + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.media || row.querySelector('.nr-i') !== card) return done();
          var life = p.media.filter(function (m) {
            if (m.media_type !== 'image') return false;
            var alt = m.alt || '', file = (m.src || '').split('/').pop();
            if (/notext|infograph|icon|feature|^f\d*-/i.test(file) && !/lifestyle/i.test(alt + ' ' + file)) return false;
            return /lifestyle/i.test(alt + ' ' + file) || /^d\d*-/i.test(file);
          })[0];
          if (!life || (life.width || 0) < 800) return done();
          var img = card.querySelector('.product-card__image--primary') || card.querySelector('img');
          if (!img) return done();
          var base = life.src.split('?')[0], ver = (life.src.split('?')[1] || '').replace(/&.*$/, ''), q = ver ? '?' + ver + '&width=' : '?width=';
          var set = [400, 600, 800, 1000, 1200].map(function (w) { return base + q + w + ' ' + w + 'w'; }).join(', ');
          /* the editorial lead tile: the photo fills the whole card (2026-10-15, asked: "the size of the full card") */
          var sizes = '(max-width: 749px) 92vw, 560px';
          /* DOWNLOAD FIRST, THEN SWAP (2026-10-22, asked: "first product card was missing"). The tile used to turn into
             the photo tile at once, hiding the packshot card, while the photo was still on its way: an empty first slot
             until it landed, for good if it failed. The packshot card now stays until the photo is decoded. */
          var pre = new Image();
          pre.sizes = sizes;
          pre.srcset = set;
          pre.src = base + q + '800';
          var swap = function () {
            done();
            if (row.querySelector('.nr-i') !== card || !pre.naturalWidth) return;
            img.removeAttribute('loading');
            img.setAttribute('sizes', sizes);
            img.setAttribute('srcset', set);
            img.setAttribute('src', pre.currentSrc || pre.src);
            card.classList.add('is-life');
            card.classList.add('is-vibe');
          };
          (pre.decode ? pre.decode() : new Promise(function (ok, no) { pre.onload = ok; pre.onerror = no; })).then(swap, done);
        })
        .catch(done);
    });
    return;
    (root || document).querySelectorAll('[data-v2-life]:not([data-v2-life-done])').forEach(function (w) {
      w.setAttribute('data-v2-life-done', '');
      var img = w.querySelector('.product-card__image--primary') || w.querySelector('img');
      if (!img) {
        w.classList.add('is-settled');
        return;
      }
      var set = w.getAttribute('data-v2-life-set');
      if (set) img.setAttribute('srcset', set);
      /* The theme ships a MALFORMED sizes attribute on these cards - "calc(100vw / - 40px)", with the column count
         missing - and a browser that cannot parse sizes falls back to 100vw, then picks the smallest candidate that
         satisfies it. Measured: a 260x260 source stretched into a 260x406 box, which is why the tile looked soft
         and not full rather than cropped. An explicit sizes fixes the candidate choice. */
      /* Sized off the card's HEIGHT, not its width. The source is square and object-fit is cover, so a 260x406 box
         needs a source at least 406 across before it stops upscaling - and twice that on a 2x screen. Asking for the
         card's width picked a 360px file and the tile came out soft. This is one card, so the extra bytes buy the
         sharpness of the one image the row leads with. */
      img.setAttribute('sizes', '(max-width: 749px) 92vw, 560px');
      img.setAttribute('src', w.getAttribute('data-v2-life'));
      /* Only now does the card become an editorial tile. The class is added on the SWAP, never before, so a product
         with no lifestyle shot is left as the ordinary packshot card it always was. */
      w.classList.add('is-life');
      w.classList.add('is-settled');
      /* The theme's card fades a second image in on hover. That one is still the packshot, which is exactly the
         comparison shot someone hovering wants, so it is deliberately left alone. */
    });

    /* The best sellers row is re-fetched through the theme's own ?view=newrow template, because best-selling order
       is something Liquid cannot produce and only a real collection request can. That fragment carries no attribute
       of ours, so for those rows the fourth image is looked up instead: 3KB gzipped, once, for the lead card. */
    var scope = root || document;
    /* initLife is called with the rail's SLOT as its root after a re-fetch, and the slot is itself the flagged
       element. querySelectorAll never matches its own root, so the scope has to be added by hand or the one call
       that matters finds nothing. */
    var rows = [].slice.call(scope.querySelectorAll('[data-v2-life-lead]'));
    if (scope.nodeType === 1 && scope.matches('[data-v2-life-lead]')) rows.unshift(scope);
    rows.forEach(function (row) {
      var card = row.querySelector('.nr-i');
      if (!card || card.hasAttribute('data-v2-life-done') || card.hasAttribute('data-v2-life')) return;
      var pc = card.querySelector('product-card[handle]');
      var handle = pc && pc.getAttribute('handle');
      if (!handle) {
        var a = card.querySelector('a[href*="/products/"]');
        if (a) handle = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#]/)[0];
      }
      if (!handle) {
        card.classList.add('is-settled');
        return;
      }
      card.setAttribute('data-v2-life-done', '');
      fetch('/products/' + handle + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (p) {
          /* Whatever happens from here - no media, no fourth image, a row that has been swapped out from under us,
             a dead network - the card has to end up visible. `settle` is the single exit, so there is no path that
             leaves it faded out. */
          function settle() {
            card.classList.add('is-settled');
          }
          if (!p || !p.media) return settle();
          var imgs = p.media.filter(function (m) {
            return m.media_type === 'image';
          });
          var life = imgs[3];
          if (!life || !life.src) return settle();
          // still the lead card of the row we started from? the visitor may have picked a watch since
          if (row.querySelector('.nr-i') !== card) return settle();
          var img = card.querySelector('.product-card__image--primary') || card.querySelector('img');
          if (!img) return settle();
          var base = life.src.split('?')[0];
          var ver = (life.src.split('?')[1] || '').replace(/&.*$/, '');
          var q = ver ? '?' + ver + '&width=' : '?width=';
          img.setAttribute(
            'srcset',
            [400, 600, 800, 1000, 1200]
              .map(function (w) {
                return base + q + w + ' ' + w + 'w';
              })
              .join(', ')
          );
          img.setAttribute('sizes', '(max-width: 749px) 92vw, 560px');
          img.setAttribute('src', base + q + '800');
          card.classList.add('is-life');
          settle();
        })
        .catch(function () {
          card.classList.add('is-settled');
          /* the packshot is a perfectly good card */
        });
    });
  }

  function initCarousel(root) {
    (root || document).querySelectorAll('[data-v2-carousel]').forEach(function (car) {
      var prev = car.querySelector('[data-v2-carousel-prev]');
      var next = car.querySelector('[data-v2-carousel-next]');
      if (!prev || !next) return;

      function sync() {
        var sc = scrollerOf(car);
        if (!sc) {
          car.removeAttribute('data-can-scroll');
          return;
        }
        car.v2Sc = sc;
        var max = sc.scrollWidth - sc.clientWidth;
        if (max <= 4) {
          // everything already fits: hide the arrows rather than show two dead buttons
          car.removeAttribute('data-can-scroll');
          return;
        }
        car.setAttribute('data-can-scroll', '');
        prev.disabled = sc.scrollLeft <= 2;
        next.disabled = sc.scrollLeft >= max - 2;

        /* Optional: a scrollbar the visitor can actually read. The thumb's width is the share of the row that is on
           screen, and its offset is how far along they are, so a short row shows a long thumb and vice versa. */
        var prog = car.querySelector('[data-v2-carousel-progress] > i');
        if (prog) {
          var frac = sc.clientWidth / sc.scrollWidth;
          prog.style.width = (frac * 100).toFixed(2) + '%';
          prog.style.transform = 'translateX(' + ((sc.scrollLeft / sc.scrollWidth) / frac * 100).toFixed(2) + '%)';
        }
      }

      if (!car.hasAttribute('data-v2-car-ready')) {
        car.setAttribute('data-v2-car-ready', '');

        var step = function (dir) {
          var sc = scrollerOf(car);
          if (!sc) return;
          var card = sc.querySelector('.nr-i') || sc.firstElementChild;
          var w = card ? card.getBoundingClientRect().width : 260;
          var stride = w + 16;
          // move by whole cards, never a partial one, and never less than one
          var page = Math.max(1, Math.floor(sc.clientWidth / stride)) * stride;
          sc.scrollBy({ left: dir * page, behavior: 'smooth' });
        };

        prev.addEventListener('click', function () {
          step(-1);
        });
        next.addEventListener('click', function () {
          step(1);
        });
        /* once a frame, not once per scroll event: a flick fires dozens of events and each sync reads layout */
        var syncQueued = false;
        car.addEventListener('scroll', function () {
          if (syncQueued) return;
          syncQueued = true;
          requestAnimationFrame(function () { syncQueued = false; sync(); });
        }, { capture: true, passive: true });
        window.addEventListener('resize', sync);
        car.v2Sync = sync;
      }

      carQueue(car);
    });
  }

  /* CAROUSELS ARE MEASURED TOGETHER, ONCE A FRAME
     Each carousel used to measure itself on the spot and again on two timers (400ms, 1.5s) in case images changed
     its width. With six rows that was read, write, read, write: every read after a write forces the whole page to lay
     out again, 590ms on a 4x slowed phone. Now every carousel that needs a look is collected and handled in one
     animation frame, and a ResizeObserver on the track replaces the guessing timers: it fires exactly when images or
     a refetch actually change the row, and never otherwise. */
  var carPending = [];
  var carRO = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (e) {
          var car = e.target.closest ? e.target.closest('[data-v2-carousel]') : null;
          if (car) carQueue(car);
        });
      })
    : null;
  function carQueue(car) {
    if (carPending.indexOf(car) < 0) carPending.push(car);
    if (carPending.length > 1) return;
    requestAnimationFrame(function () {
      var list = carPending;
      carPending = [];
      list.forEach(function (c) {
        if (c.v2Sync) c.v2Sync();
        if (carRO && c.v2Sc && !c.v2Observed) {
          c.v2Observed = true;
          carRO.observe(c.v2Sc);
          if (c.v2Sc.firstElementChild) carRO.observe(c.v2Sc.firstElementChild);
        }
      });
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     5. THE MATERIAL STAGE
     Rows are real links, so this only decides which photo is showing. With a pointer that is whatever you are
     hovering; without one it is whichever row is nearest the middle of the screen, which keeps the panel alive on a
     phone WITHOUT intercepting taps (a tab-style widget there would swallow the first tap on every row).
     -------------------------------------------------------------------------------------------------------------- */
  function initStage(root) {
    (root || document).querySelectorAll('[data-v2-stage]:not([data-v2-stage-ready])').forEach(function (st) {
      st.setAttribute('data-v2-stage-ready', '');
      var slides = st.querySelectorAll('[data-v2-slide]');
      var rows = st.querySelectorAll('[data-v2-row]');
      if (!slides.length || !rows.length) return;
      var cur = 0;

      /* Six material clips on one page would all stream at once if they were left to autoplay, and five of them sit
         at opacity 0. They are rendered paused with no preload; only the slide on screen is told to load and play. */
      var vids = [].slice.call(st.querySelectorAll('.v2-stage__vid'));
      vids.forEach(function (v) {
        v.muted = true;
        v.loop = true;
        v.setAttribute('playsinline', '');
        v.preload = 'none';
      });

      /* MEASURED: 46 MB of video on one phone load.
         The section was built so only the slide on screen ever downloads, and that held while the stage was
         manually driven. Making it auto-advance broke it: the story walks all six slides in ~25 seconds and
         playOnly() promotes each one it reaches to preload="auto", so sitting on the section pulled roughly 9 MB
         per clip, six times over, on a page whose audience is 70% mobile.

         So the story runs on the posters Shopify already generates for every clip, and a slide only fetches its
         video once the visitor has actually chosen a material. Auto-advance costs nothing; a deliberate tap still
         gets the film. */
      /* desktop plays the (now 1 MB) clips as the story runs; phones still wait for a tap (2026-10-21) */
      var userPicked = window.matchMedia('(pointer: fine) and (min-width: 990px)').matches;

      /* WHO GETS THE FILM WITHOUT ASKING
         There is exactly one rendition of each clip on this store: Shopify's HD-1080p 7.2Mbps, about 9MB. No lighter
         source exists to fall back to, so this cannot be solved by picking a smaller file.

         What it can be solved by is deciding who pays. A pointer device on a non-metered connection plays the slide
         it is on, which is the whole point of a section built as a story; with preload="none" and a 4.2s dwell the
         browser fetches roughly what it actually plays rather than the whole 9MB, so a full cycle is a few tens of
         megabytes on a desktop connection. A phone keeps the poster until somebody taps a material, because 70% of
         this page's traffic is mobile and that is where the 46MB measurement came from in the first place. */
      /* MEASURED, AND THEN MEASURED AGAIN
         Letting the auto-advancing story play its clips cost 17.9MB across 7 requests from nothing but scrolling
         past the section, because the story walks the slides and playOnly promotes each one it reaches to
         preload="auto". That is the same 46MB mistake this section was built to avoid, reintroduced while fixing
         "the videos are stuck".

         The actual complaint was that HOVERING a material did nothing, and it did nothing because hover never set
         userPicked. So hover sets it now. The story still runs on posters and costs nothing; engaging with a
         material plays its film. One clip, on purpose, for someone who asked.

         Save-Data and 2g are still honoured, and a phone still has to tap. */
      var conn = navigator.connection || {};
      var videoOk =
        !conn.saveData && !/(^|-)2g$/.test(conn.effectiveType || '') && !reduceMotion;

      /* Guard, not a sweep: the theme starts these on its own schedule, so the answer has to fire on the event
         rather than at a moment of our choosing. A clip may run only when it is the slide on screen AND the visitor
         has actually chosen a material. */
      vids.forEach(function (v) {
        v.addEventListener('play', function () {
          var slide = v.parentElement;
          while (slide && !slide.hasAttribute('data-v2-slide')) slide = slide.parentElement;
          var mine = slide && parseInt(slide.getAttribute('data-v2-slide'), 10) === cur;
          if (st.classList.contains('is-grid')) mine = !!(slide && slide.classList.contains('is-big') && st.classList.contains('is-open'));
          if (!userPicked || !mine) {
            try {
              v.pause();
              v.currentTime = 0;
            } catch (e) {
              /* ignore */
            }
          }
        });
      });

      function playOnly(i) {
        /* THE PHONE GRID PLAYS NOTHING UNTIL A TILE IS OPEN (2026-09-30). The grid is six posters; only the tile
           opened large may play. Coming back to the tab (visibilitychange) used to restart the last clip inside the
           closed grid, so one tile played while the other five stood still. Every caller goes through here. */
        if (st.classList.contains('is-grid')) {
          var big = st.querySelector('[data-v2-slide].is-big');
          if (!st.classList.contains('is-open') || !big) {
            vids.forEach(function (v) { if (!v.paused) { try { v.pause(); } catch (e) { /* ignore */ } } });
            return;
          }
          i = parseInt(big.getAttribute('data-v2-slide'), 10);
        }
        vids.forEach(function (v) {
          var slide = v.parentElement;
          while (slide && !slide.hasAttribute('data-v2-slide')) slide = slide.parentElement;
          var on = slide && parseInt(slide.getAttribute('data-v2-slide'), 10) === i;
          // poster only until somebody actually asks for this material, on every device
          if (on && !userPicked) return;
          if (on) {
            if (v.preload !== 'auto') v.preload = 'auto';
            var pr = v.play();
            if (pr && pr['catch']) pr['catch'](function () {});
          } else if (!v.paused || (v.currentTime > 0 && st.classList.contains('is-grid'))) {
            try {
              v.pause();
              if (st.classList.contains('is-grid') && v.currentTime > 0) v.load(); // a thumbnail shows its poster again
            } catch (e) {
              /* ignore */
            }
          }
        });
      }

      function show(i) {
        if (i === cur || isNaN(i)) return;
        cur = i;
        slides.forEach(function (s) {
          s.classList.toggle('is-on', parseInt(s.getAttribute('data-v2-slide'), 10) === i);
        });
        rows.forEach(function (r) {
          var on = parseInt(r.getAttribute('data-v2-row'), 10) === i;
          r.classList.toggle('is-on', on);
          if (r.hasAttribute('aria-pressed')) r.setAttribute('aria-pressed', String(on));
        });
        playOnly(i);
        paintBars(i, autoAllowed && auto !== 0);
      }

      playOnly(0);

      /* ALWAYS PLAYING WHILE IT IS SEEN (2026-09-23)
         The owner's call after "the videos are stuck": the clip on screen plays whenever the section is in view, on
         every device, and pauses the moment the section leaves the screen. Only Save-Data and 2g keep the posters.
         The cost is known and accepted: with preload="none" the browser fetches roughly what it plays, about 4MB per
         slide of the story, and nothing at all while the section is off screen. */
      if (videoOk && 'IntersectionObserver' in window) {
        var seen = false;
        new IntersectionObserver(function (es) {
          var vis = es.some(function (e) { return e.isIntersecting; });
          if (vis === seen) return;
          seen = vis;
          if (vis) {
            if (st.classList.contains('is-grid') && !st.classList.contains('is-open')) return;
            userPicked = true;
            playOnly(cur);
          } else {
            vids.forEach(function (v) {
              if (!v.paused) {
                try { v.pause(); } catch (e) { /* ignore */ }
              }
            });
          }
        }, { threshold: 0.35 }).observe(st);
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden && seen) playOnly(cur);
        });
      }

      /* Declared up here so the pill handlers below can actually cancel it. A deliberate tap ends the carousel for
         good: the visitor has told us which material they want, and moving the panel out from under them afterwards
         sends them to the wrong collection. */
      var auto = 0;
      var bars = st.querySelectorAll('[data-v2-bar]');
      var DWELL = 4200;

      /* The bars are the only thing that says "this is moving on its own". Restarting the animation means removing
         the class, forcing a reflow, and adding it back: without the reflow the browser coalesces the two changes
         and the animation never replays. */
      function paintBars(i, running) {
        bars.forEach(function (b) {
          var idx = parseInt(b.getAttribute('data-v2-bar'), 10);
          b.classList.remove('is-on', 'is-done', 'is-run');
          if (idx < i) b.classList.add('is-done');
          else if (idx === i) {
            b.classList.add('is-on');
            if (running) {
              void b.offsetWidth;
              b.classList.add('is-run');
            }
          }
        });
      }

      function stopAuto() {
        if (auto) {
          clearInterval(auto);
          auto = 0;
        }
      }
      var autoAllowed = true;
      function killAuto() {
        autoAllowed = false;
        userPicked = true; // from here on the chosen slide may load and play its clip
        stopAuto();
        paintBars(cur, false); // frozen on the chosen one, no fill crawling along
      }

      /* THE PHONE GRID: below 750px the six films are a 2 x 3 grid of small posters. A tap opens that one large and
         the other five slide into a row of thumbnails under it to switch between; the close button (or the open
         film itself) goes back to the grid. Each change is one view transition, so every tile glides from where it
         was to where it goes, and only the large film ever plays. No timer on a phone. */
      var media = st.querySelector('.v2-stage__media');
      var phoneGrid = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      if (phoneGrid && media) {
        autoAllowed = false;
        stopAuto();
        st.classList.add('is-grid');
        slides.forEach(function (s) { s.classList.remove('is-on'); });
        vids.forEach(function (v) { try { v.pause(); } catch (e) { /* ignore */ } });
        var xBtn = document.createElement('button');
        xBtn.type = 'button';
        xBtn.className = 'v2-stage__x';
        xBtn.setAttribute('aria-label', 'x');
        xBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
        media.appendChild(xBtn);
        slides.forEach(function (s, k) { s.style.viewTransitionName = 'v2mat-' + k; });
        var morph = function (fn) {
          if (document.startViewTransition && !reduceMotion) document.startViewTransition(fn);
          else fn();
        };
        var openBig = function (k) {
          morph(function () {
            st.classList.add('is-open');
            slides.forEach(function (s) { s.classList.toggle('is-big', parseInt(s.getAttribute('data-v2-slide'), 10) === k); });
            cur = -1;
            show(k);
            if (videoOk) { userPicked = true; playOnly(k); }
          });
          setTimeout(function () {
            var top = media.getBoundingClientRect().top + window.scrollY - 96;
            if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
          }, 380);
        };
        var closeBig = function () {
          morph(function () {
            st.classList.remove('is-open');
            slides.forEach(function (s) { s.classList.remove('is-big', 'is-on'); });
            // back to the poster, so every tile in the grid shows the same kind of still, not one frozen mid-clip
            vids.forEach(function (v) { try { v.pause(); if (v.currentTime > 0) v.load(); } catch (e) { /* ignore */ } });
          });
        };
        slides.forEach(function (s) {
          s.addEventListener('click', function (ev) {
            if (ev.target.closest && ev.target.closest('a')) return; // the "see all" link inside the big one
            var k = parseInt(s.getAttribute('data-v2-slide'), 10);
            if (s.classList.contains('is-big')) return;
            ev.preventDefault();
            openBig(k);
          });
        });
        xBtn.addEventListener('click', closeBig);
      }

      var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      rows.forEach(function (r) {
        var i = parseInt(r.getAttribute('data-v2-row'), 10);
        if (fine) {
          r.addEventListener('pointerenter', function () {
            stopAuto(); // paused while it is being read, not ended
            /* Hovering a material IS asking for it. This line is the whole fix for "the videos are stuck": the
               story was showing posters and nothing a visitor did with the pointer ever unlocked the clip. */
            if (videoOk) userPicked = true;
            show(i);
            playOnly(i);
            paintBars(i, false);
          });
          r.addEventListener('pointerleave', function () {
            if (autoAllowed) startAuto();
          });
        }
        // the pills are buttons: a tap browses to that material's panel rather than leaving the page
        r.addEventListener('click', function (ev) {
          ev.preventDefault();
          killAuto();
          show(i);
          // show() returns early when this slide is already the one on screen, which is exactly the case when the
          // story happens to have stopped on it. Ask for the film explicitly, or tapping it would do nothing.
          playOnly(i);
        });
        // keyboard users get the same panel, which is also what makes this usable without a mouse
        r.addEventListener('focus', function () {
          show(i);
        });
      });

      /* With no pointer the pills are a straight tap-to-navigate list, so nothing would ever change the panel. It
         advances by itself instead, and only while the section is actually on screen: an interval running against a
         panel nobody can see is pure battery. Reduced motion opts out entirely. */
      /* Runs on a desktop too now: the section is a story, and a story that only moves on phones is just a static
         picture to half the audience. Hovering a pill pauses it, because that is someone reading rather than
         choosing; a click ends it. */
      if (!reduceMotion && 'IntersectionObserver' in window) {
        var startAuto = function () {
          if (auto || !autoAllowed) return;
          auto = setInterval(function () {
            show((cur + 1) % slides.length);
          }, DWELL);
          paintBars(cur, true);
        };
        // a swipe or tap anywhere on the stage is also a deliberate interaction
        st.addEventListener('touchstart', killAuto, { passive: true });
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                startAuto();
              } else {
                stopAuto();
                // a clip still streaming behind a section nobody can see is pure bandwidth
                vids.forEach(function (v) {
                  if (!v.paused) {
                    try {
                      v.pause();
                    } catch (err) {
                      /* ignore */
                    }
                  }
                });
              }
            });
          },
          { threshold: 0.25 }
        ).observe(st);
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stopAuto();
        });
      }
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     6. CONTINUE WHERE YOU LEFT OFF
     Reads the theme's OWN record of viewed products (localStorage `theme:recently-viewed-products`, an array of ids
     newest first) and asks Shopify to render our section for the newest one through the Section Rendering API. No
     product page is modified to make this work, and the returned cards are the theme's real product-card markup.

     If there is no history, no recommendation, or anything at all goes wrong, the band simply stays hidden: it was
     rendered `hidden` and empty by Liquid, so the failure mode is "no band", never an empty heading.
     -------------------------------------------------------------------------------------------------------------- */
  function bandTitle(band) {
    var titleEl = band.querySelector('[data-v2-viewed-title]');
    var tpl = band.getAttribute('data-template') || '';
    if (!titleEl || tpl.indexOf('%s') === -1) return;

    var names = [].slice.call(band.querySelectorAll('.product-card__title')).map(function (e) {
      return (e.textContent || '').replace(/\s+/g, ' ').trim();
    });
    names = names.filter(Boolean);
    if (names.length < 3) return;

    // Shopify's "related" intent returns straps for the same watch, and on this catalogue the model is the leading
    // part of every such title ("Google Pixel Watch 4 - 41mm Nylon Strap (Green)"). The longest common prefix is
    // therefore the model name. If the titles disagree, the prefix collapses and we keep the generic heading.
    var p = names[0];
    for (var i = 1; i < names.length; i++) {
      var a = p;
      var b = names[i];
      var j = 0;
      while (j < a.length && j < b.length && a.charAt(j).toLowerCase() === b.charAt(j).toLowerCase()) j++;
      p = a.slice(0, j);
      if (p.length < 4) return;
    }

    p = p.replace(/[\s\-–—,:(|]+$/, '').trim();
    if (p.length < 6 || p.split(' ').length < 2) return;
    titleEl.textContent = tpl.replace('%s', p);
  }

  /* --------------------------------------------------------------------------------------------------------------
     6b. THE HERO SLIDESHOW
     Slides crossfade; the headline dissolves with them. Two rules keep it from being expensive:

       1. Only slide one arrives with a src. Every other slide's URLs sit in data- attributes until `hydrate` moves
          them across, and hydration runs one slide AHEAD of the fade, so the image is decoded before it is shown
          and nobody pays for photographs they never reach. This is the same lesson the material videos taught: a
          hero that eagerly loads six full bleed images is the heaviest thing on the page and five sixths waste.

       2. The timer stops whenever nobody is watching: tab hidden, pointer resting on the hero, or a visitor who has
          taken the controls. Reduced motion turns autoplay off entirely and leaves the dots working, which is the
          honest reading of the preference: no unrequested movement, full access to the content.
     -------------------------------------------------------------------------------------------------------------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-v2-hero]:not([data-v2-hero-ready])').forEach(function (hero) {
      hero.setAttribute('data-v2-hero-ready', '');

      /* PHONES: THREE MATERIALS JOIN THE HERO (2026-10-07, asked). The material films no longer play in the
         materials grid on a phone, so three of them rotate in the hero alongside its photos: the clip (480p, from
         the materials section, nothing fetched twice), its light photo as poster, the material as the headline and
         a tap that opens its page. Only on phones, only once. */
      (function heroMaterials() {
        if (!window.matchMedia('(max-width: 749px)').matches || hero.hasAttribute('data-v2-hero-mats')) return;
        var mat = document.querySelector('.shopify-section--swb-v2-materials');
        var first = hero.querySelector('[data-v2-hero-slide]');
        if (!mat || !first) return;
        hero.setAttribute('data-v2-hero-mats', '');
        /* a tap on a material slide opens that material (2026-10-19): the copy layer sits over the slide's own link, so
           the tap landed on the copy and went nowhere */
        hero.addEventListener('click', function (e) {
          if (e.target.closest('a, button, input, select, label')) return;
          var on = hero.querySelector('.v2-hero__slide--mat.is-active, .v2-hero__slide--mat.is-on');
          var link = on && on.querySelector('.v2-hero__matlink');
          if (link) location.href = link.href;
        });
        var picks = [].slice.call(mat.querySelectorAll('.v2-stage__slide')).slice(0, 3);
        /* one short line per material, in the visitor's language (no "view straps" call: the slide itself is the link) */
        var LN = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
        var LINES = {
          nl: { silicone: 'Zacht, licht en klaar voor elke workout.', milanese: 'Geweven staal, licht als een sieraad.', metal: 'Strak staal met een tijdloze uitstraling.', leather: 'Warm leer dat mooier wordt met de jaren.', nylon: 'Licht, ademend en gemaakt om te bewegen.', titanium: 'Zo sterk als staal, half zo zwaar.' },
          de: { silicone: 'Weich, leicht und bereit für jedes Training.', milanese: 'Gewebter Stahl, leicht wie Schmuck.', metal: 'Klarer Stahl mit zeitloser Ausstrahlung.', leather: 'Warmes Leder, das mit den Jahren schöner wird.', nylon: 'Leicht, atmungsaktiv und gemacht für Bewegung.', titanium: 'So stark wie Stahl, halb so schwer.' },
          fr: { silicone: 'Doux, léger et prêt pour chaque séance.', milanese: 'Un acier tissé, léger comme un bijou.', metal: 'Un acier sobre au style intemporel.', leather: 'Un cuir qui se patine joliment avec le temps.', nylon: 'Léger, respirant et fait pour bouger.', titanium: 'Aussi solide que l’acier, deux fois plus léger.' },
          es: { silicone: 'Suave, ligera y lista para cada entreno.', milanese: 'Acero tejido, ligero como una joya.', metal: 'Acero de líneas limpias y estilo atemporal.', leather: 'Piel que gana carácter con el tiempo.', nylon: 'Ligera, transpirable y hecha para moverse.', titanium: 'Casi tan resistente como el acero, mucho más ligero.' },
          en: { silicone: 'Soft, light and ready for every workout.', milanese: 'Woven steel, light as jewellery.', metal: 'Clean steel with a timeless look.', leather: 'Warm leather that gets better with age.', nylon: 'Light, breathable and made to move.', titanium: 'As strong as steel, half the weight.' }
        };
        var LINE = LINES[LN] || LINES.en;
        var photos = [].slice.call(hero.querySelectorAll('[data-v2-hero-slide]'));
        var host = first.parentNode;
        var dotsBox = hero.querySelector('.v2-hero__dots');
        var n0 = hero.querySelectorAll('[data-v2-hero-slide]').length;
        picks.forEach(function (fig, k) {
          var v0 = fig.querySelector('video');
          var name = fig.querySelector('.v2-stage__capname');
          var go = fig.querySelector('.v2-stage__capgo');
          if (!v0 || !name) return;
          var i = n0 + k;
          var sl = document.createElement('div');
          sl.className = 'v2-hero__slide v2-hero__slide--mat';
          sl.setAttribute('data-v2-hero-slide', i);
          sl.setAttribute('data-title', name.textContent.trim());
          var mk = go && (go.getAttribute('href') || '').match(/[?&]mat=([a-z]+)/);
          sl.setAttribute('data-lead', (mk && LINE[mk[1]]) || '');
          var v = document.createElement('video');
          v.muted = true; v.loop = true; v.playsInline = true;
          v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('preload', 'none');
          /* phones: the portrait cut and its portrait still, sharp in the tall hero frame (2026-10-28) */
          var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
          var poster0 = (phone && v0.getAttribute('data-phone-poster')) || v0.getAttribute('poster');
          if (poster0) v.setAttribute('poster', poster0);
          if (v0.getAttribute('data-phone-src')) {
            var ps = document.createElement('source');
            ps.setAttribute('type', 'video/mp4');
            ps.setAttribute('media', '(max-width: 749px)');
            ps.setAttribute('data-src', v0.getAttribute('data-phone-src'));
            v.appendChild(ps);
          }
          v0.querySelectorAll('source').forEach(function (src0) {
            var src = document.createElement('source');
            src.setAttribute('type', src0.getAttribute('type') || 'video/mp4');
            if (src0.getAttribute('media')) src.setAttribute('media', src0.getAttribute('media'));
            src.setAttribute('data-src', src0.getAttribute('src')); /* attached when its slide shows: 5.6 MB of film downloaded on arrival before (2026-10-16) */
            v.appendChild(src);
          });
          sl.appendChild(v);
          if (go && go.getAttribute('href')) {
            var a = document.createElement('a');
            a.className = 'v2-hero__matlink';
            a.href = go.getAttribute('href');
            a.setAttribute('aria-label', name.textContent.trim());
            sl.appendChild(a);
          }
          // mixed in: each material right after a photo (photo, material, photo, material ...)
          var after = photos[k] || photos[photos.length - 1];
          after.parentNode.insertBefore(sl, after.nextSibling);
        });
        // number the slides again in their new order, and give each its dot
        var all = [].slice.call(hero.querySelectorAll('[data-v2-hero-slide]'));
        all.forEach(function (sl, i) { sl.setAttribute('data-v2-hero-slide', i); });
        if (dotsBox) {
          dotsBox.innerHTML = '';
          all.forEach(function (sl, i) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'v2-hero__dot' + (sl.classList.contains('is-on') ? ' is-on' : '');
            d.setAttribute('data-v2-hero-dot', i);
            d.setAttribute('aria-label', (i + 1) + ' / ' + all.length);
            if (sl.classList.contains('is-on')) d.setAttribute('aria-current', 'true');
            d.innerHTML = '<i></i>';
            dotsBox.appendChild(d);
          });
        }
        // play the film only while its slide is showing
        /* the film loads while the slide BEFORE it shows, and stays invisible over its still until it really plays, then
           fades in: the still showed and the film snapped in over it a moment later (2026-10-15, asked) */
        function attach(vv) {
          if (vv._v2src) return;
          vv._v2src = 1;
          vv.setAttribute('preload', 'auto');
          vv.querySelectorAll('source[data-src]').forEach(function (so) { so.setAttribute('src', so.getAttribute('data-src')); });
          vv.load();
        }
        hero.querySelectorAll('.v2-hero__slide--mat video').forEach(function (vv) {
          var po = vv.getAttribute('poster');
          if (po) vv.parentNode.style.backgroundImage = 'url("' + po.replace(/"/g, '%22') + '")';
          vv.addEventListener('playing', function () { vv.classList.add('is-playing'); });
        });
        function sync() {
          var sls = [].slice.call(hero.querySelectorAll('[data-v2-hero-slide]'));
          var at = -1;
          sls.forEach(function (sl, i) { if (sl.classList.contains('is-on')) at = i; });
          var nxt = at > -1 ? sls[(at + 1) % sls.length] : null;
          if (nxt) { var nv = nxt.querySelector('video'); if (nv) attach(nv); }
          hero.querySelectorAll('.v2-hero__slide--mat video').forEach(function (vv) {
            var on = vv.parentNode.classList.contains('is-on');
            if (on) attach(vv);
            if (on && vv.paused) { var pr = vv.play(); if (pr && pr['catch']) pr['catch'](function () {}); }
            if (!on && !vv.paused) vv.pause();
          });
        }
        new MutationObserver(sync).observe(host, { subtree: true, attributes: true, attributeFilter: ['class'] });
        sync();
      })();
      var slides = [].slice.call(hero.querySelectorAll('[data-v2-hero-slide]'));
      var dots = [].slice.call(hero.querySelectorAll('[data-v2-hero-dot]'));
      if (slides.length < 2) return;

      var copy = hero.querySelector('.v2-hero__copy');
      var titleEl = hero.querySelector('[data-v2-hero-title]');
      var leadEl = hero.querySelector('[data-v2-hero-lead]');
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var wait = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
      var auto = hero.getAttribute('data-autoplay') === '1' && !calm;
      var cur = 0;
      var timer = 0;
      var hover = false;
      var taken = false; // a visitor who steers keeps the wheel

      function hydrate(i) {
        var s = slides[i];
        if (!s || s.hasAttribute('data-hydrated')) return;
        s.setAttribute('data-hydrated', '');
        s.querySelectorAll('source[data-srcset]').forEach(function (src) {
          src.srcset = src.getAttribute('data-srcset');
          src.removeAttribute('data-srcset');
        });
        s.querySelectorAll('img[data-src]').forEach(function (img) {
          var set = img.getAttribute('data-srcset');
          if (set) {
            img.srcset = set;
            img.removeAttribute('data-srcset');
          }
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src');
        });
      }

      function go(n) {
        n = ((n % slides.length) + slides.length) % slides.length;
        if (n === cur) return;
        hydrate(n);
        slides[cur].classList.remove('is-on');
        slides[n].classList.add('is-on');
        dots.forEach(function (d, k) {
          d.classList.toggle('is-on', k === n);
          if (k === n) {
            d.setAttribute('aria-current', 'true');
          } else {
            d.removeAttribute('aria-current');
          }
        });
        cur = n;

        /* The words change at the midpoint of the dissolve. Swapping them on frame one would put the new headline
           over the old photograph for most of a second, which is the exact mismatch the per-slide copy exists to
           avoid. */
        if (copy) {
          var t = slides[n].getAttribute('data-title');
          var l = slides[n].getAttribute('data-lead');
          /* a material slide shows its one line under the name on phones (2026-10-29, asked); the others keep it hidden */
          var isMat = slides[n].classList.contains('v2-hero__slide--mat');
          if (calm) {
            if (titleEl && t) titleEl.textContent = t;
            if (leadEl && l) leadEl.textContent = l;
            hero.classList.toggle('v2-hero--mat', isMat);
          } else {
            copy.classList.add('is-swapping');
            setTimeout(function () {
              if (titleEl && t) titleEl.textContent = t;
              if (leadEl && l) leadEl.textContent = l;
              hero.classList.toggle('v2-hero--mat', isMat);
              copy.classList.remove('is-swapping');
            }, 420);
          }
        }
        // the one after this, fetched during the dwell rather than at the moment it is needed
        setTimeout(function () {
          hydrate((n + 1) % slides.length);
        }, 600);
      }

      function tick() {
        clearTimeout(timer);
        if (!auto || taken) return;
        timer = setTimeout(function () {
          if (!document.hidden && !hover) go(cur + 1);
          tick();
        }, wait);
      }

      /* A visitor who steers keeps the wheel, but not for ever: after 12s without touching it the slides carry on
         by themselves again (2026-10-20, asked). */
      var idleT = 0;
      function steer() {
        taken = true;
        clearTimeout(timer);
        clearTimeout(idleT);
        idleT = setTimeout(function () { taken = false; tick(); }, 12000);
      }
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          steer();
          go(parseInt(d.getAttribute('data-v2-hero-dot'), 10) || 0);
        });
      });

      /* swipe between slides (2026-10-20, asked): a mostly sideways swipe on the photo, never on the picker card or a
         control, moves one slide */
      var sx = null, sy = 0;
      hero.addEventListener('touchstart', function (e) {
        var t = e.target;
        if (t.closest && t.closest('.v2-pick, a, button, select, input, label')) { sx = null; return; }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var c = e.changedTouches[0], dx = c.clientX - sx, dy = c.clientY - sy;
        sx = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        steer();
        go(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });

      /* hover pauses for a mouse only: on a phone a touch fired pointerenter and nothing ever cleared it, so the
         slides stopped for good after the first tap */
      hero.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') hover = true;
      });
      hero.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') hover = false;
      });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) tick();
      });

      /* the next slide's photo waits until the page has loaded (and the browser is idle): fetched at boot it competed
         with the first slide, the page's largest paint, for the same connection */
      (function () {
        function later() { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(function () { hydrate(1); }, { timeout: 2500 }); }
        if (document.readyState === 'complete') later();
        else window.addEventListener('load', later, { once: true });
      })();
      /* phones: the slides start turning after the page has loaded (capped at 8 s): the first material slide is a video
         (0.9 MB) and it was fetched at ~6 s while images and scripts were still coming in over the same 4G (2026-11-02 audit) */
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches && document.readyState !== 'complete') {
        var started = false;
        var start = function () { if (started) return; started = true; tick(); };
        window.addEventListener('load', start, { once: true });
        setTimeout(start, 8000);
      } else {
        tick();
      }
    });
  }

  function initViewed(root) {
    var host = (root || document).querySelector('[data-v2-viewed]:not([data-v2-viewed-ready])');
    if (!host) return;
    host.setAttribute('data-v2-viewed-ready', '');

    var ids = [];
    try {
      ids = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
    } catch (e) {
      return; // blocked storage: no history to act on
    }
    if (!Array.isArray(ids) || !ids.length) return;

    var sid = host.getAttribute('data-section-id');
    if (!sid) return;
    var limit = parseInt(host.getAttribute('data-limit'), 10) || 12;

    var url =
      '/recommendations/products?section_id=' +
      encodeURIComponent(sid) +
      '&product_id=' +
      encodeURIComponent(ids[0]) +
      '&limit=' +
      limit +
      '&intent=related';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-v2-viewed]');
        if (!fresh || !fresh.querySelector('.nr-i')) return; // nothing to recommend: stay hidden
        fresh = document.adoptNode(fresh);
        fresh.removeAttribute('hidden');
        fresh.setAttribute('data-v2-viewed-ready', '');
        if (!host.parentNode) return;
        host.parentNode.replaceChild(fresh, host);
        bandTitle(fresh);
        initReveal(fresh);
        initLife(fresh);
        initCarousel(fresh);
      })
      .catch(function () {
        /* band stays hidden */
      });
  }


  /* --------------------------------------------------------------------------------------------------------------
     7. THE HEADER ISLAND
     Mega panels and the mobile sheet. Both are rendered with the `hidden` attribute, so with JS dead the header is
     still a working logo + links + search + cart and nothing is stuck open over the page.

     Opening is two steps on purpose: drop `hidden` first, then add `is-open` on the next frame. Setting both at once
     means the element goes from display:none straight to its final state and the browser has no previous style to
     transition FROM, so the panel would snap instead of fade. Closing runs the reverse and only re-applies `hidden`
     once the transition has finished, which is why it is on a timer rather than transitionend (that never fires if
     the panel is closed while already hidden, and would leave it permanently un-hidden).
     -------------------------------------------------------------------------------------------------------------- */
  /* --------------------------------------------------------------------------------------------------------------
     10. THE BRAND INDEX
     Pills in, panels out. Every panel is already in the document, so this only decides which one is not hidden: no
     fetch, no template, and nothing is built at runtime that the back button could fail to restore.

     The pills are anchors to each brand's hub and stay that way. preventDefault turns the click into a disclosure
     for anyone with scripts; the hub is still reachable from the "all X straps" link inside the panel, which is
     where somebody who wanted the whole collection would look anyway.
     -------------------------------------------------------------------------------------------------------------- */
  function initBrandIndex(root) {
    (root || document).querySelectorAll('[data-v2-bx]:not([data-v2-bx-ready])').forEach(function (bx) {
      bx.setAttribute('data-v2-bx-ready', '');
      var pills = [].slice.call(bx.querySelectorAll('[data-v2-bx-pill]'));
      var panels = [].slice.call(bx.querySelectorAll('[data-v2-bx-panel]'));
      if (!pills.length || !panels.length) return;

      function open(i) {
        pills.forEach(function (p) {
          var on = p.getAttribute('data-v2-bx-pill') === i;
          p.classList.toggle('is-on', on);
          p.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        panels.forEach(function (pa) {
          pa.hidden = pa.getAttribute('data-v2-bx-panel') !== i;
        });
      }

      var row = bx.querySelector('.v2-bx__brands');

      /* The menus are in the merchandiser's order, which opened this on whichever brand happens to sit first. */
      var lead = (bx.getAttribute('data-v2-bx-lead') || '').trim();
      if (lead) {
        for (var k = 0; k < pills.length; k++) {
          if ((pills[k].getAttribute('data-v2-bx-name') || '') === lead) {
            open(pills[k].getAttribute('data-v2-bx-pill'));
            break;
          }
        }
      }

      pills.forEach(function (p) {
        p.addEventListener('click', function (ev) {
          ev.preventDefault();
          open(p.getAttribute('data-v2-bx-pill'));
          /* A pill three quarters along a swipeable row is half off screen the moment it lights up, so the thing
             just chosen is the thing that cannot be seen. This only ever scrolls the row, never the page. */
          if (row && row.scrollWidth > row.clientWidth + 4) {
            var want = p.offsetLeft - (row.clientWidth - p.offsetWidth) / 2;
            row.scrollTo({ left: Math.max(0, want), behavior: 'smooth' });
          }
        });
      });
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     11. OCCASIONS: CARD OPENS PANEL
     The cards are real links to the occasion page and stay that way, so this works with no scripts and reads as a
     link to a crawler. With scripts the first tap opens the panel instead, and the page is still one tap away from
     the button inside it.

     Products are fetched the first time a panel opens and never again. Every strap already carries its occasion as
     a tag, so a tag-filtered collection URL exists on all five storefronts with nothing to create and no per-market
     handle to pin. Nothing is fetched for a panel nobody opens, which on a section this far down the page is most
     of them.
     -------------------------------------------------------------------------------------------------------------- */
  function initOccasions(root) {
    (root || document).querySelectorAll('[data-v2-occ-panels]:not([data-v2-occ-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-v2-occ-ready', '');
      var band = wrap.closest('.v2-occ') || document;
      var cards = [].slice.call(band.querySelectorAll('[data-v2-occ-card]'));
      var panels = [].slice.call(wrap.querySelectorAll('[data-v2-occ-panel]'));
      var ptr = wrap.querySelector('[data-v2-occ-ptr]');
      var row = band.querySelector('.v2-occ__row');
      if (!cards.length || !panels.length) return;
      var cur = null;

      function cardFor(i) {
        for (var k = 0; k < cards.length; k++) {
          if (cards[k].getAttribute('data-v2-occ-card') === i) return cards[k];
        }
        return null;
      }

      function placePointer(i) {
        if (!ptr || !row) return;
        var c = cardFor(i);
        if (!c) return;
        /* offsetLeft is measured inside the scrolling track, so the pointer has to be corrected by how far that
           track has been scrolled or it aims at where the card used to be. */
        var x = c.offsetLeft - row.scrollLeft + c.offsetWidth / 2;
        ptr.style.left = Math.round(x) + 'px';
        ptr.hidden = false;
      }

      /* Returns a promise that ALWAYS resolves, including on failure, because the caller uses it to decide when to
         open the panel and a dead network must not leave the card stuck in a loading state forever. */
      /* THE PREFETCH AND THE TAP SHARE ONE REQUEST
         The filled flag used to be set when a request STARTED. A tap that landed while the band's prefetch was still
         in flight was therefore told the products were already there: the panel opened empty and then jumped about
         300px when they arrived, measured on a phone, which is exactly the jerk this section was known for. The
         request's promise is kept on the panel instead, and a tap waits on that same promise. */
      /* THE PANEL SHOWS STRAPS FOR THE VISITOR'S WATCH
         With a watch chosen in the switch module, the products come from that model's own collection filtered by
         the occasion's tag (measured: /collections/<model>/<tag>?view=newrow returns cards on all five markets), so
         "Popular for this moment" is popular for THEIR watch. No watch, or a model with nothing tagged for this
         moment, falls back to the section's own source. The panel remembers which source it holds, so a watch
         chosen later refreshes it in place. */
      function watchSrc() {
        var w = readWatch();
        if (!w || !w.url || !/\/collections\//.test(w.url)) return '';
        return w.url.split('?')[0].replace(/^.*\/collections\//, '').replace(/\/$/, '');
      }
      function getItems(src, tag) {
        /* six seconds at most: a hung request must never leave a moment on its placeholders */
        var ctl = window.AbortController ? new AbortController() : null;
        var tmo = ctl ? setTimeout(function () { ctl.abort(); }, 6000) : 0;
        return fetch('/collections/' + src + (tag ? '/' + encodeURIComponent(tag) : '') + '?view=newrow', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: ctl ? ctl.signal : undefined
        })
          .then(function (r) { clearTimeout(tmo); return r; }, function (e) { clearTimeout(tmo); throw e; })
          .then(function (r) {
            return r.ok ? r.text() : '';
          })
          .then(function (html) {
            if (!html || html.indexOf('<html') > -1) return [];
            var tpl = document.createElement('template');
            tpl.innerHTML = html;
            return [].slice.call(tpl.content.querySelectorAll('.nr-i'));
          })
          .catch(function () {
            return [];
          });
      }
      function fill(panel) {
        var tag = panel.getAttribute('data-v2-occ-tag');
        var base = panel.getAttribute('data-v2-occ-src');
        var mine = watchSrc();
        var key = mine || base;
        if (panel.v2Fill && panel.v2FillKey === key) return panel.v2Fill;
        panel.v2FillKey = key;
        panel.setAttribute('data-v2-occ-filled', '');
        var slot = panel.querySelector('[data-v2-occ-prods]');
        if (!slot || !tag || !base) return (panel.v2Fill = Promise.resolve());
        return (panel.v2Fill = getItems(key, tag)
          /* NEVER EMPTY (asked 2026-09-30). In order: the visitor's watch for this moment, that watch's own
             bestsellers (straps that still fit beat straps for another brand), this moment across all straps, and
             finally the source collection's bestsellers. A failed or timed-out request just moves down the list. */
          .then(function (items) {
            return items.length || !mine ? items : getItems(mine, '');
          })
          .then(function (items) {
            return items.length || !mine ? items : getItems(base, tag);
          })
          .then(function (items) {
            return items.length ? items : getItems(base, '');
          })
          .then(function (items) {
            if (panel.v2FillKey !== key) return; // a newer watch took over while this was in flight
            if (!items.length) {
              slot.innerHTML = '';
              return;
            }
            /* MATERIALS MIXED. Best-selling order gave an Apple Watch "every day" row of eight Milanese bands. The
               cards are dealt round robin by material (read from the title, in all five languages), so the row
               shows the range first and the second Milanese only after one of everything else. */
            var MATS = [
              ['milanese', /milan/],
              ['leather', /leather|leer|leder|cuir|cuero|piel/],
              ['silicone', /silicon|silikon|rubber|sport/],
              ['nylon', /nylon|woven|geweven|gewebt|tiss|trenzad|braid|gevlochten|geflochten|loop/],
              ['titanium', /titan/],
              ['steel', /steel|staal|stahl|acier|acero|metal|link|schakel/]
            ];
            var buckets = {}, order = [];
            items.forEach(function (it) {
              var tl = ((it.querySelector('.product-card__title') || {}).textContent || '').toLowerCase();
              var mat = 'other';
              for (var mi = 0; mi < MATS.length; mi++) if (MATS[mi][1].test(tl)) { mat = MATS[mi][0]; break; }
              if (!buckets[mat]) { buckets[mat] = []; order.push(mat); }
              buckets[mat].push(it);
            });
            if (order.length > 1) {
              var mixed = [];
              for (var round = 0; mixed.length < items.length; round++) {
                order.forEach(function (m) { if (buckets[m][round]) mixed.push(buckets[m][round]); });
              }
              items = mixed;
            }
            /* SLIM CARDS: image, title, price. The panel used to carry the theme's full product card (A/B badges,
               points row, swatches, hover swap), which made it tall and busy for what is a "here are a few" peek. The
               four facts a visitor needs are read out of that card and set in a card of our own. */
            var txt = function (el) {
              if (!el) return '';
              var c2 = el.cloneNode(true);
              [].forEach.call(c2.querySelectorAll('.sr-only, .visually-hidden'), function (x) { x.remove(); });
              return c2.textContent.replace(/\s+/g, ' ').trim();
            };
            var esc2 = function (t) {
              return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; });
            };
            var html = '';
            /* SHORT TITLES. The panel already holds straps for the chosen watch, so repeating "Huawei Watch GT 7 -
               46mm" in front of every name only pushed the part that differs (the strap) off the card. The watch's
               own name comes off the front; the full title stays on the link. The currency code goes too: these are
               compact cards and "GBP" was what wrapped the price onto a second line. */
            var wch = mine ? readWatch() : null;
            var cut = [];
            if (wch) {
              cut.push(watchLabel(wch), (wch.model || '').trim());
              if (wch.brand) cut.push(wch.brand.trim() + ' Watch', wch.brand.trim());
            }
            cut = cut.filter(Boolean).sort(function (x, y) { return y.length - x.length; });
            var shortT = function (t) {
              var low = t.toLowerCase();
              for (var k = 0; k < cut.length; k++) {
                if (low.indexOf(cut[k].toLowerCase()) === 0) {
                  var rest = t.slice(cut[k].length).replace(/^[\s\-–:|,]+/, '');
                  if (rest.length > 3) return rest.charAt(0).toUpperCase() + rest.slice(1);
                }
              }
              // a strap brand in front ("Bandz Huawei Watch GT 7 - 46mm Woven..."): the watch comes out of the middle
              for (var m = 0; m < cut.length; m++) {
                var at = low.indexOf(' ' + cut[m].toLowerCase() + ' ');
                if (at > 0) return (t.slice(0, at) + ' ' + t.slice(at + cut[m].length + 2)).replace(/\s+/g, ' ').replace(/\s[\-–]\s/, ' ').trim();
              }
              return t;
            };
            var noCode = function (p) { return p.replace(/\s*[A-Z]{3}$/, ''); };
            // up to eight: a desktop row shows as many as fit, a phone swipes through all of them
            for (var c = 0; c < items.length && c < 8; c++) {
              var it = items[c];
              var a = it.querySelector('a[href*="/products/"]');
              var img = it.querySelector('.product-card__image--primary') || it.querySelector('img');
              var title = txt(it.querySelector('.product-card__title'));
              var now = txt(it.querySelector('sale-price'));
              var was = txt(it.querySelector('compare-at-price'));
              // the card's own badges (sale %, our choice...) come along, the same as on every other card
              var bl = it.querySelector('.product-card__badge-list');
              var badges = bl ? '<span class="v2-occ__pcb">' + bl.innerHTML + '</span>' : '';
              if (!a || !title) continue;
              html +=
                '<a class="v2-occ__pc" href="' + esc2(a.getAttribute('href')) + '" title="' + esc2(title) + '">' +
                '<span class="v2-occ__pcimg">' + badges +
                (img ? '<img src="' + esc2(img.getAttribute('src') || '') + '"' +
                  (img.getAttribute('srcset') ? ' srcset="' + esc2(img.getAttribute('srcset')) + '"' : '') +
                  ' sizes="(max-width: 699px) 42vw, 190px" alt="" loading="lazy">' : '') +
                '</span>' +
                '<span class="v2-occ__pct">' + esc2(shortT(title)) + '</span>' +
                '<span class="v2-occ__pcp"><b>' + esc2(noCode(now)) + '</b>' + (was ? '<s>' + esc2(noCode(was)) + '</s>' : '') + '</span>' +
                '</a>';
            }
            slot.innerHTML = html ? '<div class="v2-occ__pgrid is-in">' + html + '</div>' : '';
          })
          .catch(function () {
            slot.innerHTML = '';
          }));
      }

      /* STAGE MODE (sections/swb-home-v2-moments.liquid, 2026-09-30): the moment switcher. Always open, one moment on
         the stage at a time; a tab swaps the photo and the pane in place. No shrinking row, no panel growing, no
         scroll to reveal, so the page never moves. fill() above is shared, so the products are the same watch-aware
         tag lists as before. */
      if (band.hasAttribute && band.hasAttribute('data-v2-occ-stage')) {
        var shots = [].slice.call(band.querySelectorAll('[data-v2-occ-img]'));
        var tFor = band.getAttribute('data-t-for') || '';
        var forLine = function () {
          var w = readWatch();
          var lbl = w && watchSrc() ? watchLabel(w) : '';
          band.querySelectorAll('[data-v2-mom-for]').forEach(function (el) {
            el.textContent = lbl ? tFor.replace('%s', lbl) : '';
            el.hidden = !lbl;
          });
        };
        var pick = function (i, focus) {
          if (i === cur) return;
          cur = i;
          cards.forEach(function (c) {
            var on = c.getAttribute('data-v2-occ-card') === i;
            c.classList.toggle('is-open', on);
            c.setAttribute('aria-selected', on ? 'true' : 'false');
            c.tabIndex = on ? 0 : -1;
            if (on && focus) c.focus({ preventScroll: true });
            /* the pill row follows: a swipe to "Uitgaan" brings its pill fully into view (2026-10-19, asked) */
            if (on) {
              var row = c.parentNode;
              if (row && row.scrollWidth > row.clientWidth + 2) {
                var cr = c.getBoundingClientRect(), rr = row.getBoundingClientRect();
                var want = row.scrollLeft + (cr.left - rr.left) - (row.clientWidth - cr.width) / 2;
                row.scrollTo({ left: Math.max(0, Math.min(want, row.scrollWidth - row.clientWidth)), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
              }
            }
          });
          shots.forEach(function (f) { f.classList.toggle('is-on', f.getAttribute('data-v2-occ-img') === i); });
          panels.forEach(function (p) { p.classList.toggle('is-open', p.getAttribute('data-v2-occ-panel') === i); });
          var p = panelFor(i);
          if (p) fill(p).then(function () { p.v2Filled = true; });
        };
        cur = (cards[0] && cards[0].getAttribute('data-v2-occ-card')) || '0';
        /* STEP IN THE ORDER THE ROW SHOWS, NOT THE DOM ORDER (2026-10-31, "it goes from all day to sport, then
           zakelijk?"). The tabs are laid out by CSS `order` (the section's m_ord: the hour of the day), while the
           blocks sit in the editor's order (all_day, sport, business, bling), so stepping by DOM index jumped around
           the visible row. The sequence is read from each tab's computed order at the moment of the step, DOM index
           breaking ties, so it holds on every market, at every width, and if the blocks are reordered. */
        var stepFrom = function (i, d) {
          var seq = cards.map(function (c, k) {
            var o = parseInt(window.getComputedStyle(c).order, 10);
            return { c: c, o: isNaN(o) ? 0 : o, k: k };
          }).sort(function (a, b) { return a.o - b.o || a.k - b.k; }).map(function (e) { return e.c; });
          var at = 0;
          seq.forEach(function (c, k) { if (c.getAttribute('data-v2-occ-card') === i) at = k; });
          return seq[(at + d + seq.length) % seq.length];
        };
        cards.forEach(function (c, ci) {
          c.tabIndex = ci === 0 ? 0 : -1;
          c.addEventListener('pointerenter', function () { warm(c); });
          c.addEventListener('click', function (ev) {
            ev.preventDefault();
            pick(c.getAttribute('data-v2-occ-card'));
          });
          // arrow keys walk the tabs in the order they are SHOWN, the way a tablist should
          c.addEventListener('keydown', function (ev) {
            var d = ev.key === 'ArrowRight' ? 1 : ev.key === 'ArrowLeft' ? -1 : 0;
            if (!d) return;
            ev.preventDefault();
            pick(stepFrom(c.getAttribute('data-v2-occ-card'), d).getAttribute('data-v2-occ-card'), true);
          });
        });
        // a sideways swipe on the photograph moves to the next or previous moment (phones)
        var mediaEl = band.querySelector('[data-v2-mom-media]');
        if (mediaEl) {
          var sx = 0, sy = 0;
          mediaEl.addEventListener('touchstart', function (ev) { sx = ev.touches[0].clientX; sy = ev.touches[0].clientY; }, { passive: true });
          mediaEl.addEventListener('touchend', function (ev) {
            var t = ev.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
            if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
            pick(stepFrom(cur, dx < 0 ? 1 : -1).getAttribute('data-v2-occ-card'));
          }, { passive: true });
        }
        forLine();
        // the first moment is filled as the band nears the screen, the others one at a time after it
        if ('IntersectionObserver' in window) {
          var stWarm = new IntersectionObserver(function (es) {
            if (!es.some(function (e) { return e.isIntersecting; })) return;
            stWarm.disconnect();
            var conn = navigator.connection || {};
            var first = panelFor(cur);
            if (first) fill(first);
            /* the other moments in parallel, not one after another: queued, a moment tapped early (usually the last
               one) sat on its placeholders for seconds on a phone. Save-Data and 2g still get the first only. */
            if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;
            panels.forEach(function (p) { if (p !== first) fill(p); });
          }, { rootMargin: '0px 0px 2600px 0px' }); // ~3 screens ahead: the fetch takes 0.2-1.7s and one run still showed placeholders at 1500px
          stWarm.observe(band);
        } else {
          fill(panelFor(cur));
        }
        // a watch chosen later refreshes the straps and the "for your watch" line in place
        document.addEventListener(EVENT, function () {
          forLine();
          panels.forEach(function (p) { p.v2Fill = null; p.v2Filled = false; });
          var p = panelFor(cur);
          if (p) fill(p);
        });
        return;
      }

      /* THE OPENED PANEL COMES TO THE THUMB
         On a phone the panel opens under the card row and its products and button end up below the fold, so the
         visitor tapped a card and saw nothing happen. Once it opens, the page glides just far enough to show the
         whole panel, in step with the height animation rather than after it, and never so far that the panel's top
         slides under the island. The tapped card is also brought fully into its own horizontal row. */
      function reveal(panel) {
        var c = cardFor(cur);
        if (c && row && row.scrollWidth > row.clientWidth + 2) {
          var l = c.offsetLeft - row.scrollLeft;
          if (l < 0 || l + c.offsetWidth > row.clientWidth) {
            row.scrollTo({ left: Math.max(0, c.offsetLeft - 16), behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        }
        var box = panel.querySelector('.v2-occ__pbox') || panel;
        /* measured a beat in, once the card row has mostly finished shrinking: measured at once, the panel's
           top was still where the tall cards had pushed it, and the page scrolled too far */
        setTimeout(function () {
          var r = box.getBoundingClientRect();
          var hdrEl = document.querySelector('.v2-hdr__island');
          var top = hdrEl ? Math.max(0, hdrEl.getBoundingClientRect().bottom) + 12 : 84;
          var need = r.bottom - (window.innerHeight - 16);
          var room = r.top - top;
          var by = Math.min(need, room);
          if (by > 8) window.scrollBy({ top: by, behavior: reduceMotion ? 'auto' : 'smooth' });
        }, reduceMotion ? 0 : 260);
      }

      function close() {
        panels.forEach(function (p) {
          p.classList.remove('is-open');
        });
        cards.forEach(function (c) {
          c.setAttribute('aria-expanded', 'false');
          c.classList.remove('is-open');
        });
        if (band && band.classList) band.classList.remove('is-expanded');
        if (ptr) ptr.hidden = true;
        cur = null;
        /* Anything still in flight is abandoned here, so a fetch that lands after the visitor closed the panel
           cannot open it again behind them. Escape and the close button both come through this path. */
        pending = null;
      }

      function panelFor(i) {
        for (var k = 0; k < panels.length; k++) {
          if (panels[k].getAttribute('data-v2-occ-panel') === i) return panels[k];
        }
        return null;
      }

      /* THE ROW MOVES ON THE TAP, NOT ON THE NETWORK
         The first version waited for the products before anything at all happened, so the first tap on each card
         felt dead for as long as the round trip took and only then started a 440ms animation. Perceived latency was
         the fetch plus the stagger plus the transition.

         Now the tap is answered in the same frame: the cards start shrinking immediately. Only the PANEL waits for
         its products, which is the one part that genuinely cannot be shown early without opening empty and
         reflowing. By the time the response lands the row has usually finished moving, so the two read as one
         gesture rather than as a wait. */
      function shrink(i) {
        if (band && band.classList) band.classList.add('is-expanded');
        cards.forEach(function (c) {
          var on = c.getAttribute('data-v2-occ-card') === i;
          c.setAttribute('aria-expanded', on ? 'true' : 'false');
          c.classList.toggle('is-open', on);
        });
        cur = i;
      }

      /* SWITCHING IS A SEQUENCE, NOT A CROSSFADE
         Collapsing one panel while expanding another runs two 620ms height animations against each other. They are
         never the same height, so the section's total height swings up and down on the way and the whole page below
         it jitters. Closing first and opening after is one continuous movement instead of two fighting ones, and
         the outgoing collapse is deliberately quicker than the incoming open: leaving should not take as long as
         arriving.

         The pointer moves immediately rather than waiting, because it is the thing that says which card you just
         chose, and it is the one part that should answer the tap at once. */
      function showPanel(i) {
        if (cur !== i) return; // a different card was picked while this one was in flight
        var next = panelFor(i);
        if (!next) return;
        var open = null;
        for (var k = 0; k < panels.length; k++) {
          if (panels[k].classList.contains('is-open')) open = panels[k];
        }
        placePointer(i);
        if (!open || open === next) {
          next.classList.add('is-open');
          reveal(next);
          return;
        }
        /* Closing one and then opening the other was one movement at a time, but it still collapsed the section to
           the height of the cards and grew it back: a 554px bounce, measured. On a SWITCH the panel area never
           needs to pass through zero, so the wrapper takes over and animates straight from the outgoing height to
           the incoming one while the panels themselves swap instantly underneath. One height, one direction. */
        var from = wrap.getBoundingClientRect().height;
        wrap.classList.add('is-switching');
        open.classList.remove('is-open');
        next.classList.add('is-open');
        wrap.style.height = from + 'px';
        // read the height the new panel actually wants, without ever painting it
        wrap.style.transition = 'none';
        wrap.style.height = 'auto';
        var to = wrap.getBoundingClientRect().height;
        wrap.style.height = from + 'px';
        void wrap.offsetWidth; // without this the browser coalesces both heights and nothing animates
        wrap.style.transition = '';
        wrap.style.height = to + 'px';
        reveal(next);
        clearTimeout(wrap.v2SwitchT);
        wrap.v2SwitchT = setTimeout(function () {
          wrap.classList.remove('is-switching');
          wrap.style.height = '';
          wrap.style.transition = '';
        }, 560);
      }

      function open(i) {
        var panel = panelFor(i);
        if (!panel) return;
        shrink(i);
        var cached = !!panel.v2Filled;
        var card = cardFor(i);
        /* NO WAIT: a panel whose products are still on their way opens at once with placeholder cards of the exact
           size the real ones have, and the real cards fade in over them. The height never changes, so there is
           nothing to jump. */
        if (!cached) {
          var slotS = panel.querySelector('[data-v2-occ-prods]');
          if (slotS && !slotS.querySelector('.v2-occ__pc')) {
            var sk = '';
            for (var q = 0; q < 8; q++) sk += '<span class="v2-occ__pc v2-occ__pc--sk" aria-hidden="true"><span class="v2-occ__pcimg"></span><span class="v2-occ__pct">&nbsp;<br>&nbsp;</span><span class="v2-occ__pcp">&nbsp;</span></span>';
            slotS.innerHTML = '<div class="v2-occ__pgrid">' + sk + '</div>';
          }
          cached = true;
          var early = i;
          setTimeout(function () { if (cur === early) showPanel(early); }, 60); // open now, on the placeholders
        }
        var mine = (pending = i);
        fill(panel).then(function () {
          panel.v2Filled = true;
          if (card) card.classList.remove('is-loading');
          if (pending !== mine) return;
          /* 55ms when the products were already in hand, so the panel still reads as following the row rather than
             appearing with it. Nothing when they were not, because the fetch was the stagger. */
          if (cached) setTimeout(function () { showPanel(i); }, 90);
          else showPanel(i);
        });
      }

      var pending = null;

      /* A head start. pointerdown fires before click, and on a desktop pointerenter fires long before either, so by
         the time the tap is registered the response is usually already on its way or in. Costs one request for a
         card somebody is actively reaching for. */
      function warm(c) {
        var p = panelFor(c.getAttribute('data-v2-occ-card'));
        if (p) fill(p);
      }

      cards.forEach(function (c) {
        c.addEventListener('pointerenter', function () {
          warm(c);
        });
        c.addEventListener('pointerdown', function () {
          warm(c);
        });
        c.addEventListener('click', function (ev) {
          ev.preventDefault();
          var i = c.getAttribute('data-v2-occ-card');
          if (i === cur) {
            pending = null;
            close();
          } else {
            open(i);
          }
        });
      });

      wrap.querySelectorAll('[data-v2-occ-close]').forEach(function (b) {
        b.addEventListener('click', function () {
          pending = null;
          close();
        });
      });

      band.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && cur !== null) {
          var c = cardFor(cur);
          close();
          if (c) c.focus();
        }
      });

      /* THE FETCH WAS THE SLOW PART, NOT THE ANIMATION
         Measured: /collections/all-straps/<tag>?view=newrow takes 0.2s to 1.7s and returns 194KB, because Shopify
         renders a whole collection page to produce it. A first tap therefore sat for up to two seconds however fast
         the transition was. Hover warming fixes that for a mouse and does nothing for a thumb.

         So the panels are warmed when the band actually reaches the screen. This section sits about 70% down the
         page, so only a visitor who has already scrolled past everything pays for it, and for them every tap is
         instant. The first panel goes immediately because it is the likeliest tap; the rest follow one at a time so
         four requests never contend with each other or with anything the page is still doing.

         Save-Data is honoured absolutely, and a 2g connection gets the first panel only: prefetching 800KB onto a
         metered phone to save a wait that connection is going to have anyway is not a trade worth making. */
      if (band && band.nodeType === 1 && 'IntersectionObserver' in window) {
        var warmer = new IntersectionObserver(
          function (entries) {
            if (!entries.some(function (e) { return e.isIntersecting; })) return;
            warmer.disconnect();
            var conn = navigator.connection || {};
            if (conn.saveData) return;
            fill(panels[0]);
            if (/(^|-)2g$/.test(conn.effectiveType || '')) return;
            var k = 1;
            (function next() {
              if (k >= panels.length) return;
              fill(panels[k++]).then(function () {
                setTimeout(next, 120);
              });
            })();
          },
          { threshold: 0.35 }
        );
        warmer.observe(band);
      }

      if (row) row.addEventListener('scroll', function () {
        if (cur !== null) placePointer(cur);
      });
      document.addEventListener(EVENT, function () {
        panels.forEach(function (p) {
          p.v2Fill = null;
          p.v2Filled = false;
        });
        if (cur !== null) {
          var p = panelFor(cur);
          if (p) fill(p).then(function () { p.v2Filled = true; });
        }
      });
      window.addEventListener('resize', function () {
        if (cur !== null) placePointer(cur);
      });
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     12. THE SHEET PICKER
     Three states, one question at a time: brands as big tiles; then the brands shrunk to a row of chips with the
     models as big tiles; then both shrunk to chips and one button. Every answer already given stays on screen,
     small, and is one tap from being changed.

     THE SHRINK IS THE POINT
     When a tile is tapped its position is measured, the next state is rendered, and the chip that now stands for
     the same choice is animated FROM the tile's old box to its own (a FLIP). So the visitor watches the thing they
     tapped get small and move out of the way, rather than seeing one screen replaced by another. Everything else in
     the new state fades up after it.
     -------------------------------------------------------------------------------------------------------------- */
  function initSheetPicker(root) {
    (root || document).querySelectorAll('[data-v2-spick]:not([data-v2-ready])').forEach(function (box) {
      box.setAttribute('data-v2-ready', '');
      var stage = box.querySelector('[data-v2-spick-stage]');
      var q = box.querySelector('[data-v2-spick-q]');
      if (!stage) return;

      var DATA = [];
      try {
        var src = document.getElementById(box.getAttribute('data-src') || '');
        DATA = src ? JSON.parse(src.textContent) || [] : [];
      } catch (e) {
        DATA = [];
      }
      DATA = DATA.filter(function (d) {
        return d && d.m && d.m.length;
      });
      if (!DATA.length) return;
      /* APPLE'S OLDEST MODELS IN THE PHONE MENU (2026-10-28, asked: "the model switch in the mobile menu doesn't show older
         Apple Watch models"). Series 1 to 6 have no collection of their own (the desktop menu links them to the brand page,
         2026-10-27); here they are one tile after Series 7, leading to the Apple Watch straps page. Only this picker's own
         copy of the list: in the shared list the brand page would count as that watch's page everywhere. */
      (function () {
        var lg = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
        var OLD = { nl: 'Series 1 t/m 6', de: 'Series 1 bis 6', fr: 'Series 1 à 6', es: 'Series 1 a 6' }[lg] || 'Series 1 to 6';
        DATA.forEach(function (d) {
          if (!/apple/i.test(d.b) || !d.h || d.h === '#') return;
          if (d.m.some(function (m) { return /series [1-6]\b/i.test(m.t); })) return;
          var at = -1;
          d.m.forEach(function (m, j) { if (/series 7\s*$/i.test(m.t)) at = j; });
          var ref = at >= 0 ? d.m[at] : d.m[d.m.length - 1];
          d.m = d.m.slice();
          d.m.splice(at >= 0 ? at + 1 : d.m.length, 0, { t: d.b + ' ' + OLD, u: d.h, s: ref.s });
        });
      })();

      var T = {
        q: box.getAttribute('data-t-q') || '',
        model: box.getAttribute('data-t-model') || '',
        go: box.getAttribute('data-t-go') || '%s',
        change: box.getAttribute('data-t-change') || '',
        more: box.getAttribute('data-t-more') || '',
        count: box.getAttribute('data-t-count') || '%s',
        /* one model is singular ("1 modellen" on Oozoo, 2026-10-19) */
        one: ({ nl: '1 model', de: '1 Modell', fr: '1 modèle', es: '1 modelo' })[(document.documentElement.lang || 'en').slice(0, 2)] || '1 model',
        back: box.getAttribute('data-t-back') || '',
        dk: box.getAttribute('data-t-dk') || '',
        clear: box.getAttribute('data-t-clear') || '',
        dkUrl: box.getAttribute('data-dk-url') || ''
      };
      /* Four brands and a "more" tile (2026-10-14, asked: "only show 4 from the switch module when no model is chosen"),
         in the market's sales order: the same quick_brands list the homepage pills use (data-quick), then the rest. */
      var FIRST = 4;
      var QUICK = String(box.getAttribute('data-quick') || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
      var ORDER = DATA.map(function (d, i) { return i; }).sort(function (a, b) {
        var qa = QUICK.indexOf(String(DATA[a].b).toLowerCase()), qb = QUICK.indexOf(String(DATA[b].b).toLowerCase());
        return (qa < 0 ? 99 : qa) - (qb < 0 ? 99 : qb) || a - b;
      });
      var bi = -1;
      var mi = -1;
      var si = -1;
      var showAll = false;

      /* SERIES AS A STEP (asked 2026-10-05: "the list isn't structured, a lot of scrolling"). A brand with many models
         first shows its series (Galaxy Watch 9, Galaxy Watch 8, ...) with a count; a tap shows only that series'
         models. The series come from the brand menu (m.s); a model without one stays a tile of its own. */
      function groupsOf(b) {
        var d = DATA[b], out = [], at = {};
        if (!d) return null;
        d.m.forEach(function (m, j) {
          var n = String(m.s || '').replace(/\s+(serie|series)$/i, '').trim();
          if (!n) { out.push({ n: '', ix: [j] }); return; }
          if (at[n] === undefined) { at[n] = out.length; out.push({ n: n, ix: [] }); }
          out[at[n]].ix.push(j);
        });
        var real = out.filter(function (g) { return g.n && g.ix.length > 1; }).length;
        return d.m.length > 12 && real >= 2 ? out : null;
      }

      function esc(t) {
        return String(t).replace(/[&<>"]/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
        });
      }

      /* "Apple Watch Series 12" under a lit "Apple Watch" chip says the brand twice and wraps to two lines. The tile
         and the chip drop it; the button keeps the full name, because that one is read on its own. */
      function short(t, brand) {
        var b = String(brand || '').toLowerCase();
        var s = String(t);
        if (b && s.toLowerCase().indexOf(b + ' ') === 0) return s.slice(b.length + 1);
        return s;
      }

      // a watch chosen anywhere else on the site starts the picker at its last step
      function fromWatch(w) {
        bi = -1;
        mi = -1;
        if (!w || !w.url) return;
        for (var i = 0; i < DATA.length; i++) {
          for (var j = 0; j < DATA[i].m.length; j++) {
            if (DATA[i].m[j].u === w.url) {
              bi = i;
              mi = j;
              return;
            }
          }
        }
      }

      /* WHERE YOU ARE, ONE LINE (2026-10-17, asked: "the sliding left to right can be made nicer"): the sideways brand
         chips and their arrow are gone. The chosen brand (and series) read as a path; the round arrow steps back one
         level. Same height as the chip row it replaces. */
      function crumb(series) {
        return (
          '<div class="v2-spick__crumb v2-spick__in">' +
          '<button type="button" class="v2-spick__up" data-up aria-label="' + esc(T.back) + '">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<button type="button" class="v2-spick__path' + (series ? '' : ' is-last') + '" data-k="b' + bi + '" data-home>' + esc(DATA[bi].b) + '</button>' +
          (series ? '<span class="v2-spick__sep" aria-hidden="true">/</span><span class="v2-spick__path is-last">' + esc(series) + '</span>' : '') +
          '</div>'
        );
      }
      function brandChips() { return crumb(''); }
      /* "don't know your model?" and, once something is chosen, "Wissen" beside it (2026-10-17, asked); the button
         uses the site-wide data-v2-clear action, so every picker and the saved watch are reset together */
      function dunno(chosen) {
        var dk = !chosen && T.dk && T.dkUrl ? '<a class="v2-spick__dk" href="' + esc(T.dkUrl) + '">' + esc(T.dk) + '</a>' : '';
        var saved = null; try { saved = readWatch(); } catch (e) {}
        var cl = T.clear && (bi >= 0 || (saved && saved.url)) ? '<button type="button" class="v2-spick__clear" data-v2-clear>' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>' + esc(T.clear) + '</button>' : '';
        /* a chosen model: "Wissen" sits beside its "Wijzig" chip instead of on a row of its own (2026-10-28, asked) */
        if (chosen) return '';
        return dk || cl ? '<div class="v2-spick__foot">' + dk + cl + '</div>' : '';
      }

      function html() {
        if (bi < 0) {
          var list = showAll ? ORDER : ORDER.slice(0, FIRST);
          return (
            '<div class="v2-spick__grid v2-spick__in">' +
            list
              .map(function (i) {
                var d = DATA[i];
                return (
                  '<button type="button" class="v2-spick__tile" data-k="b' + i + '" data-b="' + i + '">' +
                  esc(d.b) +
                  '<small>' + esc(d.m.length === 1 ? T.one : T.count.replace('%s', d.m.length)) + '</small></button>'
                );
              })
              .join('') +
            (!showAll && DATA.length > FIRST
              ? '<button type="button" class="v2-spick__tile v2-spick__tile--more" data-more>' + esc(T.more) +
                '<small>+' + (DATA.length - FIRST) + '</small></button>'
              : '') +
            '</div>'
          );
        }
        var models = DATA[bi].m;
        var groups = groupsOf(bi);
        if (mi < 0 && groups && si < 0) {
          return (
            brandChips() +
            '<div class="v2-spick__grid v2-spick__grid--series v2-spick__in">' +
            groups
              .map(function (g, gi) {
                if (!g.n || g.ix.length === 1) {
                  var j = g.ix[0];
                  return '<button type="button" class="v2-spick__tile" data-k="m' + j + '" data-m="' + j + '">' + esc(short(models[j].t, DATA[bi].b)) + '</button>';
                }
                return '<button type="button" class="v2-spick__tile v2-spick__tile--series" data-k="s' + gi + '" data-s="' + gi + '">' +
                  esc(short(g.n, DATA[bi].b)) + '<small>' + esc(g.ix.length === 1 ? T.one : T.count.replace('%s', g.ix.length)) + '</small></button>';
              })
              .join('') +
            '</div>'
          );
        }
        if (mi < 0 && groups && si >= 0 && groups[si]) {
          return (
            crumb(short(groups[si].n, DATA[bi].b)) +
            '<div class="v2-spick__grid v2-spick__grid--models v2-spick__in">' +
            groups[si].ix
              .map(function (j) {
                return '<button type="button" class="v2-spick__tile" data-k="m' + j + '" data-m="' + j + '">' + esc(short(models[j].t, DATA[bi].b)) + '</button>';
              })
              .join('') +
            '</div>'
          );
        }
        if (mi < 0) {
          return (
            brandChips() +
            '<div class="v2-spick__grid v2-spick__grid--models v2-spick__in">' +
            models
              .map(function (m, j) {
                return '<button type="button" class="v2-spick__tile" data-k="m' + j + '" data-m="' + j + '">' + esc(short(m.t, DATA[bi].b)) + '</button>';
              })
              .join('') +
            '</div>'
          );
        }
        var chosen = models[mi];
        return (
          brandChips() +
          '<div class="v2-spick__chosen">' +
          '<button type="button" class="v2-spick__chip is-on v2-spick__chip--model" data-k="m' + mi + '" data-edit>' +
          esc(short(chosen.t, DATA[bi].b)) + '<span>' + esc(T.change) + '</span></button>' +
          (T.clear ? '<button type="button" class="v2-spick__clear" data-v2-clear>' +
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>' + esc(T.clear) + '</button>' : '') +
          '</div>' +
          '<a class="v2-btn v2-btn--accent v2-spick__go v2-spick__in" href="' + esc(chosen.u) + '">' +
          esc(T.go.replace('%s', chosen.t)) +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</a>'
        );
      }

      function render(fromKey, fromRect) {
        if (q) {
          /* the word "smartwatch" in the accent, like the hero's "Kies je smartwatch" (2026-10-21) */
          var qt = bi >= 0 && mi < 0 ? T.model : T.q;
          q.innerHTML = esc(qt).replace(/(smartwatch|Smartwatch)/, '<span class="v2-acc-w">$1</span>');
        }
        stage.innerHTML = html() + dunno(mi >= 0); /* a chosen model keeps only "Wissen" */
        var row = null; /* the sideways chip row is gone (2026-10-17) */
        if (row && row.children.length > 3) {
          var hint = document.createElement('button');
          hint.type = 'button';
          hint.className = 'v2-spick__more';
          hint.setAttribute('aria-hidden', 'true');
          hint.tabIndex = -1;
          hint.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          row.parentNode.insertBefore(hint, row.nextSibling);
          var wrapS = document.createElement('div');
          wrapS.className = 'v2-spick__chipwrap';
          row.parentNode.insertBefore(wrapS, row);
          wrapS.appendChild(row);
          wrapS.appendChild(hint);
          var endCheck = function () { wrapS.classList.toggle('is-end', row.clientWidth > 0 && row.scrollLeft + row.clientWidth >= row.scrollWidth - 4); };
          row.addEventListener('scroll', endCheck, { passive: true });
          hint.addEventListener('click', function () { row.scrollBy({ left: row.clientWidth * 0.7, behavior: 'smooth' }); });
          // checked after the browser's own layout (a ResizeObserver), not forced mid-script (2026-10-14)
          if (window.ResizeObserver) new ResizeObserver(endCheck).observe(row); else endCheck();
          if (!reduceMotion && !window.__v2ChipNudged && row.clientWidth > 0) {
            window.__v2ChipNudged = true;
            setTimeout(function () { row.scrollTo({ left: 56, behavior: 'smooth' }); setTimeout(function () { row.scrollTo({ left: 0, behavior: 'smooth' }); }, 650); }, 500);
          }
        }
        if (!fromKey || !fromRect || reduceMotion) return;
        var to = stage.querySelector('[data-k="' + fromKey + '"]');
        if (!to) return;
        var r = to.getBoundingClientRect();
        if (!r.width || !r.height) return;
        // FLIP: start the chip where the tile was, and let it travel to where it belongs
        to.style.transition = 'none';
        to.style.transformOrigin = '0 0';
        to.style.transform =
          'translate(' + (fromRect.left - r.left) + 'px,' + (fromRect.top - r.top) + 'px) scale(' +
          fromRect.width / r.width + ',' + fromRect.height / r.height + ')';
        void to.offsetWidth;
        to.style.transition = 'transform 0.46s var(--v2-ease-open)';
        to.style.transform = '';
      }

      stage.addEventListener('click', function (ev) {
        var t = ev.target.closest ? ev.target.closest('button') : null;
        if (!t || !stage.contains(t)) return;
        var rect = t.getBoundingClientRect();
        var key = t.getAttribute('data-k');

        if (t.hasAttribute('data-more')) {
          showAll = true;
          render();
          return;
        }
        if (t.hasAttribute('data-edit')) {
          mi = -1;
          si = -1;
          render();
          return;
        }
        if (t.hasAttribute('data-s')) {
          si = parseInt(t.getAttribute('data-s'), 10);
          render();
          stage.scrollIntoView({ block: 'nearest' });
          return;
        }
        if (t.hasAttribute('data-up') || t.hasAttribute('data-home')) {
          /* one level up: a series back to the brand's series, otherwise back to all brands */
          if (t.hasAttribute('data-up')) {
            if (mi >= 0) mi = -1;
            else if (si >= 0) si = -1;
            else bi = -1;
          } else if (si >= 0 || mi >= 0) { si = -1; mi = -1; }
          else bi = -1;
          render();
          return;
        }
        if (t.hasAttribute('data-sback')) {
          si = -1;
          render();
          return;
        }
        if (t.hasAttribute('data-b')) {
          var nb = parseInt(t.getAttribute('data-b'), 10);
          if (t.classList.contains('is-on') && t.classList.contains('v2-spick__chip')) {
            // tapping the lit brand chip is "I want a different brand": back to the big tiles
            bi = -1;
            mi = -1;
            si = -1;
            render();
            return;
          }
          bi = nb;
          mi = -1;
          si = -1;
          render('b' + nb, t.classList.contains('v2-spick__tile') ? rect : null);
          return;
        }
        if (t.hasAttribute('data-m')) {
          mi = parseInt(t.getAttribute('data-m'), 10);
          var m = DATA[bi].m[mi];
          /* The choice is written straight away, not when the button is pressed. The header pill, the bestsellers
             rail and every other picker on the page follow it at once, so the visitor sees the page change
             behind the sheet as they choose. */
          writeWatch({ brand: DATA[bi].b, model: m.t, url: m.u });
          render(key, rect);
        }
      });

      // stays in step with a watch chosen in the hero, the band or anywhere else
      document.addEventListener(EVENT, function (ev) {
        var before = bi + ':' + mi;
        fromWatch(ev.detail);
        if (bi + ':' + mi !== before) render();
      });

      fromWatch(readWatch());
      render();
    });
  }

  function initHeader(root) {
    var hdr = (root || document).querySelector('[data-v2-hdr]:not([data-v2-hdr-ready])');
    if (!hdr) return;
    hdr.setAttribute('data-v2-hdr-ready', '');

    var scrim = hdr.querySelector('[data-v2-mega-scrim]');
    var panels = {};
    hdr.querySelectorAll('[data-v2-mega]').forEach(function (p) {
      panels[p.getAttribute('data-v2-mega')] = p;
    });
    var triggers = [].slice.call(hdr.querySelectorAll('[data-v2-mega-open]'));
    var sheet = hdr.querySelector('[data-v2-sheet]');
    var openBtn = hdr.querySelector('[data-v2-sheet-open]');
    var closeBtn = hdr.querySelector('[data-v2-sheet-close]');
    var current = null;
    var locked = false; // opened by click, so a pointer leaving the header must not close it
    /* Keyed on the ELEMENT, not on its class name. Both mega panels are `.v2-mega`, so a className key made the two
       share one slot and showing either one cancelled the other's pending hide. */
    function show(el) {
      if (!el) return;
      if (el.v2HideTimer) {
        clearTimeout(el.v2HideTimer);
        el.v2HideTimer = 0;
      }
      el.hidden = false;
      /* The browser needs one frame of the closed state to animate from. That used to be a forced reflow
         (el.offsetWidth) inside the tap, which laid out the whole 1,771-node header before anything could paint:
         434-525ms on a slowed phone for the sheet. Two frames later costs nothing and the tap paints at once. */
      if (el.v2OpenRaf) cancelAnimationFrame(el.v2OpenRaf);
      el.v2OpenRaf = requestAnimationFrame(function () {
        el.v2OpenRaf = requestAnimationFrame(function () {
          el.v2OpenRaf = 0;
          if (!el.hidden) el.classList.add('is-open');
        });
      });
    }

    function hide(el) {
      if (!el || el.hidden) return;
      if (el.v2OpenRaf) { cancelAnimationFrame(el.v2OpenRaf); el.v2OpenRaf = 0; }
      el.classList.remove('is-open');
      if (el.v2HideTimer) clearTimeout(el.v2HideTimer);
      el.v2HideTimer = setTimeout(function () {
        el.hidden = true;
        el.v2HideTimer = 0;
      }, 340);
    }

    function openMega(key) {
      if (current === key) return;
      announcePanel('mega');
      closeMega(true);
      var p = panels[key];
      if (!p) return;
      current = key;
      megaDepth = 0;
      lpUi('mega', 'open', key, 0);
      show(p);
      show(scrim);
      /* the panel scrolls inside itself below this point (2026-10-20: cut off on laptop screens) */
      var pt = p.getBoundingClientRect().top;
      if (pt > 0) document.documentElement.style.setProperty('--v2-mega-top', Math.round(pt) + 'px');
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', String(t.getAttribute('data-v2-mega-open') === key));
      });
    }

    function closeMega(skipScrim) {
      if (!current) return;
      lpUi('mega', 'close', current, megaDepth);
      /* the next open starts fresh: no brand, series or model list left open from last time (2026-10-21, asked) */
      setTimeout(function () {
        try {
          document.dispatchEvent(new CustomEvent('swb-v2:mega-closed'));
        } catch (e) {
          /* ignore */
        }
      }, 320);
      hide(panels[current]);
      current = null;
      locked = false;
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      if (!skipScrim) hide(scrim);
    }
    /* other code can close the panel too: the "Change" button in the for-your-watch bar (2026-10-22) */
    document.addEventListener('swb-v2:mega-close', function () { closeMega(); });

    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    /* v2MegaGrace: a hover-opened panel closes a moment after the pointer leaves it, not on the first pixel outside */
    var leaveTimer = 0;
    function keepOpen() { clearTimeout(leaveTimer); leaveTimer = 0; }
    function softClose() {
      if (locked || !current) return;
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(function () { leaveTimer = 0; if (!locked) closeMega(); }, 280);
    }

    triggers.forEach(function (t) {
      var key = t.getAttribute('data-v2-mega-open');
      t.addEventListener('click', function (ev) {
        ev.preventDefault();
        /* menu variant "side" (2026-10-21, Burga-style test): the bar's menus open the side sheet, as on a phone */
        if (document.documentElement.getAttribute('data-menu') === 'side') {
          openSheet();
          return;
        }
        // a second click on an already LOCKED panel closes it; a click on a hover-opened one locks it in place
        if (current === key && locked) {
          closeMega();
          return;
        }
        if (current !== key) openMega(key);
        locked = true;
      });
      if (fine) {
        t.addEventListener('pointerenter', function () {
          if (locked) return; // a locked panel is not replaced by hovering its neighbour
          if (document.documentElement.getAttribute('data-menu') === 'side') return;
          if (window.swbV2DrawerOpen && window.swbV2DrawerOpen()) return; // passing over the header must not cover the cart
          /* hover intent (2026-10-15, asked): a pointer passing over the bar does not open it, a third of a second on it does */
          clearTimeout(t._v2hover);
          t._v2hover = setTimeout(function () { if (!locked) openMega(key); }, 320);
        });
        t.addEventListener('pointerleave', function () { clearTimeout(t._v2hover); });
      }
    });

    if (fine) {
      // leaving the whole header closes it, so the panel does not hang around after the pointer moves to the page
      hdr.addEventListener('pointerleave', softClose);
      /* back on the bar or a panel before the grace runs out: stay open (2026-10-16, asked: hovering from "Alle bandjes"
         down to a brand closed the menu; it now closes only once the pointer has really left the menu) */
      hdr.addEventListener('pointerover', function (ev) {
        if (scrim && (ev.target === scrim || scrim.contains(ev.target))) return;
        keepOpen();
      });
    }

    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape') return;
      closeMega();
      closeSheet();
      closeWatch();
    });

    // something else opened: get out of its way
    document.addEventListener(PANEL_EVENT, function (ev) {
      if (ev.detail !== 'mega') closeMega();
      if (ev.detail !== 'watch') closeWatch();
      if (ev.detail !== 'sheet') closeSheet();
    });

    /* the scrim lives inside the header, so leaving the panel onto the scrim never fired the header's pointerleave
       and a hover-opened mega menu stayed open (desktop sweep 2026-10-15) */
    if (scrim) scrim.addEventListener('pointerenter', softClose);
    if (scrim) {
      scrim.addEventListener('click', function () {
        closeMega();
        closeSheet();
      });
    }

    /* Every panel that can be locked open needs a way out that is not "guess that Escape works". Delegated, so the
       two mega panels and the watch popover are all served by one handler. */
    hdr.addEventListener('click', function (ev) {
      if (!ev.target.closest) return;
      if (ev.target.closest('[data-v2-mega-close]')) {
        ev.preventDefault();
        closeMega();
      } else if (ev.target.closest('[data-v2-watch-close]')) {
        ev.preventDefault();
        closeWatch();
      }
    });

    /* ---- mobile sheet ---- */
    function openSheet() {
      if (!sheet) return;
      sheetDepth = 0;
      lpUi('sheet', 'open', '', 0);
      announcePanel('sheet');
      show(sheet);
      show(scrim);
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeSheet() {
      if (!sheet || sheet.hidden) return;
      lpUi('sheet', 'close', '', sheetDepth);
      hide(sheet);
      if (!current) hide(scrim);
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        if (sheet && !sheet.hidden) closeSheet();
        else openSheet();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);

    /* ---- publish the island height, and let the hero slide up underneath it ----
       The island is sticky, so it occupies flow space and the first section starts BELOW it, leaving a band of page
       background above the hero. Measuring it into a custom property lets the hero take that band back with a
       negative margin and re-pad its own content, which is the only way the photo reaches the top of the page
       without hardcoding a header height that changes with the logo. */
    function measure() {
      var h = Math.round(hdr.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--v2-hdr-h', h + 'px');
      // the USP pill sticks above the island, so the island's own sticky offset is that pill's height
      var ann = document.querySelector('.shopify-section--swb-v2-ann');
      var ah = ann ? Math.round(ann.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--v2-ann-h', ah + 'px');
    }
    /* measured by a ResizeObserver (2026-10-14): it reports after the browser's own layout, so this no longer forces
       a synchronous layout of the whole page mid-script (the first one of the page, ~180ms on a throttled phone) */
    if (window.ResizeObserver) {
      var annEl = document.querySelector('.shopify-section--swb-v2-ann');
      var ro = new ResizeObserver(function (entries) {
        entries.forEach(function (e) {
          var bb = e.borderBoxSize && (e.borderBoxSize[0] || e.borderBoxSize);
          var hh = Math.round(bb && bb.blockSize != null ? bb.blockSize : e.contentRect.height);
          if (e.target === hdr) { if (hh > 0) document.documentElement.style.setProperty('--v2-hdr-h', hh + 'px'); }
          else document.documentElement.style.setProperty('--v2-ann-h', hh + 'px');
        });
        if (typeof publishLine === 'function') publishLine();
      });
      ro.observe(hdr);
      if (annEl) ro.observe(annEl); else document.documentElement.style.setProperty('--v2-ann-h', '0px');
    } else {
      measure();
      window.addEventListener('resize', measure);
    }

    /* Which pages get the banner-behind-the-island treatment? Not just the home page. The first section in <main> is
       treated as a banner when its media is FULL WIDTH and ABSOLUTELY POSITIONED, which is the shape every full
       bleed hero on this store uses and which in-flow content images never match. Anything else is left alone, so a
       normal page with a picture near the top is not dragged under the header. */
    /* the early script floated this page's first section; a banner was found after all, so take the float off */
    function unfloat() {
      var de = document.documentElement;
      if (!de.hasAttribute('data-v2-early-float')) return;
      de.classList.remove('v2-hdr-float');
      de.removeAttribute('data-v2-early-float');
      var ff = document.querySelector('[data-v2-floatfirst]');
      if (ff) ff.removeAttribute('data-v2-floatfirst');
    }
    function markHero() {
      // already decided while the page parsed (the early script at the end of swb-header-v2.liquid)
      var de0 = document.documentElement;
      if (de0.classList.contains('v2-hdr-over')) return;
      if (de0.classList.contains('v2-hdr-float') && !de0.hasAttribute('data-v2-early-float')) return;
      var main = document.querySelector('main, [role="main"]');
      if (!main) return;
      /* The common case first, and without touching layout. Walking the sections with offsetHeight below forced a
         full layout of the page before it had painted, measured at 340ms on a 4x slowed phone. A v2 hero in one of
         the first two sections IS the answer, whatever their heights. */
      var hero = main.querySelector('.v2-hero');
      if (hero) {
        var sec = hero.closest('main > *');
        if (sec && (sec === main.firstElementChild || sec.previousElementSibling === main.firstElementChild)) {
          hero.setAttribute('data-v2-heroish', '');
          unfloat(); document.documentElement.classList.add('v2-hdr-over');
          return;
        }
      }
      var first = main.firstElementChild;
      while (first && first.offsetHeight === 0) first = first.nextElementSibling;
      if (!first) return;
      if (first.querySelector('.v2-hero')) {
        first.querySelector('.v2-hero').setAttribute('data-v2-heroish', '');
        unfloat(); document.documentElement.classList.add('v2-hdr-over');
        return;
      }
      var media = first.querySelector('img, video');
      if (!media) return;
      var r = media.getBoundingClientRect();
      if (r.width < window.innerWidth * 0.92) return;
      if (r.height < 200) return;
      var holder = media.parentElement;
      var absolute = false;
      for (var n = 0; n < 3 && holder && holder !== first; n++) {
        if (getComputedStyle(holder).position === 'absolute') absolute = true;
        holder = holder.parentElement;
      }
      if (getComputedStyle(media).position === 'absolute') absolute = true;
      if (!absolute) return;
      first.setAttribute('data-v2-heroish', '');
      unfloat(); document.documentElement.classList.add('v2-hdr-over');
    }
    markHero();
    /* ---- every other page: the island floats, the page runs underneath it ----
       markHero only fires for pages that open with a full-bleed banner. Everything else - collections, products,
       the cart, search, plain pages - had the island sitting in its own strip of page background, with the content
       starting underneath it. That is the "boxed" look the homepage does not have.

       The fix touches no template. The first section is pulled UP behind the header by exactly the header's height
       and padded back DOWN by the same amount, so at scroll zero nothing moves at all - but its box, and whatever
       background it has, now reaches the top of the page, and once the page scrolls the content passes behind a
       frosted island instead of disappearing under a white one. The section's own original top padding is read
       first and added back, so a section that already had breathing room keeps it. */
    function floatPages() {
      var de = document.documentElement;
      if (de.classList.contains('v2-hdr-over')) return; // a real banner page already gets the full treatment
      if (de.classList.contains('v2-hdr-float')) return; // already floated while the page parsed
      if (hdr.getAttribute('data-v2-float') === 'off') return;
      var main = document.querySelector('main, [role="main"]');
      if (!main) return;
      var first = main.firstElementChild;
      while (first && first.offsetHeight === 0) first = first.nextElementSibling;
      if (!first) return;
      var pad = parseFloat(getComputedStyle(first).paddingTop) || 0;
      first.style.setProperty('--v2-float-pad', pad + 'px');
      first.setAttribute('data-v2-floatfirst', '');
      de.classList.add('v2-hdr-float');
    }
    floatPages();

    /* ---- the island's bottom edge, published the way the theme does it ----
       Impact's own header sets --sticky-area-height and everything built on the theme sticks to it: the sale page's
       filter rail and sidebar, the all-straps hub's chip row and sidebar, the theme's facet bars. Our island replaced
       that header, so the variable stayed 0 and all of them stuck at the very top, behind the island. Publishing the
       real line puts every one of them under it at once, and restick() below then skips them (they already clear it). */
    function publishLine() {
      var grp = hdr.closest('.shopify-section') || hdr;
      var ann = document.querySelector('.shopify-section--swb-v2-ann');
      var line = Math.round((ann ? ann.getBoundingClientRect().height : 0) + grp.getBoundingClientRect().height);
      if (line) document.documentElement.style.setProperty('--sticky-area-height', line + 'px');
      return line;
    }
    if (!window.ResizeObserver) publishLine(); // otherwise the header's ResizeObserver above publishes it, after layout

    /* ---- anything else that sticks goes UNDER the island, not behind it ----
       Pages bring their own sticky things: a filter bar on a collection, an add-to-cart bar on a product page, a
       table of contents on a long article. Left alone they stick to top:0 and slide under the island, where the
       island hides them. This finds anything sticky or fixed near the top of the viewport, outside the header
       itself, and moves its stick point to the island's bottom edge, adding back whatever offset it had.

       What it deliberately leaves alone: drawers and dialogs (they are meant to cover everything), anything taller
       than 60% of the screen (that is a panel, not a bar), and anything inside the header group. It runs when the
       page is idle rather than at load, because it has to read a computed style for every element, and again on
       resize. window.swbV2.restick() reruns it for anything that becomes sticky later. */
    function restick(extra) {
      if (extra && !extra.length) extra = null;
      var grp = hdr.closest('.shopify-section') || hdr;
      var line = publishLine();
      if (!line) return;
      /* NOT EVERY ELEMENT ANY MORE. Reading the computed style of all ~4,000 nodes in <main> cost 290ms on a 4x slowed
         phone, twice per page. Sticky bars announce themselves in their class or inline style almost without
         exception, and the rare one that does not is caught by the point test on scroll below, which reads only
         what is actually sitting under the island. */
      var all = [].slice.call(document.querySelectorAll(
        '[class*="sticky" i], [class*="fixed" i], [style*="sticky"], [style*="fixed"], [data-sticky], sticky-header, body > *:not(script):not(style):not(link)'
      )).concat(extra || []);
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.closest('.shopify-section-group-header-group') || grp.contains(el)) continue;
        if (el.closest('[role="dialog"], [aria-modal="true"], dialog, x-drawer, cart-drawer, search-drawer, .drawer')) continue;
        var cs = getComputedStyle(el);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
        var orig = el.hasAttribute('data-v2-orig-top') ? parseFloat(el.getAttribute('data-v2-orig-top')) : parseFloat(cs.top);
        if (isNaN(orig) || orig >= line) continue;
        var r = el.getBoundingClientRect();
        if (r.height > window.innerHeight * 0.6) continue;
        /* Hidden things and overlays are not bars in the way. The switch module's overlay and the loyalty backdrop
           are fixed, 0px while closed, and were being moved 126px down, so they would have opened with a gap. */
        if (!r.height || /overlay|backdrop|modal|popup|drawer/i.test(String(el.className))) continue;
        if (cs.position === 'fixed' && r.top > line) continue; // a fixed thing sitting lower down is not in the way
        if (!el.hasAttribute('data-v2-orig-top')) el.setAttribute('data-v2-orig-top', String(orig));
        el.style.top = line + Math.max(0, orig) + 'px';
        el.setAttribute('data-v2-stuck-under', '');
      }
    }
    var idle = window.requestIdleCallback || function (f) {
      return setTimeout(f, 600);
    };
    idle(function () { restick(); });
    /* The point test: when scrolling settles, whatever sits just under the island is checked, with its ancestors,
       for being stuck there. A handful of style reads per scroll stop instead of thousands per page. */
    var stopT = 0;
    window.addEventListener('scroll', function () {
      clearTimeout(stopT);
      stopT = setTimeout(function () {
        var y = Math.round((document.querySelector('.shopify-section--swb-v2-ann') || { getBoundingClientRect: function () { return { height: 0 }; } }).getBoundingClientRect().height + (hdr.closest('.shopify-section') || hdr).getBoundingClientRect().height) + 4;
        var hits = [];
        [0.15, 0.5, 0.85].forEach(function (fx) {
          var stack = document.elementsFromPoint ? document.elementsFromPoint(window.innerWidth * fx, y) : [];
          stack.forEach(function (el) {
            for (var n = el, d = 0; n && n !== document.body && d < 6; n = n.parentElement, d++) {
              if (hits.indexOf(n) < 0 && !n.hasAttribute('data-v2-stuck-under')) hits.push(n);
            }
          });
        });
        var stuck = hits.filter(function (n) {
          var p = getComputedStyle(n).position;
          return p === 'sticky' || p === 'fixed';
        });
        if (stuck.length) restick(stuck);
      }, 220);
    }, { passive: true });
    setTimeout(restick, 2500); // apps that inject their sticky bars late
    var rt = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(restick, 250);
    });
    window.swbV2Restick = restick;
    // the logo is eager but still changes layout height when it decodes
    var logo = hdr.querySelector('.v2-hdr__logoimg');
    if (logo && !logo.complete) logo.addEventListener('load', measure);

    /* ---- brand -> models inside the straps panel ---- */
    // NOT [data-v2-brand]: that is the picker's <select>, which lives in this same header and would be
    // picked up here, then blank the models column the moment it was hovered.
    var brandBtns = [].slice.call(hdr.querySelectorAll('[data-v2-megabrand]'));
    var seriesSets = [].slice.call(hdr.querySelectorAll('[data-v2-series]'));
    var seriesBtns = [].slice.call(hdr.querySelectorAll('[data-v2-seriesopen]'));
    var modelSets = [].slice.call(hdr.querySelectorAll('[data-v2-gmodels]'));
    var modelCol = hdr.querySelector('[data-v2-modelcol]');
    var modelHead = hdr.querySelector('[data-v2-modelhead]');

    /* Third level. Every series of every brand is already in the DOM, so opening one is a class toggle and the
       panel never waits on anything. */
    function showSeriesModels(key) {
      if (key) megaDepth = Math.max(megaDepth, 2);
      seriesBtns.forEach(function (b) {
        var on = b.getAttribute('data-v2-seriesopen') === key;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-expanded', String(on));
      });
      var any = false;
      modelSets.forEach(function (m) {
        var on = m.getAttribute('data-v2-gmodels') === key;
        m.hidden = !on;
        if (on) any = true;
      });
      /* Nine of the twenty brands have no series at all. Rather than leave a labelled empty column standing there,
         the heading goes with the content. */
      if (modelHead) modelHead.hidden = !any;
      if (modelCol) modelCol.classList.toggle('is-empty', !any);
    }

    function showModels(idx) {
      megaDepth = Math.max(megaDepth, 1);
      brandBtns.forEach(function (b) {
        var on = b.getAttribute('data-v2-megabrand') === idx;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-expanded', String(on));
      });
      seriesSets.forEach(function (m) {
        m.hidden = m.getAttribute('data-v2-series') !== idx;
      });
      /* Open this brand's first series straight away, so the third column is never blank for a brand that has one.
         Picking the brand is the visitor's move; being shown its newest series for free is not a click they owe. */
      var openSet = seriesSets.filter(function (m) {
        return m.getAttribute('data-v2-series') === idx;
      })[0];
      var firstBtn = openSet ? openSet.querySelector('[data-v2-seriesopen]') : null;
      showSeriesModels(firstBtn ? firstBtn.getAttribute('data-v2-seriesopen') : '');
    }

    var seriesTimer = 0;
    seriesBtns.forEach(function (b) {
      var key = b.getAttribute('data-v2-seriesopen');
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        clearTimeout(seriesTimer);
        showSeriesModels(key);
      });
      if (fine) {
        // same dwell as the brand column, for the same reason: a pointer crossing to the models must not re-aim
        b.addEventListener('pointerenter', function () {
          clearTimeout(seriesTimer);
          seriesTimer = setTimeout(function () {
            showSeriesModels(key);
          }, 140);
        });
        b.addEventListener('pointerleave', function () {
          clearTimeout(seriesTimer);
        });
      }
    });
    var brandTimer = 0;
    /* MENU AIM (2026-10-20, Margot's video on ES: moving from Fitbit or Samsung towards their series crossed Garmin and
       Xiaomi in the next column, and the series switched to those). While the pointer is travelling towards the series
       column, inside the triangle from where it was to that column's left edge, a brand it crosses waits. The switch
       happens once the pointer stops (no move for 90ms), turns away, or rests on the brand for 900ms. */
    var aimPts = [];
    var megaPanel = brandCol0();
    function brandCol0() { return hdr.querySelector('.v2-mega__brands'); }
    function trackAim(ev) { aimPts.push({ x: ev.clientX, y: ev.clientY, t: Date.now() }); if (aimPts.length > 5) aimPts.shift(); }
    if (fine && megaPanel && megaPanel.parentElement) megaPanel.parentElement.addEventListener('pointermove', trackAim, { passive: true });
    function aimingAtSeries() {
      var set = seriesSets.filter(function (m) { return !m.hidden; })[0];
      var R = set && set.getBoundingClientRect();
      if (!R || !R.width || aimPts.length < 2) return false;
      var loc = aimPts[aimPts.length - 1], prev = aimPts[0];
      if (Date.now() - loc.t > 90) return false; /* stopped: the visitor is choosing this brand */
      if (loc.x >= R.left || loc.x <= prev.x) return false;
      var up = { x: R.left, y: R.top - 60 }, dn = { x: R.left, y: R.bottom + 60 };
      var slope = function (a, c) { return (c.y - a.y) / (c.x - a.x); };
      return slope(loc, up) < slope(prev, up) && slope(loc, dn) > slope(prev, dn);
    }
    brandBtns.forEach(function (b) {
      var idx = b.getAttribute('data-v2-megabrand');
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        clearTimeout(brandTimer);
        showModels(idx);
      });
      if (fine) {
        /* A short dwell before switching. Travelling right towards the models column passes over the brands below
           the one just chosen, and without this the selection changed under the pointer on the way to the column it
           had opened. 140ms is long enough to ignore a pass-over and short enough to feel immediate when aimed. */
        b.addEventListener('pointerenter', function () {
          clearTimeout(brandTimer);
          var t0 = Date.now();
          var attempt = function () {
            if (aimingAtSeries() && Date.now() - t0 < 900) { brandTimer = setTimeout(attempt, 80); return; }
            showModels(idx);
          };
          brandTimer = setTimeout(attempt, 140);
        });
        b.addEventListener('pointerleave', function () {
          clearTimeout(brandTimer);
        });
      }
    });

    /* Leaving the brand column entirely also cancels a pending switch, so a pointer that exits sideways into the
       models never lands a late change behind itself. */
    var brandCol = hdr.querySelector('.v2-mega__brands');
    if (brandCol) {
      brandCol.addEventListener('pointerleave', function () {
        clearTimeout(brandTimer);
      });
    }

    /* Liquid marks the first brand as open and leaves its series panel visible, but nothing has opened a SERIES yet,
       so without this the third column stands empty until the first hover. Run the same function a click would. */
    // the mega menu opens on the visitor's own brand when a watch is known (2026-10-06), else on the first brand
    function megaBrandFor(w) {
      var want = w && w.brand ? String(w.brand).toLowerCase().trim() : '';
      if (!want) return null;
      for (var i = 0; i < brandBtns.length; i++) {
        var t = brandBtns[i].textContent.toLowerCase().trim();
        if (t === want || t.indexOf(want) === 0 || want.indexOf(t) === 0) return brandBtns[i];
      }
      return null;
    }
    if (brandBtns.length) {
      var mb0 = megaBrandFor(readWatch()) || brandBtns[0];
      showModels(mb0.getAttribute('data-v2-megabrand'));
      document.addEventListener(EVENT, function (ev) {
        var b = megaBrandFor(ev.detail);
        if (b) showModels(b.getAttribute('data-v2-megabrand'));
      });
      document.addEventListener('swb-v2:mega-closed', function () {
        var b0 = megaBrandFor(readWatch()) || brandBtns[0];
        showModels(b0.getAttribute('data-v2-megabrand'));
        hdr.querySelectorAll('.v2-mega [data-v2-msub-t][aria-expanded="true"]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
          var l = document.getElementById(t.getAttribute('aria-controls'));
          if (l) l.hidden = true;
        });
        hdr.querySelectorAll('.v2-mega__col').forEach(function (c) { c.scrollTop = 0; });
      });
    }

    /* The two columns disagreed on height. The brand list is a fixed twenty entries, but a model list runs to a
       hundred and more, so the panel was sized by the models and the brands column stopped well short of the bottom
       with dead space under it. Measuring the brand column and capping the models to it makes the panel end where
       the brands end, and the models scroll inside that. Measured rather than hardcoded because the row height moves
       with the market's font and the visitor's zoom. */
    function sizeColumns() {
      if (!brandCol) return;
      var h = Math.round(brandCol.getBoundingClientRect().height);
      if (h > 120) hdr.style.setProperty('--v2-brands-h', h + 'px');
    }
    /* Measured when a panel opens, not at load: the panels are hidden at load, so the old first call read a height
       of 0, did nothing, and still forced a layout of the whole page (370ms on a slowed phone, on phones that never
       show this menu at all). */
    window.addEventListener('resize', function () {
      if (current) sizeColumns();
    });
    triggers.forEach(function (t) {
      var later = function () {
        setTimeout(sizeColumns, 60);
      };
      t.addEventListener('click', later);
      t.addEventListener('pointerenter', later);
    });

    /* ---- the watch pill ---- */
    var wpill = hdr.querySelector('[data-v2-watch-open]');
    var wpop = hdr.querySelector('[data-v2-watch-pop]');
    var wlabel = hdr.querySelector('[data-v2-watch-label]');
    if (wlabel) wlabel.classList.toggle('is-long', wlabel.textContent.trim().length > 17);

    function closeWatch() {
      if (!wpop || wpop.hidden) return;
      hide(wpop);
      if (window.swbV2IslandPop) window.swbV2IslandPop('watch', false);
      if (wpill) wpill.setAttribute('aria-expanded', 'false');
    }
    function openWatch() {
      if (!wpop) return;
      announcePanel('watch');
      closeMega();
      wpop._v2at = Date.now(); /* the click that opened it from outside must not close it on its way up (2026-10-15) */
      show(wpop);
      if (window.swbV2IslandPop) window.swbV2IslandPop('watch', true, wpop);
      if (wpill) wpill.setAttribute('aria-expanded', 'true');
    }
    if (wpill && wpop) {
      wpill.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (wpop.hidden) openWatch();
        else closeWatch();
      });
      document.addEventListener('click', function (ev) {
        if (wpop.hidden) return;
        if (Date.now() - (wpop._v2at || 0) < 400) return;
        if (wpop.contains(ev.target) || wpill.contains(ev.target)) return;
        closeWatch();
      });
      /* The legacy "Change" / "Choose your smartwatch" links (.choose__watch, e.g. the PDP compatibility box) opened
         the old switch module, a second design for the same choice. While this pill is on screen they open the pill's
         picker instead (2026-10-04); window capture runs before switch-module.js's document listener. */
      window.addEventListener('click', function (ev) {
        var t = ev.target.closest && ev.target.closest('.choose__watch');
        if (!t || hdr.contains(t) || (!wpill.getClientRects().length && document.querySelector('.switch-module'))) return; /* without the old popup on the page (lite, 2026-10-19) the header's picker always takes the link */
        ev.preventDefault();
        ev.stopPropagation();
        openWatch();
      }, true);
    }

    // keep the pill in step with whatever picker made the choice
    document.addEventListener(EVENT, function (ev) {
      var w = ev.detail;
      if (!wlabel) return;
      if (w && w.model) {
        wlabel.textContent = w.model;
        wlabel.classList.toggle('is-long', w.model.length > 17);
        if (wpill) wpill.classList.add('is-set');
      } else {
        wlabel.textContent = wlabel.getAttribute('data-empty') || '';
        if (wpill) wpill.classList.remove('is-set');
      }
    });

    var savedWatch = readWatch();
    if (savedWatch && savedWatch.model && wlabel && wlabel.textContent.trim() === (wlabel.getAttribute('data-empty') || '')) {
      wlabel.textContent = savedWatch.model;
      if (wpill) wpill.classList.add('is-set');
    }

    // a link inside the sheet navigates; make sure the scroll lock does not survive a bfcache restore
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        document.documentElement.style.overflow = '';
        if (sheet) {
          sheet.classList.remove('is-open');
          sheet.hidden = true;
        }
        if (scrim) {
          scrim.classList.remove('is-open');
          scrim.hidden = true;
        }
        closeMega();
        if (wpop && !wpop.hidden) { wpop.classList.remove('is-open'); wpop.hidden = true; if (wpill) wpill.setAttribute('aria-expanded', 'false'); }
      }
    });
    /* NO GHOST OF THE OPEN PICKER ON THE NEXT PAGE (2026-10-30, asked: "when the switch module is open and the new page
       loads, it glitches a bit"). Pages cross-fade (@view-transition), and the old page was captured with the picker
       popover (or the phone sheet) still open, so it faded out OVER the new page for a moment. pageswap fires just before
       that capture: everything that floats is put away at once, without its closing animation. */
    window.addEventListener('pageswap', function () {
      [wpop, sheet, scrim].forEach(function (el) {
        if (!el || el.hidden) return;
        if (el.v2HideTimer) { clearTimeout(el.v2HideTimer); el.v2HideTimer = 0; }
        el.classList.remove('is-open');
        el.hidden = true;
      });
      closeMega();
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     8. THE USP BAR
     One message at a time, stepped by the arrows. Autoplay is opt-in, pauses while a pointer or the keyboard is in
     the bar, and never starts under prefers-reduced-motion: a line of text that moves on its own is the thing people
     most often cannot finish reading.
     -------------------------------------------------------------------------------------------------------------- */
  function initAnnounce(root) {
    (root || document).querySelectorAll('[data-v2-ann]:not([data-v2-ann-ready])').forEach(function (bar) {
      bar.setAttribute('data-v2-ann-ready', '');
      var items = [].slice.call(bar.querySelectorAll('[data-v2-ann-item]'));
      var prev = bar.querySelector('[data-v2-ann-prev]');
      var next = bar.querySelector('[data-v2-ann-next]');
      if (items.length < 1) return;

      var cur = 0;
      var timer = 0;

      function show(i) {
        cur = (i + items.length) % items.length;
        items.forEach(function (el, n) {
          el.classList.toggle('is-on', n === cur);
        });
        try { sessionStorage.setItem('swb_ann_i', String(cur)); } catch (e) {}
      }
      /* the next page carries on with the next message instead of starting over (2026-10-16, asked) */
      try { var last = parseInt(sessionStorage.getItem('swb_ann_i'), 10); if (!isNaN(last) && items.length > 1) show(last + 1); } catch (e) {}

      // a single message needs no controls at all
      if (items.length < 2) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = 0;
        }
      }
      function start() {
        stop();
        if (reduceMotion || items.length < 2) return;
        if (bar.getAttribute('data-autoplay') !== '1') return;
        var secs = parseInt(bar.getAttribute('data-speed'), 10) || 5;
        timer = setInterval(function () {
          show(cur + 1);
        }, secs * 1000);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          show(cur - 1);
          start();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          show(cur + 1);
          start();
        });
      }
      bar.addEventListener('pointerenter', stop);
      bar.addEventListener('pointerleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      /* the same-day cutoff. Computed from the VISITOR's clock, which is the same hour as the warehouse for the
         markets this store ships from; it is a nudge, not a promise, and it simply hides itself once the cutoff has
         passed rather than showing a negative number. */
      bar.querySelectorAll('[data-v2-countdown]').forEach(function (el) {
        var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
        if (isNaN(cutoff)) return;
        function tick() {
          var now = new Date();
          var end = new Date();
          end.setHours(cutoff, 0, 0, 0);
          var ms = end - now;
          if (ms <= 0) {
            el.textContent = '';
            return;
          }
          var h = Math.floor(ms / 3600000);
          var m = Math.floor((ms % 3600000) / 60000);
          el.textContent = ' ' + (h > 0 ? h + 'h ' : '') + m + 'm';
        }
        tick();
        setInterval(tick, 30000);
      });

      /* no show(0) here: it reset every page to the first message after the head script had already picked the next one,
         so each page jumped back to the deal and the next page always opened on the same line (2026-10-17, asked) */
      var on = items.filter(function (el) { return el.classList.contains('is-on'); })[0];
      cur = on ? items.indexOf(on) : 0;
      if (!on) show(0);
      start();
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     9. INLINE SEARCH
     The form works without any of this: it has a real action and a real submit, so enter goes to /search either way.
     What follows only adds live suggestions and the open/close motion.
     -------------------------------------------------------------------------------------------------------------- */
  function initSearch(root) {
    var hdr = (root || document).querySelector('[data-v2-hdr]');
    if (!hdr || hdr.hasAttribute('data-v2-search-ready')) return;
    var bar = hdr.querySelector('[data-v2-searchbar]');
    var openBtn = hdr.querySelector('[data-v2-search-open]');
    var closeBtn = hdr.querySelector('[data-v2-search-close]');
    var input = hdr.querySelector('[data-v2-search-input]');
    var sugg = hdr.querySelector('[data-v2-sugg]');
    if (!bar || !openBtn || !input) return;
    hdr.setAttribute('data-v2-search-ready', '');
    var inl = hdr.querySelector('[data-v2-hsearch-input]');

    function open() {
      announcePanel('search');
      bar.hidden = false;
      void bar.offsetWidth; // let the browser see the closed state before transitioning
      bar.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      lpUi('search', 'open', '', 0);
      if (!input.value.trim() && window.swbV2SearchQuick) window.swbV2SearchQuick();
      try {
        input.focus();
      } catch (e) {
        /* ignore */
      }
    }
    function close() {
      if (bar.hidden) return;
      bar.classList.remove('is-open');
      bar.classList.remove('is-inline');
      bar.style.left = bar.style.right = bar.style.width = '';
      openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () {
        bar.hidden = true;
      }, 300);
    }

    openBtn.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (bar.hidden) open();
      else close();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') close();
    });
    document.addEventListener(PANEL_EVENT, function (ev) {
      if (ev.detail !== 'search') close();
    });
    document.addEventListener('click', function (ev) {
      if (bar.hidden) return;
      if (bar.contains(ev.target) || openBtn.contains(ev.target)) return;
      if (inl && inl.form && inl.form.contains(ev.target)) return;
      close();
    });

    /* ---- the field that is already open in the island (desktop) ----
       It owns no suggestion logic of its own: what is typed is copied into the bar's input and that input's own
       listeners do the work, so the two can never disagree. The bar opens in its "inline" form, which is just the
       results panel under the island; an empty field closes it again. */
    if (inl) {
      var mirror = function () {
        var v = inl.value;
        if (!v.trim()) {
          input.value = '';
          if (!(window.swbV2SearchQuick && document.activeElement === inl && window.swbV2SearchQuick())) close();
          return;
        }
        if (bar.hidden) {
          announcePanel('search');
          bar.hidden = false;
          void bar.offsetWidth;
        }
        bar.classList.add('is-open', 'is-inline');
        place();
        if (input.value !== v) {
          input.value = v;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      };
      /* The results hang from the field itself, bol-style: same left edge, a little wider than the field so a
         product row has room, and never past the island's right edge. Measured against the bar's own offset
         parent, so it follows the island wherever the header sits. */
      var place = function () {
        var host = bar.offsetParent || hdr;
        var hr = host.getBoundingClientRect();
        var fr = inl.form.getBoundingClientRect();
        var isl = hdr.querySelector('.v2-hdr__island');
        var ir = isl ? isl.getBoundingClientRect() : hr;
        // with the chat's side panel open, the results end before it rather than sliding under it
        var edge = ir.right - 12;
        var chatP = document.documentElement.classList.contains('v2-chat-side') && document.querySelector('.v2-chat__dock.is-open .v2-chat__panel');
        if (chatP) edge = Math.min(edge, chatP.getBoundingClientRect().left - 12);
        var w = Math.min(Math.max(fr.width + 160, 540), edge - ir.left - 12);
        var left = Math.max(ir.left + 12, Math.min(fr.left, edge - w)) - hr.left;
        bar.style.left = Math.round(left) + 'px';
        bar.style.right = 'auto';
        bar.style.width = Math.round(w) + 'px';
      };
      window.addEventListener('resize', function () {
        if (bar.classList.contains('is-inline')) place();
      });
      inl.addEventListener('input', mirror);
      inl.addEventListener('focus', function () {
        if (inl.value.trim()) {
          mirror();
          return;
        }
        if (!window.swbV2SearchQuick) return;
        if (bar.hidden) {
          announcePanel('search');
          bar.hidden = false;
          void bar.offsetWidth;
        }
        lpUi('search', 'focus', '', 0);
        bar.classList.add('is-open', 'is-inline');
        place();
        input.value = '';
        if (!window.swbV2SearchQuick()) close();
      });
      inl.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') {
          close();
          inl.blur();
        }
      });
    }

    /* ---- suggestions ---- */
    var timer = 0;
    var token = 0;
    var money = (document.querySelector('[data-v2-hdr]') && window.Shopify && Shopify.currency) || null;

    /* The suggest endpoint returns price as a bare decimal STRING ("17.99") with no currency at all, so it has to be
       formatted here or every suggestion shows a naked number. Shopify.currency.active is on the storefront; if
       anything is missing we fall back to the raw value rather than guessing a symbol. */
    var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var LOC = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
    var fmt = null;
    try {
      if (CUR) fmt = new Intl.NumberFormat(LOC, { style: 'currency', currency: CUR });
    } catch (e) {
      fmt = null;
    }
    function price(v) {
      if (v === null || v === undefined || v === '') return '';
      var n = parseFloat(String(v).replace(/[^0-9.,-]/g, '').replace(',', '.'));
      if (!isNaN(n) && window.swbMoney) return window.swbMoney(Math.round(n * 100));
      if (isNaN(n) || !fmt) return String(v);
      return fmt.format(n);
    }

    /* ---- the local indexes ----
       The placeholder promises brands, models and materials, so the box has to actually answer those. Watch models
       and the browse pages are already on the page as JSON (the picker and the mega menu need them anyway), so they
       are matched in memory and appear instantly, with no request at all. Only products and collections need the
       network, and they come back under their own heading rather than being the whole answer. */
    function readJson(id) {
      var el = id ? document.getElementById(id) : null;
      if (!el) return [];
      try {
        return JSON.parse(el.textContent) || [];
      } catch (e) {
        return [];
      }
    }

    var BROWSE = readJson(sugg && sugg.getAttribute('data-browse')).map(function (x) {
      return { label: x.t, url: x.u };
    });

    /* A brand menu mixes MODELS with material links: Apple's top level is Silicone, Milanese, Metal and so on. Left
       unfiltered, typing "leather" answered with "Polar Leather" and "Fitbit Leather" under a heading that says
       Watches, which is both wrong and the least useful result on the list. Anything whose model name is one of the
       material or occasion names is dropped, and the rest is deduped because several brands repeat a model name. */
    var WATCHES = [];
    (function () {
      var skip = {};
      BROWSE.forEach(function (b) {
        skip[String(b.label).toLowerCase().trim()] = 1;
      });
      ['accessories', 'accessoires', 'view all straps', 'all straps', 'fob straps'].forEach(function (k) {
        skip[k] = 1;
      });
      var seen = {};
      readJson(sugg && sugg.getAttribute('data-brands')).forEach(function (b) {
        (b.m || []).forEach(function (m) {
          var name = String(m.t || '').toLowerCase().trim();
          if (!m.u || m.u === '#' || skip[name]) return;
          // "Apple Watch Apple Watch SE": the menus often already name the brand in the model
          var label = String(m.t).toLowerCase().indexOf(String(b.b).toLowerCase()) === 0 ? m.t : b.b + ' ' + m.t;
          if (seen[label]) return;
          seen[label] = 1;
          WATCHES.push({ label: label, url: m.u });
        });
      });
    })();

    /* A prefix hit beats a hit buried in the middle, and among equals the shorter label is the tighter match, so
       "galaxy watch 7" ranks the 7 above the 7 Classic rather than whichever happened to be indexed first. */
    function match(list, q, limit) {
      var needle = q.toLowerCase();
      var hits = [];
      for (var i = 0; i < list.length; i++) {
        var pos = list[i].label.toLowerCase().indexOf(needle);
        if (pos > -1) hits.push({ item: list[i], pos: pos, len: list[i].label.length });
      }
      hits.sort(function (a, b) {
        return a.pos - b.pos || a.len - b.len;
      });
      return hits.slice(0, limit).map(function (h) {
        return h.item;
      });
    }

    function esc(t) {
      return String(t).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function group(label) {
      return '<p class="v2-sugg__g">' + esc(label) + '</p>';
    }

    function row(item, icon) {
      return (
        '<a class="v2-sugg__i v2-sugg__i--slim" href="' + item.url + '">' +
        '<span class="v2-sugg__ic">' + icon + '</span>' +
        '<span class="v2-sugg__t">' + esc(item.label) + '</span></a>'
      );
    }

    var ICON_WATCH =
      '<svg viewBox="0 0 24 24" fill="none"><rect x="7" y="7" width="10" height="10" rx="3" stroke="currentColor" stroke-width="1.8"/><path d="M9 7V4h6v3M9 17v3h6v-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    var ICON_TAG =
      '<svg viewBox="0 0 24 24" fill="none"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';

    /* QUICK LINKS IN AN EMPTY FIELD (2026-10-21, menu data: search converted best in the rollout, 32% against 14%).
       Focusing the empty field shows a short list straight away: the saved watch first, then the newest model of the
       first five brands in the menu, then the sale. Labelled "quick links", not "popular": there is no search-term
       data behind it. */
    var QUICK_T = { nl: 'Snel naar', de: 'Schnell zu', fr: 'Accès rapide', es: 'Acceso rápido' }[String(LOC).slice(0, 2)] || 'Quick links';
    var SALE_T = { nl: 'Aanbiedingen', de: 'Angebote', fr: 'Promos', es: 'Ofertas' }[String(LOC).slice(0, 2)] || 'Sale';
    function quickList() {
      var out = [];
      var seen = {};
      function add(label, url) {
        if (!label || !url || url === '#' || seen[url]) return;
        seen[url] = 1;
        out.push({ label: label, url: url });
      }
      try {
        var w = window.swbV2 && typeof window.swbV2.get === 'function' ? window.swbV2.get() : null;
        if (w && w.model && w.url) add(w.model, w.url);
      } catch (e) {
        /* ignore */
      }
      readJson(sugg && sugg.getAttribute('data-brands')).slice(0, 5).forEach(function (b) {
        var m = (b.m || []).filter(function (x) {
          return x.u && x.u !== '#' && !/^(accessor|accesor|zubeh|view all|all straps|alle )/i.test(String(x.t || ''));
        })[0];
        if (!m) return;
        var label = String(m.t).toLowerCase().indexOf(String(b.b).toLowerCase()) === 0 ? m.t : b.b + ' ' + m.t;
        add(label, m.u);
      });
      add(SALE_T, (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root.replace(/\/$/, '') : '') + '/collections/sale');
      return out.slice(0, 7);
    }
    function renderQuick() {
      if (!sugg) return false;
      var list = quickList();
      if (!list.length) return false;
      sugg.innerHTML = group(QUICK_T) + list.map(function (it, i) { return row(it, i === list.length - 1 ? ICON_TAG : ICON_WATCH); }).join('');
      sugg.hidden = false;
      return true;
    }
    window.swbV2SearchQuick = renderQuick;

    function render(products, q) {
      if (!sugg) return;
      if (!q) {
        if (!renderQuick()) {
          sugg.hidden = true;
          sugg.innerHTML = '';
        }
        return;
      }
      var watches = match(WATCHES, q, 4);
      var browse = match(BROWSE, q, 3);
      var html = '';

      if (watches.length) {
        html += group(sugg.getAttribute('data-g-watch') || '');
        watches.forEach(function (w) {
          html += row(w, ICON_WATCH);
        });
      }
      if (browse.length) {
        html += group(sugg.getAttribute('data-g-browse') || '');
        browse.forEach(function (b) {
          html += row(b, ICON_TAG);
        });
      }
      if (products.length) {
        html += group(sugg.getAttribute('data-g-prod') || '');
        products.forEach(function (it) {
          var img = it.image
            ? '<span class="v2-sugg__th"><img src="' + it.image + '" alt="" loading="eager"></span>'
            : '<span class="v2-sugg__th"></span>';
          html +=
            '<a class="v2-sugg__i" href="' + it.url + '">' + img +
            '<span class="v2-sugg__t">' + esc(it.title) + '</span>' +
            (it.price ? '<span class="v2-sugg__p">' + (it.was ? '<s>' + esc(it.was) + '</s> ' : '') + esc(it.price) + '</span>' : '') +
            '</a>';
        });
      }

      if (!html) {
        html = '<p class="v2-sugg__none">' + (sugg.getAttribute('data-none') || '') + ' &ldquo;' + esc(q) + '&rdquo;</p>';
      } else {
        html +=
          '<a class="v2-sugg__all" href="' + bar.getAttribute('action') + '?type=product&q=' + encodeURIComponent(q) + '">' /* products only: pages and articles thinned the first page (2026-10-17) */ +
          (sugg.getAttribute('data-all') || '') + '</a>';
      }
      sugg.innerHTML = html;
      sugg.hidden = false;
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        render([], '');
        return;
      }
      // local matches are free, so they paint on this keystroke rather than waiting for the network
      render([], q);
      timer = setTimeout(function () {
        var mine = ++token;
        var url =
          '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (j) {
            if (mine !== token || !j) return; // a newer keystroke already won
            var list = (j.resources && j.resources.results && j.resources.results.products) || [];
            render(
              list.map(function (x) {
                return {
                  title: x.title,
                  url: x.url,
                  image: (x.featured_image && x.featured_image.url) || x.image || '',
                  price: price(x.price),
                  // the was-price too, whenever there is one (2026-10-03: every element showing a product shows it)
                  was: parseFloat(x.compare_at_price_max || x.compare_at_price || 0) > parseFloat(x.price) ? price(x.compare_at_price_max || x.compare_at_price) : ''
                };
              }),
              q
            );
          })
          ['catch'](function () {
            /* leave whatever is on screen */
          });
      }, 220);
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     10. THE GUIDE DIALOG
     Opens over the page instead of sending the visitor to another one, which is the whole point: they are mid way
     through choosing a watch and a navigation would throw that away.
     -------------------------------------------------------------------------------------------------------------- */
  var FIT_KEY = 'filter.p.m.custom.collection_filter_suitable_for';
  var fitValues = null; // the published list, fetched at most once per page

  function normalise(t) {
    return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function loadFitValues(fromUrl) {
    if (fitValues) return Promise.resolve(fitValues);
    /* the count-only facets view (templates/collection.mb-facets.liquid) lists the published fit values in a few KB;
       this used to download the whole collection page (164KB on the homepage, measured 2026-10-15) for the same list */
    var url = fromUrl.split('?')[0] + '?view=mb-facets';
    try { var pv1 = (location.search.match(/[?&]preview_theme_id=(\d+)/) || [])[1]; if (pv1 || window.swbPreviewId) url += '&preview_theme_id=' + (pv1 || Shopify.theme.id); } catch (e) {} /* never on a served theme: a preview parameter would pin the visitor (2026-10-15) */
    return fetch(url) /* no JSON Accept header: with one, Shopify answers with its own collection JSON instead of the view (2026-10-15) */
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (j) {
        var out = [];
        var list = j && j.filters && j.filters[FIT_KEY];
        if (list && list.length) list.forEach(function (x) { if (x && x.v && out.indexOf(x.v) === -1) out.push(x.v); });
        fitValues = out;
        return out;
      })
      .catch(function () {
        fitValues = [];
        return fitValues;
      });
  }

  /* Brand AND model first, because "Galaxy Watch 7 44mm" under Samsung is "Samsung Galaxy Watch 7 (44mm)" once the
     punctuation is gone. Then the model alone, which is how the Coros entries are written. Then the brand alone,
     which is all that exists for Apple. */
  function matchFit(values, brand, model) {
    var want = [normalise(brand + ' ' + model), normalise(model), normalise(brand)];
    for (var w = 0; w < want.length; w++) {
      if (!want[w]) continue;
      for (var i = 0; i < values.length; i++) {
        if (normalise(values[i]) === want[w]) return values[i];
      }
    }
    return '';
  }

  function initAccFit(root) {
    (root || document).querySelectorAll('[data-v2-accfit]:not([data-v2-ready])').forEach(function (sec) {
      sec.setAttribute('data-v2-ready', '');
      var links = [].slice.call(sec.querySelectorAll('[data-v2-accfit-link]'));
      if (!links.length) return;
      links.forEach(function (a) {
        a.setAttribute('data-base-href', a.getAttribute('href') || '');
      });
      var note = sec.querySelector('[data-v2-accfit-note]');
      var noteTpl = note ? note.getAttribute('data-template') || '' : '';

      function apply(w) {
        var base = links[0].getAttribute('data-base-href') || '';
        if (!w || !w.brand || !base) {
          links.forEach(function (a) {
            a.setAttribute('href', a.getAttribute('data-base-href') || '');
          });
          if (note) note.hidden = true;
          return;
        }
        loadFitValues(base).then(function (values) {
          var hit = matchFit(values, w.brand, w.model || '');
          links.forEach(function (a) {
            var b = a.getAttribute('data-base-href') || '';
            a.setAttribute('href', hit ? b.split('?')[0] + '?' + FIT_KEY + '=' + encodeURIComponent(hit) : b);
          });
          if (note) {
            if (hit && noteTpl) {
              note.textContent = noteTpl.replace('%s', hit);
              note.hidden = false;
            } else {
              note.hidden = true;
            }
          }
        });
      }

      apply(readWatch());
      document.addEventListener(EVENT, function (ev) {
        apply(ev.detail);
      });
    });
  }

  /* The brand list in the mobile sheet. Tapping a brand opens its models rather than navigating to a brand page,
     which is what the mega menu does on a desktop and what the chips looked like they would do. The models come from
     the same JSON the picker reads, so there is no second copy of the menu in the markup and no way for the two to
     disagree. Panels fill on first open. */
  function initSheetBrands(root) {
    (root || document).querySelectorAll('[data-v2-sheetbrands]:not([data-v2-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-v2-ready', '');

      var DATA = [];
      try {
        var src = document.getElementById(wrap.getAttribute('data-src') || '');
        DATA = src ? JSON.parse(src.textContent) || [] : [];
      } catch (e) {
        DATA = [];
      }

      function esc(t) {
        return String(t).replace(/[&<>"]/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
        });
      }

      function fill(panel, idx) {
        if (panel.getAttribute('data-filled')) return;
        panel.setAttribute('data-filled', '1');
        var entry = DATA[idx];
        var models = entry && entry.m ? entry.m : [];
        if (!models.length) return;
        panel.insertAdjacentHTML(
          'beforeend',
          models.map(function (m) {
            return '<a class="v2-sbrand__m" href="' + m.u + '">' + esc(m.t) + '</a>';
          }).join('')
        );
      }

      wrap.addEventListener('click', function (ev) {
        var btn = ev.target.closest ? ev.target.closest('[data-v2-sheetbrand]') : null;
        if (!btn || !wrap.contains(btn)) return;
        ev.preventDefault();
        var panel = btn.parentElement.querySelector('[data-v2-sheetpanel]');
        if (!panel) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        // one brand open at a time, so the list never becomes a wall of models
        wrap.querySelectorAll('[data-v2-sheetbrand][aria-expanded="true"]').forEach(function (o) {
          if (o === btn) return;
          o.setAttribute('aria-expanded', 'false');
          var op = o.parentElement.querySelector('[data-v2-sheetpanel]');
          if (op) op.hidden = true;
        });

        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
          return;
        }
        fill(panel, parseInt(btn.getAttribute('data-v2-sheetbrand'), 10));
        btn.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      });
    });
  }

  /* Relative luminance, the sRGB weighting. Good enough to decide "is this dark", which is all that is asked here. */
  function lumaOf(r, g, b) {
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }

  /* A ramp of navy shades rather than an arbitrary computed colour: every step is a deliberate brand tone, and white
     text stays legible on all of them. Index 0 is the authored default; the darker entry is for a pale hero. */
  var ANN_RAMP = [
    [21, 28, 41],
    [33, 45, 66],
    [46, 62, 91],
    [60, 80, 116],
    [11, 15, 23]
  ];
  var ANN_MIN_DELTA = 30; // luminance points between the pill and what is behind it

  function initAnnContrast() {
    var pill = document.querySelector('[data-v2-ann-in]');
    var img = document.querySelector('.v2-hero__media img');
    if (!pill || !img) return;

    function apply() {
      try {
        if (!img.naturalWidth) return;
        var rect = pill.getBoundingClientRect();
        if (!rect.height) return;

        /* Sample the band of the IMAGE the bar sits on, FULL WIDTH. An average was the wrong measure here and said
           this hero was fine: the mean is carried by the brightly lit subject on one side while the bar spans the
           whole width and vanishes into the near black corners. What matters is not the average brightness but how
           much of the backdrop the pill MERGES INTO, so score each candidate shade by the share of sampled pixels
           that land within touching distance of it, and take the shade that merges with the least. */
        var sh = img.naturalHeight;
        var band = Math.max(1, Math.round(sh * 0.08));
        var c = document.createElement('canvas');
        c.width = 32;
        c.height = 4;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, img.naturalWidth, band, 0, 0, 32, 4);
        var d = ctx.getImageData(0, 0, 32, 4).data;

        var lums = [];
        for (var i = 0; i < d.length; i += 4) lums.push(lumaOf(d[i], d[i + 1], d[i + 2]));

        function mergeShare(rgb) {
          var L = lumaOf(rgb[0], rgb[1], rgb[2]);
          var hits = 0;
          for (var j = 0; j < lums.length; j++) {
            if (Math.abs(lums[j] - L) < ANN_MIN_DELTA) hits++;
          }
          return hits / lums.length;
        }

        /* Direction matters, not just distance. Minimising the merge share alone happily picked NEAR BLACK against
           a dark hero, which is technically the biggest luminance gap and visually just more darkness. So: a dark
           photo steps the bar LIGHTER, a pale photo steps it DARKER, and the first step that stops it merging wins. */
        lums.sort(function (a, b) { return a - b; });
        var median = lums[Math.floor(lums.length / 2)];
        var candidates;
        if (median < 95) candidates = [1, 2, 3];        // dark hero: lighter navies
        else if (median > 150) candidates = [4, 0];     // pale hero: go darker
        else candidates = [];                           // mid tone: the authored shade is fine

        var best = ANN_RAMP[0];
        var bestShare = mergeShare(ANN_RAMP[0]);
        if (bestShare > 0.12 && candidates.length) {
          var chosen = null;
          for (var k = 0; k < candidates.length; k++) {
            var share = mergeShare(ANN_RAMP[candidates[k]]);
            if (share <= 0.12) { chosen = candidates[k]; bestShare = share; break; }
            if (chosen === null || share < bestShare) { chosen = candidates[k]; bestShare = share; }
          }
          if (chosen !== null) best = ANN_RAMP[chosen];
        }
        pill.style.setProperty('--v2-ann-bg', 'rgb(' + best[0] + ' ' + best[1] + ' ' + best[2] + ')');
        pill.setAttribute('data-ann-merge', Math.round(bestShare * 100));
      } catch (e) {
        /* canvas refused, or the image is not same origin: the CSS ring already keeps the bar readable */
      }
    }

    /* An explicit choice always wins. The sampler is a convenience for when the campaign image changes and nobody
       remembers to look; it is not a better judge of the artwork than the person who chose it. */
    var forced = pill.getAttribute('data-v2-ann-shade');
    if (forced && forced !== 'auto') {
      var idx = parseInt(forced, 10);
      if (!isNaN(idx) && ANN_RAMP[idx]) {
        pill.style.setProperty('--v2-ann-bg', 'rgb(' + ANN_RAMP[idx].join(' ') + ')');
        pill.setAttribute('data-ann-merge', 'forced');
        return;
      }
    }
    return; /* one bar colour on every page (2026-10-15, asked: the bar took another shade over one hero); the sampler below stays for an explicit opt-in later */
    /* Idle, not at load: drawing the hero into a canvas decodes it on the main thread (120ms on a slowed phone) and
       the bar is readable with its default shade for the moment this takes. */
    var later = function () {
      (window.requestIdleCallback || function (f) { return setTimeout(f, 300); })(apply, { timeout: 2500 });
    };
    if (img.complete && img.naturalWidth) later();
    else img.addEventListener('load', later, { once: true });
  }

  /* The sheet's tabs. Deliberately dumb: show one panel, hide the rest. The panels are real markup, so the first one
     works with no script at all and the others are simply not reachable rather than broken. */
  /* --------------------------------------------------------------------------------------------------------------
     12b. THE SHEET'S DEVICE ROW
     "For your watch" and a pill, Casetify's "For Your Device / Select Device". The picker lives folded inside it:
     a tap unfolds it, a model chosen in it folds it away again, and the pill and the card under it switch to that
     watch. A visitor who already told us their watch sees their card first and never the tiles.
     -------------------------------------------------------------------------------------------------------------- */
  function initSheetDevice(root) {
    (root || document).querySelectorAll('[data-v2-sdev]:not([data-v2-ready])').forEach(function (box) {
      box.setAttribute('data-v2-ready', '');
      var btn = box.querySelector('[data-v2-sdev-toggle]');
      var label = box.querySelector('[data-v2-sdev-label]');
      var mine = box.querySelector('[data-v2-smine]');
      var mineT = box.querySelector('[data-v2-smine-t]');
      var tPick = box.getAttribute('data-t-pick') || '';
      var tMine = box.getAttribute('data-t-mine') || '%s';
      var closeT = 0;

      function setOpen(on) {
        box.classList.toggle('is-open', on);
        if (btn) btn.setAttribute('aria-expanded', String(on));
      }

      function paint(w) {
        var known = !!(w && w.model && w.url);
        if (label) label.textContent = known ? w.model : tPick;
        box.classList.toggle('is-known', known);
        if (mine) {
          mine.hidden = !known;
          if (known) {
            mine.setAttribute('href', w.url);
            if (mineT) mineT.textContent = tMine.replace('%s', w.model);
          }
        }
      }

      if (btn) btn.addEventListener('click', function () {
        setOpen(!box.classList.contains('is-open'));
      });

      document.addEventListener(EVENT, function (ev) {
        var w = ev.detail;
        paint(w);
        // a model picked in the unfolded picker: let the chip land, then fold it away and show the card
        if (w && w.model && box.classList.contains('is-open')) {
          clearTimeout(closeT);
          closeT = setTimeout(function () { setOpen(false); }, reduceMotion ? 0 : 520);
        }
      });

      paint(readWatch());
      // open from the start for someone who has not chosen a watch yet; with a watch known it stays folded and shows it
      var known0 = readWatch();
      setOpen(!(known0 && known0.model));
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     12c. THE SHEET'S DRILL-DOWN: all brands -> a brand's series -> a series' models
     The flow of the live homepage's search section, inside the menu. Each step is a page that slides in over the
     menu with a back header; the last step is a link. Series and models are read from the desktop mega panel,
     which already holds the whole filtered tree, so nothing is fetched and nothing is emitted twice.
     -------------------------------------------------------------------------------------------------------------- */
  function initSheetDrill(root) {
    (root || document).querySelectorAll('[data-v2-sdrill]:not([data-v2-ready])').forEach(function (layer) {
      layer.setAttribute('data-v2-ready', '');
      var sheet = layer.closest('[data-v2-sheet]');
      var hdr = layer.closest('[data-v2-hdr]') || document;
      if (!sheet) return;
      var bar = sheet.querySelector('.v2-sheet__bar');
      var T = {
        back: layer.getAttribute('data-t-back') || '',
        allb: layer.getAttribute('data-t-allb') || '',
        allof: layer.getAttribute('data-t-allof') || '%s',
        kb: layer.getAttribute('data-t-kb') || '', ks: layer.getAttribute('data-t-ks') || '', km: layer.getAttribute('data-t-km') || '',
        dk: layer.getAttribute('data-t-dk') || '', dkUrl: layer.getAttribute('data-dk-url') || '',
        bymat: ({ nl: 'Shop op materiaal', de: 'Nach Material shoppen', fr: 'Par matériau', es: 'Por material' })[String(document.documentElement.lang || 'en').slice(0, 2)] || 'Shop by material',
        older: ({ nl: 'Oudere modellen (Series 1 t/m 6)', de: 'Ältere Modelle (Series 1 bis 6)', fr: 'Modèles plus anciens (Series 1 à 6)', es: 'Modelos anteriores (Series 1 a 6)' })[String(document.documentElement.lang || 'en').slice(0, 2)] || 'Older models (Series 1 to 6)'
      };
      var tplBrands = layer.querySelector('[data-v2-sdrill-brands]');
      var tplAcc = layer.querySelector('[data-v2-sdrill-acc]');
      var stack = [];
      var CHEV = '<svg class="v2-srow2__chev" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      function esc(t) {
        return String(t).replace(/[&<>"]/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
        });
      }
      // badge: the mega menu's "new" flag (data-v2-new / data-v2-newdot) carried onto the row
      function row(label, href, attrs, from) {
        var nb = '';
        if (from && from.hasAttribute('data-v2-new')) nb = '<i class="v2-newb">' + esc(from.getAttribute('data-v2-new')) + '</i>';
        else if (from && from.hasAttribute('data-v2-newdot')) nb = '<i class="v2-newdot" aria-hidden="true"></i>';
        return href
          ? '<li><a class="v2-srow2" href="' + esc(href) + '"' + (attrs || '') + '><span class="v2-srow2__n">' + esc(label) + nb + '</span>' + CHEV + '</a></li>'
          : '<li><button type="button" class="v2-srow2"' + (attrs || '') + '><span class="v2-srow2__n">' + esc(label) + nb + '</span>' + CHEV + '</button></li>';
      }

      /* the page's title beside "back" (what was tapped, with what to choose here above it), and on the pages where
         a model is chosen a last row for visitors who do not know theirs (2026-10-14, asked) */
      /* "don't know your model?" is always the last row of a brand or series page, under "all straps" and "by material" (2026-10-29, asked) */
      function dunno() { return T.dk && T.dkUrl ? '<li><a class="v2-srow2 v2-srow2--dk" href="' + esc(T.dkUrl) + '"><span class="v2-srow2__n">' + esc(T.dk) + '</span>' + CHEV + '</a></li>' : ''; }
      function push(title, bodyHtml, kicker) {
        sheetDepth = Math.max(sheetDepth, stack.length + 1);
        lpUi('sheet', 'step', title || '', stack.length + 1);
        if (bar) layer.style.top = bar.offsetHeight + 'px';
        var page = document.createElement('div');
        page.className = 'v2-sdpage';
        page.innerHTML =
          '<button type="button" class="v2-sdpage__back" data-v2-sdback>' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<span>' + esc(T.back || title) + '</span>' +
          (title ? '<span class="v2-sdpage__t">' + (kicker ? '<small>' + esc(kicker) + '</small>' : '') + esc(title) + '</span>' : '') + '</button>' +
          '<div class="v2-sdpage__body">' + bodyHtml + '</div>';
        layer.appendChild(page);
        layer.classList.add('is-on');
        layer.setAttribute('aria-hidden', 'false');
        stack.push(page);
        void page.offsetWidth; // a "before" for the slide
        page.classList.add('is-in');
        var prev = stack[stack.length - 2];
        if (prev) prev.classList.add('is-under');
        var f = page.querySelector('[data-v2-sdback]');
        if (f && f.focus) f.focus({ preventScroll: true });
      }

      function pop() {
        var page = stack.pop();
        if (!page) return;
        page.classList.remove('is-in');
        var prev = stack[stack.length - 1];
        if (prev) prev.classList.remove('is-under');
        setTimeout(function () {
          if (page.parentNode) page.parentNode.removeChild(page);
          if (!stack.length) {
            layer.classList.remove('is-on');
            layer.setAttribute('aria-hidden', 'true');
          }
        }, reduceMotion ? 0 : 420);
      }

      function reset() {
        stack.forEach(function (p) {
          if (p.parentNode) p.parentNode.removeChild(p);
        });
        stack = [];
        layer.classList.remove('is-on');
        layer.setAttribute('aria-hidden', 'true');
      }

      function openBrands(title) {
        push(title || T.allb, '<ul class="v2-sbrands v2-sbrands--all" role="list">' + (tplBrands ? tplBrands.innerHTML : '') + '</ul><ul class="v2-srows2" role="list">' + dunno() + '</ul>', T.kb);
      }
      function openAcc(title) {
        push(title, '<ul class="v2-srows2" role="list">' + (tplAcc ? tplAcc.innerHTML : '') + '</ul>');
      }

      // a brand's page: "all <brand> straps" first, then its series (a page each) and its loose models (links)
      function openBrand(idx, name, url) {
        var col = hdr.querySelector('[data-v2-series="' + idx + '"]');
        var items = col ? col.querySelectorAll('.v2-serieslist > li') : [];
        if (!items.length) {
          location.href = url;
          return;
        }
        var html = ''; /* no "all <brand> straps" row above the series any more (2026-10-17, asked): the series ARE the way in */
        /* ...but a visitor who does not know the series, or wants to browse a material, had no way on (2026-10-27, team
           feedback before the rollout: "you had to choose your series at once, the general Apple Watch page and the
           materials could not be picked"). A compact chip row on top: all straps of the brand and its materials, the
           same links as the desktop panel (.v2-bx), accessories left out. */
        var bxLinks = [].slice.call(col.querySelectorAll('.v2-bx a.v2-bx__l')).filter(function (a) { return !/accessor|zubeh|charger|opla|screen|hoes|case|etui|funda|ladeg/i.test(a.getAttribute('href') + ' ' + a.textContent); }).slice(0, 8);
        /* the brand's way in without a model (2026-10-27, asked: "not a fan of the pills, introduce it cleaner"): two plain
           rows like the models, "all <brand> straps" and "shop by material", which opens the materials as its own page */
        var matLinks = bxLinks.slice(1);
        /* ...as the last two rows, under the models (2026-10-28, asked): the models are the main way in */
        var foot = '';
        if (bxLinks.length) foot += row(T.allof.replace('%s', name), bxLinks[0].getAttribute('href'), '', null);
        /* a brand without a .v2-bx block in its menu column (all but Apple) still gets its "all straps" row, to the brand
           page itself (2026-10-29 sweep: Samsung, Garmin and Fitbit had no way to their brand page from the phone menu) */
        else if (url && url !== '#') foot += row(T.allof.replace('%s', name), url, '', null);
        if (matLinks.length) {
          sheet.v2Mats = matLinks.map(function (a) { return row(a.textContent.trim(), a.getAttribute('href'), '', null); }).join('');
          foot += row(T.bymat, null, ' data-v2-sdmats=""', null);
        }
        /* Apple's oldest models have no collection of their own (Series 1 to 6 fit by size): one row to the brand page */
        var olderRow = /apple/i.test(name) && bxLinks.length ? row(T.older || 'Older models (Series 1 to 6)', bxLinks[0].getAttribute('href').split('#')[0] + '#oudere-modellen', '', null) : '';
        /* One series and nothing else (Apple: everything sits under "Series") would be a page with a single row to
           tap through. Go straight to its models instead, with the brand's "all straps" still on top. */
        var seriesBtns = col.querySelectorAll('.v2-serieslist [data-v2-seriesopen]');
        if (seriesBtns.length === 1 && items.length === 1) {
          openSeries(seriesBtns[0].getAttribute('data-v2-seriesopen'), name, html, olderRow, foot);
          return;
        }
        /* SHORTER ROUTE (2026-10-21, menu data: visitors who went brand > series > model bought less). A brand with at
           most 24 models, or with small series (4 models each on average, 40 in all: Samsung), gets ONE page with every model under its series
           heading, so the model is one tap from the brand instead of two. Big brands keep the series pages. */
        if (seriesBtns.length >= 2) {
          var total = 0;
          var groups = [];
          for (var g = 0; g < items.length; g++) {
            var sb = items[g].querySelector('[data-v2-seriesopen]');
            var la = items[g].querySelector('a.v2-seriesl');
            if (sb) {
              var ms = hdr.querySelectorAll('[data-v2-gmodels="' + sb.getAttribute('data-v2-seriesopen') + '"] a.v2-gmodel');
              total += ms.length;
              groups.push({ title: sb.textContent.trim(), links: ms });
            } else if (la) {
              total += 1;
              groups.push({ title: '', links: [la] });
            }
          }
          var avg = total / seriesBtns.length;
          if (total && (total <= 24 || (avg <= 4 && total <= 40))) {
            var gh = '';
            groups.forEach(function (gr) {
              if (gr.title) gh += '<li class="v2-srows2__h" role="presentation">' + esc(gr.title) + '</li>';
              for (var k = 0; k < gr.links.length; k++) gh += row(gr.links[k].textContent.trim(), gr.links[k].getAttribute('href'), '', gr.links[k]);
            });
            push(name, '<ul class="v2-srows2" role="list">' + html + gh + olderRow + foot + dunno() + '</ul>', T.km);
            return;
          }
        }
        for (var i = 0; i < items.length; i++) {
          var b = items[i].querySelector('[data-v2-seriesopen]');
          var a = items[i].querySelector('a.v2-seriesl');
          if (b) html += row(b.textContent.trim(), null, ' data-v2-sdseries="' + esc(b.getAttribute('data-v2-seriesopen')) + '"', b);
          else if (a) html += row(a.textContent.trim(), a.getAttribute('href'), '', a);
        }
        push(name, '<ul class="v2-srows2" role="list">' + html + olderRow + foot + dunno() + '</ul>', col.querySelector('[data-v2-seriesopen]') ? T.ks : T.km);
      }

      function openSeries(key, title, lead, tail, foot) {
        var list = hdr.querySelectorAll('[data-v2-gmodels="' + key + '"] a.v2-gmodel');
        var html = lead || '';
        for (var i = 0; i < list.length; i++) {
          html += row(list[i].textContent.trim(), list[i].getAttribute('href'), '', list[i]);
          // Apple's "older models" sits right under the oldest numbered series (Series 7), not at the end (2026-10-27, asked)
          if (tail && /series 7$/i.test(list[i].textContent.trim())) { html += tail; tail = ''; }
        }
        push(title, '<ul class="v2-srows2" role="list">' + html + (tail || '') + (foot || '') + dunno() + '</ul>', T.km);
      }

      sheet.addEventListener('click', function (ev) {
        var t = ev.target.closest ? ev.target.closest('[data-v2-sopen], [data-v2-sbrand], [data-v2-sdseries], [data-v2-sdback], [data-v2-sdmats]') : null;
        if (!t || !sheet.contains(t)) return;
        if (t.hasAttribute('data-v2-sdback')) {
          pop();
        } else if (t.hasAttribute('data-v2-sopen')) {
          ev.preventDefault();
          var lbl = (t.querySelector('.v2-srow2__n') || t).textContent.trim();
          if (t.getAttribute('data-v2-sopen') === 'acc') openAcc(lbl);
          else openBrands(lbl);
        } else if (t.hasAttribute('data-v2-sbrand')) {
          ev.preventDefault();
          openBrand(t.getAttribute('data-v2-sbrand'), t.getAttribute('data-name') || t.textContent.trim(), t.getAttribute('href'));
        } else if (t.hasAttribute('data-v2-sdmats')) {
          push(T.bymat, '<ul class="v2-srows2" role="list">' + (sheet.v2Mats || '') + '</ul>');
        } else if (t.hasAttribute('data-v2-sdseries')) {
          openSeries(t.getAttribute('data-v2-sdseries'), (t.querySelector('.v2-srow2__n') || t).textContent.trim());
        }
      });

      var cartLink = sheet.querySelector('[data-v2-sheet-cart]');
      if (cartLink) cartLink.addEventListener('click', function () {
        var x = sheet.querySelector('[data-v2-sheet-close]');
        if (x) x.click();
      });

      // every time the menu opens it starts at the top, not three pages deep from last time
      hdr.querySelectorAll('[data-v2-sheet-open], [data-v2-sheet-close]').forEach(function (b) {
        b.addEventListener('click', reset);
      });
      sheet.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && stack.length) {
          ev.stopPropagation();
          pop();
        }
      });
    });
  }

  /* --------------------------------------------------------------------------------------------------------------
     12d. OUR QUICK ADD
     The theme renders its own "+ Quick add" form inside some cards only (products it can add in one step, which on
     UK is most of them and on NL almost none), as a green pill that lands on top of the price. Instead of editing the
     theme's card, its control is hidden in our sections and every card gets the same round "+" in the image's top
     right corner, opposite the badges.

     A product the theme could add directly (its form carries a variant id) is added the theme's own way, the Impact
     contract: cart/add.js with the drawer's sections bundled, then variant:add (which OPENS the drawer) and
     cart:change (which repaints it and the header count). Anything else, a strap with sizes to choose, opens its page.
     -------------------------------------------------------------------------------------------------------------- */
  /* ADDED-TO-CART TOAST (2026-10-03). For adds that stay on the page instead of opening the drawer: the card "+"
     quick add. One toast, reused: a tick, "Added to your cart", the product on one line, and "View cart", which opens
     the theme's own drawer (cart-drawer.show()) or the cart page. Hides after 4s; a new add restarts the timer.

     QUIET ADD, THE CART CONTRACT. Impact repaints the drawer and the header count on `cart:change`, reading
     cart.sections[<its id>] and throwing without it; `variant:add` additionally OPENS the drawer. So: ask the theme
     which sections it wants (cart:prepare-bundled-sections), add with them, re-read /cart.js, graft the sections onto
     it, and send only `cart:change` (as a line change, the same as the chat's quiet add). Count and drawer update,
     the drawer stays shut. */
  var TOAST_T = {
    nl: ['Toegevoegd', 'Bekijk'],
    de: ['Hinzugefügt', 'Ansehen'],
    fr: ['Ajouté', 'Voir'],
    es: ['Añadido', 'Ver'],
    en: ['Added', 'View cart']
  };
  var toastEl = null, toastTimer = 0;
  function cartToast(title, img, o) {
    // o (optional): { msg, go, href } turns the same toast into another notice, e.g. "saved to your list" (2026-10-15)
    var lang = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var T = TOAST_T[lang] || TOAST_T.en;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'v2-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.setAttribute('data-v2-own-layer', '');
      toastEl.innerHTML =
        '<span class="v2-toast__ok" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M5.5 12.5l4 4 9-9" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '<span class="v2-toast__tx"><b data-v2-toast-msg></b><span data-v2-toast-item></span></span>' +
        '<button type="button" class="v2-toast__go" data-v2-toast-go></button>' +
        // a way to dismiss it straight away (2026-10-15, asked)
        '<button type="button" class="v2-toast__x" data-v2-toast-x><svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button>';
      document.body.appendChild(toastEl);
      toastEl.querySelector('[data-v2-toast-x]').addEventListener('click', function () {
        clearTimeout(toastTimer);
        toastEl.classList.remove('is-on');
      });
      toastEl.querySelector('[data-v2-toast-go]').addEventListener('click', function () {
        toastEl.classList.remove('is-on');
        if (toastEl.v2Href) { window.location.href = toastEl.v2Href; return; }
        var dr = document.querySelector('cart-drawer');
        if (dr && typeof dr.show === 'function') dr.show();
        else window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
      });
    }
    toastEl.querySelector('[data-v2-toast-msg]').textContent = (o && o.msg) || T[0];
    /* the brand's spirit word on an add to cart (2026-10-28, the owner: "more woohoo at the celebration moments, e.g.
       when something is added to the cart"); not on the other notices this toast shows */
    var woo = toastEl.querySelector('.v2-toast__woo');
    if (!woo) {
      woo = document.createElement('span');
      woo.className = 'v2-toast__woo';
      woo.setAttribute('aria-hidden', 'true');
      woo.textContent = 'woohoo!';
      /* a sticker on the toast's top edge, outside the text: inside the "Toegevoegd" row it crowded the line and the
         product name (2026-10-28, asked: "didn't look clean") */
      toastEl.appendChild(woo);
    }
    woo.hidden = !!(o && o.msg);
    woo.classList.remove('is-pop');
    void woo.offsetWidth;
    woo.classList.add('is-pop');
    toastEl.v2Href = (o && o.href) || '';
    toastEl.querySelector('[data-v2-toast-item]').textContent = title || '';
    /* THE 2+1 ON EVERY ADD (2026-10-28, asked: "mention the 2+1 a bit more cleanly, it is a 24/7 deal"; one-strap orders
       were 62% on the new theme): the toast says where this cart stands in the deal, in the cart's own words. The add
       brings back the re-rendered cart drawer, whose deal bar is counted by the theme (straps only, this market's
       text), so the line is read from there once it changes; no extra request. */
    var dealEl = toastEl.querySelector('.v2-toast__deal');
    if (!dealEl) { dealEl = document.createElement('span'); dealEl.className = 'v2-toast__deal'; toastEl.querySelector('.v2-toast__tx').appendChild(dealEl); }
    dealEl.hidden = true;
    clearInterval(toastEl.v2DealT);
    if (!(o && o.msg)) {
      var dealSel = 'cart-drawer .cart-tier-bar__message, #shopify-section-cart-drawer .cart-tier-bar__message, [id*="__cart-drawer"] .cart-tier-bar__message';
      var dealTxt = function () { var e = document.querySelector(dealSel); return e ? e.textContent.replace(/woohoo!/i, '').replace(/\s+/g, ' ').trim() : ''; };
      var before = dealTxt(), tries = 0;
      toastEl.v2DealT = setInterval(function () {
        var now = dealTxt();
        if ((now && now !== before) || (++tries >= 8 && now)) {
          clearInterval(toastEl.v2DealT);
          dealEl.textContent = now;
          dealEl.hidden = false;
        } else if (tries >= 8) clearInterval(toastEl.v2DealT);
      }, 250);
    }
    var tim = toastEl.querySelector('.v2-toast__img');
    if (!tim) { tim = document.createElement('img'); tim.className = 'v2-toast__img'; tim.alt = ''; tim.width = 48; tim.height = 48; toastEl.insertBefore(tim, toastEl.firstChild); }
    if (img) { if (img.indexOf('//') === 0) img = 'https:' + img; tim.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120'; tim.hidden = false; } else tim.hidden = true;
    toastEl.querySelector('[data-v2-toast-go]').textContent = (o && o.go) || T[1];
    toastEl.querySelector('[data-v2-toast-x]').setAttribute('aria-label', ({ nl: 'Sluiten', de: 'Schließen', fr: 'Fermer', es: 'Cerrar' })[lang] || 'Close');
    // above a sticky add-to-cart bar on phones, never over it
    /* above every fixed control at the bottom of a phone screen (sticky add to cart, filter pill, chat and points
       buttons), never over one (2026-10-15, asked) */
    var lift = 0;
    if (window.matchMedia('(max-width: 749px)').matches) {
      var vh = window.innerHeight;
      [].forEach.call(document.querySelectorAll('product-quick-add.is-visible, body > *, [class*="floating"], [class*="fab"], [class*="sticky"]'), function (el) {
        if (el === toastEl || toastEl.contains(el)) return;
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
        var r = el.getBoundingClientRect(), vw = window.innerWidth;
        /* near the bottom (a floating filter pill sits ~30px above the edge, it counts) and across the middle of the screen:
           corner buttons (chat, Trusted Shops, points) sit beside the note, not under it, and do not lift it (2026-10-19) */
        if (r.width < 30 || r.height < 24 || r.height > vh * 0.45 || r.bottom < vh - 120 || r.top >= vh) return;
        if (!(r.left < vw * 0.5 && r.right > vw * 0.5)) return;
        if (el.id === 'PBarNextFrameWrapper') return;
        lift = Math.max(lift, vh - r.top);
      });
      lift = Math.min(lift, 220);
    }
    toastEl.style.setProperty('--v2-toast-lift', lift + 'px');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-on');
    /* an add to cart stays up long enough to read and tap "Bekijk" (5.5s; it went after 2.8s, asked 2026-10-28: "disappears a
       bit too quickly"); other notices keep the short time. A pointer on it holds it. */
    toastEl.v2Ms = (o && o.msg) ? 3200 : 5500;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, toastEl.v2Ms);
    if (!toastEl.v2Hold) {
      toastEl.v2Hold = 1;
      toastEl.addEventListener('pointerenter', function () { clearTimeout(toastTimer); });
      toastEl.addEventListener('pointerleave', function () {
        if (!toastEl.classList.contains('is-on')) return;
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2500);
      });
    }
  }
  window.swbV2Toast = cartToast;
  function quietAdd(items) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var bundled = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: bundled } }));
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: bundled })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (added) {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (added && added.sections) cart.sections = added.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: cart } }));
            return { added: added, cart: cart };
          });
      });
  }
  window.swbV2CartQuiet = quietAdd;

  var QA_LABEL = {
    nl: 'Snel toevoegen', de: 'Schnell hinzufügen', fr: 'Ajout rapide', es: 'Añadir rápido', en: 'Quick add'
  };
  /* The card "+" adds QUIETLY since 2026-10-03: the shopper stays on the page they are browsing, the header count
     goes up, the "+" turns into a tick, and the toast says what was added with a way into the cart. */
  function quickAddTo(vid, btn) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (btn.classList.contains('is-busy')) return Promise.resolve();
    btn.classList.add('is-busy');
    return quietAdd([{ id: vid, quantity: 1 }])
      .then(function (res) {
        var st = window.themeVariables && themeVariables.settings;
        if (st && st.cartType === 'page') {
          location.href = root + 'cart';
          return;
        }
        var a = res.added || {};
        var line = (a.items && a.items[0]) || a;
        var card = btn.closest && btn.closest('.product-card, .nr-i, .v2mi');
        var tEl = card && card.querySelector('.product-card__title');
        var cIm = card && card.querySelector('img');
        cartToast(line.product_title || (tEl && tEl.textContent.trim()) || '', (line.featured_image && line.featured_image.url) || line.image || (cIm && (cIm.currentSrc || cIm.src).split('&width')[0].split('?width')[0]) || '');
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
      })
      ['catch'](function () {
        btn.classList.remove('is-busy');
      });
  }
  /* QUICK ADD, THE VARIANT STEP
     The product is read from /products/<handle>.js. One purchasable variant: straight into the cart. More than
     one: a sheet rises with the product's options as buttons (size, colour...), sold-out choices struck through,
     and the add button stays disabled until every option has a value. */
  var QA_T = {
    nl: ['Kies je variant', 'In winkelwagen', 'Uitverkocht'],
    de: ['Variante wählen', 'In den Warenkorb', 'Ausverkauft'],
    fr: ['Choisissez votre variante', 'Ajouter au panier', 'Épuisé'],
    es: ['Elige tu variante', 'Añadir al carrito', 'Agotado'],
    en: ['Choose your option', 'Add to cart', 'Sold out']
  };
  /* the option's name in the shopper's language ("SIZE" was printed raw on NL/DE/UK, markets audit 2026-10-15) */
  var OPT_T = { size: { nl: 'Maat', de: 'Größe', fr: 'Taille', es: 'Talla', en: 'Size' }, color: { nl: 'Kleur', de: 'Farbe', fr: 'Couleur', es: 'Color', en: 'Colour' }, colour: { nl: 'Kleur', de: 'Farbe', fr: 'Couleur', es: 'Color', en: 'Colour' }, maat: { nl: 'Maat', de: 'Größe', fr: 'Taille', es: 'Talla', en: 'Size' }, kleur: { nl: 'Kleur', de: 'Farbe', fr: 'Couleur', es: 'Color', en: 'Colour' } };
  function optLabel(name) {
    var k = String(name || '').trim().toLowerCase(), l = String(document.documentElement.lang || 'en').slice(0, 2);
    return (OPT_T[k] && (OPT_T[k][l] || OPT_T[k].en)) || name;
  }
  function qaMoney(cents) {
    if (window.swbMoney) return window.swbMoney(cents);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  /* QUICK ADD ANSWERS AT ONCE (2026-10-15, asked: "reacts kinda slow"): the product's details are fetched before the
     tap (when the card comes into view, and again the moment a finger lands on the button), so the tap itself only
     opens the sheet or adds; one request per product, shared */
  var QA_CACHE = {};
  function qaGet(url) {
    if (!QA_CACHE[url]) {
      QA_CACHE[url] = fetch(url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r.json(); });
      QA_CACHE[url]['catch'](function () { delete QA_CACHE[url]; });
    }
    return QA_CACHE[url];
  }
  var qaIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      qaIO.unobserve(e.target);
      var u = e.target.getAttribute('data-qa-url');
      if (u) (window.requestIdleCallback || setTimeout)(function () { qaGet(u); });
    });
  }, { rootMargin: '200px' }) : null;
  function quickAddOpen(url, btn) {
    btn.classList.add('is-busy');
    qaGet(url)
      .then(function (p) {
        btn.classList.remove('is-busy');
        var avail = p.variants.filter(function (v) { return v.available; });
        if (!avail.length) return;
        if (p.variants.length === 1 || (p.options.length === 1 && String(p.options[0].name || p.options[0]) === 'Title')) {
          quickAddTo(avail[0].id, btn);
          return;
        }
        qaSheet(p, btn);
      })
      ['catch'](function () {
        btn.classList.remove('is-busy');
        location.href = url;
      });
  }
  function qaSheet(p, btn) {
    var lang = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var T = QA_T[lang] || QA_T.en;
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var pick = p.options.map(function () { return null; });
    var wrap = document.createElement('div');
    wrap.className = 'v2-qs';
    var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
    wrap.innerHTML =
      '<div class="v2-qs__scrim" data-qs-close></div>' +
      '<div class="v2-qs__sheet" role="dialog" aria-modal="true" aria-label="' + esc(T[0]) + '">' +
      '<button type="button" class="v2-qs__x" data-qs-close aria-label="x"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
      '<div class="v2-qs__head">' + (img ? '<img src="' + esc(img) + '&width=200" alt="" width="72" height="72">' : '') +
      '<div><p class="v2-qs__t">' + esc(p.title) + '</p><p class="v2-qs__p" data-qs-price>' + esc(qaMoney(p.price)) + '</p></div></div>' +
      p.options.map(function (o, oi) {
        var vals = [];
        p.variants.forEach(function (v) { if (vals.indexOf(v.options[oi]) < 0) vals.push(v.options[oi]); });
        return '<p class="v2-qs__o">' + esc(optLabel(o.name || o)) + '</p><div class="v2-qs__vals">' + vals.map(function (val) {
          return '<button type="button" class="v2-qs__v" data-o="' + oi + '" data-v="' + esc(val) + '">' + esc(val) + '</button>';
        }).join('') + '</div>';
      }).join('') +
      '<button type="button" class="v2-btn v2-btn--accent v2-qs__add" data-qs-add disabled>' + esc(T[1]) + '</button>' +
      '</div>';
    document.body.appendChild(wrap);
    var addB = wrap.querySelector('[data-qs-add]');
    var priceEl = wrap.querySelector('[data-qs-price]');
    function match() {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i], ok = true;
        for (var k = 0; k < pick.length; k++) if (pick[k] !== null && v.options[k] !== pick[k]) ok = false;
        if (ok && pick.indexOf(null) < 0) return v;
      }
      return null;
    }
    function paint() {
      [].forEach.call(wrap.querySelectorAll('.v2-qs__v'), function (b) {
        var oi = +b.getAttribute('data-o'), val = b.getAttribute('data-v');
        b.classList.toggle('is-on', pick[oi] === val);
        // struck through when no available variant carries this value with the other choices made so far
        var can = p.variants.some(function (v) {
          if (!v.available || v.options[oi] !== val) return false;
          for (var k = 0; k < pick.length; k++) if (k !== oi && pick[k] !== null && v.options[k] !== pick[k]) return false;
          return true;
        });
        b.classList.toggle('is-out', !can);
      });
      var v = match();
      addB.disabled = !(v && v.available);
      addB.textContent = v && !v.available ? T[2] : T[1];
      if (v) priceEl.textContent = qaMoney(v.price);
    }
    function close() {
      wrap.classList.remove('is-open');
      setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 380);
    }
    wrap.addEventListener('click', function (ev) {
      var t = ev.target.closest ? ev.target.closest('[data-qs-close], .v2-qs__v, [data-qs-add]') : null;
      if (!t) return;
      if (t.hasAttribute('data-qs-close')) return close();
      if (t.classList.contains('v2-qs__v')) {
        var oi = +t.getAttribute('data-o');
        pick[oi] = pick[oi] === t.getAttribute('data-v') ? null : t.getAttribute('data-v');
        return paint();
      }
      var v = match();
      if (v && v.available) {
        close();
        quickAddTo(v.id, btn);
      }
    });
    document.addEventListener('keydown', function esc2(ev) {
      if (ev.key === 'Escape') { close(); document.removeEventListener('keydown', esc2); }
    });
    // a single value per option is already chosen for the visitor
    p.options.forEach(function (o, oi) {
      var vals = [];
      p.variants.forEach(function (v) { if (vals.indexOf(v.options[oi]) < 0) vals.push(v.options[oi]); });
      if (vals.length === 1) pick[oi] = vals[0];
    });
    paint();
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
  }

  function initQuickAdd(root) {
    if (!document.documentElement.classList.contains('v2-cardlook')) return; // cards are live's 1:1 (2026-10-15, asked); the v2 card extras sleep until html.v2-cardlook
    /* not on collection pages (2026-10-20, asked: live's collection cards have no quick add; keep it on the homepage) */
    if (/\/collections\//.test(location.pathname)) return;
    /* our "+" belongs to the homepage's own cards. Everywhere else the cards are the live theme's, and so is their
       quick-buy: "+ Quick add" where that market has it switched on (FR, ES, UK), nothing where it does not (NL, DE),
       exactly as on live (asked 2026-10-14). */
    /* 2026-10-14 (asked again, later the same day): our cart button on EVERY product card on every page; the theme's
       own quick-buy is hidden wherever ours sits (swb-v2.css) */
    var lang = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var label = QA_LABEL[lang] || QA_LABEL.en;
    /* every product card, the live collection grids included (2026-10-14, asked: quick add on all cards); the
       photo-swap arrows below stay a homepage thing */
    (root || document).querySelectorAll('.product-card:not([data-v2-qa])').forEach(function (card) {
      card.setAttribute('data-v2-qa', '');
      if (card.querySelector('sold-out-badge, .badge--sold-out')) return; // nothing to add
      var fig = card.querySelector('.product-card__figure') || card;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'v2-qa';
      b.setAttribute('aria-label', label);
      b.innerHTML =
        '<svg class="v2-qa__plus" width="16" height="15" viewBox="0 0 16 15" fill="none" stroke-width="2" aria-hidden="true"><path d="M4.5 3.545H15l-2.546 5.728H5.136L3.546 1H1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><circle cx="5.955" cy="12.682" r=".5" fill="currentColor" stroke="currentColor"/><circle cx="11.5" cy="12.682" r=".5" fill="currentColor" stroke="currentColor"/></svg>' +
        '<svg class="v2-qa__ok" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (b.classList.contains('is-busy')) return;
        quickAddOpen(link.getAttribute('href').split('?')[0], b);
      });
      var qaUrl = link.getAttribute('href').split('?')[0];
      b.setAttribute('data-qa-url', qaUrl);
      b.addEventListener('pointerdown', function () { qaGet(qaUrl); b.classList.add('is-press'); }, { passive: true });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { b.addEventListener(t, function () { b.classList.remove('is-press'); }, { passive: true }); });
      if (qaIO) qaIO.observe(b);
      if (fig === card && getComputedStyle(fig).position === 'static') fig.style.position = 'relative'; // see swb-v2-shortlist.js decorate()
      fig.appendChild(b);

      /* IMAGE SWITCH ON A PHONE. The rows render a main and a second image and swap them on hover, which a thumb
         never does. Two small arrows, like the theme's own collection cards, flip between them. Not on the
         full-photo lead card: its second image is the packshot it already covers. */
      if (!document.documentElement.classList.contains('v2-home')) return;
      if (card.closest('.nr-i.is-life') || !card.querySelector('.product-card__image--secondary')) return;
      var mk = function (dir) {
        var a = document.createElement('button');
        a.type = 'button';
        a.className = 'v2-swap v2-swap--' + dir;
        a.setAttribute('aria-label', dir === 'prev' ? '<' : '>');
        a.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        a.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          /* Swap the PICTURES inside the visible image rather than fading one layer over another: the theme's hover
             rules fight a layer fade on a touch screen (a tap is also a hover there) and left the card blank. */
          var p1 = card.querySelector('.product-card__image--primary');
          var p2 = card.querySelector('.product-card__image--secondary');
          if (!p1 || !p2) return;
          ['src', 'srcset', 'sizes'].forEach(function (at) {
            var x = p1.getAttribute(at), y = p2.getAttribute(at);
            if (y !== null) p1.setAttribute(at, y); else p1.removeAttribute(at);
            if (x !== null) p2.setAttribute(at, x); else p2.removeAttribute(at);
          });
          p1.classList.remove('v2-swapin');
          void p1.offsetWidth;
          p1.classList.add('v2-swapin');
        });
        return a;
      };
      fig.appendChild(mk('prev'));
      fig.appendChild(mk('next'));
    });
  }
  // rows are fetched and re-rendered (a watch change, an occasion, the lead tile): cards that arrive later get theirs
  (function () {
    var t = 0;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { initQuickAdd(document); }, 180);
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* THE BAR NEVER CUTS A MESSAGE. Each message stays on one line; one that is wider than the bar (a phone, a long
     promise) glides left to show its end, rests, and glides back, like a ticker that reads rather than races. */
  /* THE CHAT'S FIRST SCREEN, WITH CONTEXT. When the header already knows the watch, the chat asks "For your Apple
     Watch Ultra 4?" with "Yes" and "Another watch" and nothing more: a model name out of nowhere. The chat's files
     are its own, so this only dresses what it renders: the question becomes a small card that says it is the watch
     you chose, what "yes" will do, and a "yes" that says it. The buttons are the chat's own, with their own
     handlers; only the first one's words change. Rebuilt each time the chat redraws its start screen. */
  function initChatStart() {
    var L = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var S = {
      nl: ['Jouw smartwatch', 'Zal ik bandjes laten zien die passen?', 'Ja, toon bandjes'],
      de: ['Deine Smartwatch', 'Soll ich dir passende Armb\u00e4nder zeigen?', 'Ja, Armb\u00e4nder zeigen'],
      fr: ['Votre smartwatch', 'Voir les bracelets compatibles ?', 'Oui, voir les bracelets'],
      es: ['Tu smartwatch', '\u00bfTe ense\u00f1o las correas compatibles?', 'S\u00ed, ver correas']
    }[L] || ['Your smartwatch', 'Shall I show you straps that fit?', 'Yes, show straps'];
    var ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round" aria-hidden="true"><rect x="6.5" y="6" width="11" height="12" rx="3"/><path d="M9 6l.6-3h4.8l.6 3M9 18l.6 3h4.8l.6-3"/></svg>';
    function dress() {
      document.querySelectorAll('.v2-chat__start:not([data-v2-wc])').forEach(function (box) {
        box.setAttribute('data-v2-wc', '');
        var q = box.querySelector('.v2-chat__startq');
        var row = box.querySelector('.v2-chat__startchips');
        var btns = row ? row.querySelectorAll('.v2-chat__qb') : [];
        if (!q || btns.length !== 2) return; // no watch known: the brand chips stay as they are
        var lab = document.querySelector('[data-v2-watch-label]');
        var watch = lab ? String(lab.textContent || '').trim() : '';
        if (!watch) return;
        var card = document.createElement('div');
        card.className = 'v2-wcard';
        card.innerHTML = '<div class="v2-wcard__head"><span class="v2-wcard__ico">' + ICON + '</span>' +
          '<span class="v2-wcard__txt"><span class="v2-wcard__eye"></span><b class="v2-wcard__name"></b></span></div>' +
          '<p class="v2-wcard__sub"></p>';
        card.querySelector('.v2-wcard__eye').textContent = S[0];
        card.querySelector('.v2-wcard__name').textContent = watch;
        card.querySelector('.v2-wcard__sub').textContent = S[1];
        q.parentNode.insertBefore(card, q);
        q.classList.add('v2-wcard__q');
        card.appendChild(q);
        row.classList.add('v2-wcard__acts');
        card.appendChild(row);
        btns[0].textContent = S[2];
        btns[0].classList.add('v2-wcard__yes');
      });
    }
    dress();
    var t = 0;
    new MutationObserver(function () {
      if (t) return;
      t = requestAnimationFrame(function () { t = 0; dress(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function initAnnFit() {
    var items = document.querySelectorAll('.v2-ann__item');
    if (!items.length) return;
    items.forEach(function (it) {
      if (it.querySelector('.v2-ann__run')) return;
      var run = document.createElement('span');
      run.className = 'v2-ann__run';
      while (it.firstChild) run.appendChild(it.firstChild);
      it.appendChild(run);
    });
    function fit() {
      items.forEach(function (it) {
        var run = it.querySelector('.v2-ann__run');
        it.classList.remove('is-long');
        var over = run.scrollWidth - it.clientWidth;
        if (over > 4) {
          it.style.setProperty('--ann-shift', -(over + 8) + 'px');
          it.style.setProperty('--ann-dur', Math.max(6, over / 18 + 4) + 's');
          it.classList.add('is-long');
        }
      });
      /* THE DEAL LINE IN TWO LINES ON A PHONE (2026-10-19, asked: "Buy 2 Get 1 FREE on all smartwatch straps" took three
         on a 360px phone): its text steps down half a pixel at a time until it fits two lines, never below 10.5px */
      items.forEach(function (it) {
        var d = it.querySelector('.v2-ann__dealtxt');
        if (!d) return;
        d.style.fontSize = '';
        if (window.innerWidth > 749) return;
        var fs = parseFloat(getComputedStyle(d).fontSize) || 12;
        var lines = function () {
          var lh = parseFloat(getComputedStyle(d).lineHeight) || fs * 1.2;
          return Math.round(d.getBoundingClientRect().height / lh);
        };
        while (lines() > 2 && fs > 10.5) { fs -= 0.5; d.style.fontSize = fs + 'px'; }
      });
    }
    fit();
    var t = 0;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 200); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* NO POP-UP EVER SITS UNDER THE ISLAND
     The island (z-index 10050) must beat the page, but every pop-up must beat the island: the theme's image zoom
     (Fancybox), its drawers and dialogs, app pop-ups. Known ones are named in CSS (html:has(...)); for anything else
     this looks for a newly shown, fixed layer that covers most of the screen and, while one is up, drops the island
     below it (html.v2-under-overlay). Our own layers (the menu sheet inside the header, the chat, the quick-add sheet)
     are skipped: they are built to sit above the island. */
  function initOverlayGuard() {
    var de = document.documentElement;
    var hdrSec = document.querySelector('.shopify-section--swb-v2-header');
    if (!hdrSec) return;
    var OURS = '.shopify-section--swb-v2-header, .v2-chat__dock, .v2-qs, .v2-hdr, #shopify-pc__banner, [data-v2-own-layer]';
    function covering(el) {
      if (!el || el.nodeType !== 1 || el.closest(OURS)) return false;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none') return false;
      if (fixedSeen.indexOf(el) < 0 && fixedSeen.length < 40) fixedSeen.push(el); // a fixed layer still fading in is looked at again by the light checks
      if (cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) return false;
      // what is ON the screen counts: a closed sheet parked below the fold (the sale page's filters) is full size too
      var r = el.getBoundingClientRect();
      var vw = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
      var vh = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
      return vw >= window.innerWidth * 0.6 && vh >= window.innerHeight * 0.6;
    }
    var shown = []; // layers seen covering the screen; re-checked until they close
    var fixedSeen = []; // fixed layers the last full sweep found, shown or not
    /* light: only the layers already showing and the elements that just changed. The two follow-up looks after a
       change (for pop-ups still fading in) use it; they were full sweeps of the page, three per change, and on a
       page whose hero rotates every 6s that was the guard's whole cost (about 660ms per idle 15s at 4x). */
    function check(light) {
      if (!light) fixedSeen = [];
      var cand = (light ? fixedSeen.slice() : [].slice.call(document.querySelectorAll('body > *, [open], [aria-modal="true"], dialog, [role="dialog"], .fancybox__container, .pswp, .modal, [class*="popup"], [class*="lightbox"], [data-lightbox], [data-qv]'))).concat(shown, recent);
      recent = [];
      shown = cand.filter(function (el, i) { return cand.indexOf(el) === i && covering(el); });
      // a popup hanging from the island (html.v2-islpop) wants the island ON top, not under it (2026-10-15)
      de.classList.toggle('v2-under-overlay', shown.length > 0 && !de.classList.contains('v2-islpop'));
      /* WHILE THE ISLAND IS DOWN, KEEP LOOKING (2026-10-31, owner: "opening the mobile menu flickers"). A pop-up that
         closed by removing itself, or that was still fading out when the check after its close click ran, left the
         island hidden until the next change on the page: opening the menu was that change, and the header blinked
         back in under the sheet. A light look (only the layers it is down for) every 500 ms ends that. */
      clearTimeout(watchT);
      if (shown.length) watchT = setTimeout(function () { check(true); }, 500);
    }
    var watchT = 0;
    var t = 0, recent = [];
    /* our own animated parts restyle themselves constantly (carousels, tilt, hero and stage timers, cards) and never
       contain a full-screen layer: their changes are not candidates and do not re-arm the three checks */
    var CALM = '[id^="trustbadge"], .v2-hero, .v2-stage, .v2-carousel, .v2-rail__slot, .v2-occ, .v2-usp, .v2-uspvp, .product-card, .nr-i, .v2-hdr, .v2-chat__dock, .v2-bcar, .v2-dd, .v2-mx__grid';
    new MutationObserver(function (recs) {
      // any element that just changed (shown, restyled, inserted) is a candidate, whatever it is called
      var any = false;
      recs.forEach(function (r) {
        var tg = r.target;
        /* speed (2026-10-16 audit): a lazy image, a video or a card class flip is never a pop-up; ignoring them took
           about 1 s of style and layout per 18 s off a phone at 4x CPU */
        if (tg.nodeType === 1 && /^(IMG|PICTURE|SOURCE|VIDEO|SVG|PATH|SPAN|I|B|S|A|LI)$/i.test(tg.tagName) && r.type === 'attributes') return;
        if (tg.nodeType === 1 && tg.closest && tg.closest(CALM)) return;
        if (r.type === 'attributes') { any = true; if (recent.length < 60) recent.push(tg); }
        else if (r.addedNodes) for (var k = 0; k < r.addedNodes.length; k++) if (r.addedNodes[k].nodeType === 1) { any = true; if (recent.length < 60) recent.push(r.addedNodes[k]); }
        /* a layer that removed itself while the island was down for it: look again (it never fired before) */
        if (shown.length && r.removedNodes && r.removedNodes.length) any = true;
      });
      if (!any) return;
      /* a throttle, not a debounce: some layer on the page (the Trusted Shops badge rewrites its own style non-stop)
         changes more often than every 40 ms, and a debounce that restarts on every change never fired at all */
      if (t) return;
      // pop-ups fade in: look again while they finish appearing, so the island steps back at once
      t = setTimeout(function () {
        requestAnimationFrame(function () {
          t = 0;
          var keep = recent.slice();
          check();
          setTimeout(function () { requestAnimationFrame(function () { recent = recent.concat(keep); check(true); }); }, 400);
        });
      }, 60);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'style', 'hidden', 'aria-hidden'] });
    document.addEventListener('click', function () { setTimeout(check, 350); }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setTimeout(check, 350); });
  }

  /* THE CHAT PANEL CLEARS ITS OWN STRIP: on a desktop the chat opens as a side panel and pushes the page, but a
     fixed layer (the PDP's sticky add-to-cart, the Trusted Shops badge, an app's floater) ignores that push and sat
     under the panel. While the panel is open, every fixed layer it would cover steps left out of its strip, and slides
     back when it closes. Nothing is named: whatever is fixed on the page is a candidate, so a new app is covered too.
     Full-screen layers (drawers, lightboxes) are left alone; the overlay guard and their own z-index handle those. */
  function initDockDodge() {
    // the chat script builds its panel after this runs, so it is looked up each time, never cached at boot
    var dock = null;
    var SKIP = '.shopify-section--swb-v2-header, #PBarNextFrameWrapper, [data-v2-own-layer], x-drawer, cart-drawer, facet-drawer, quick-buy-drawer, x-modal'; // drawers cover the window; the chat steps aside for them instead
    var cands = [], moved = new Map(), scanned = false, raf = 0, t = 0;
    function isOpen() {
      if (!dock || !dock.isConnected) dock = document.querySelector('.v2-chat__dock');
      if (!dock || !dock.classList.contains('is-open')) return false;
      var r = dock.getBoundingClientRect();
      return r.width > 0 && r.width < window.innerWidth * 0.7;
    }
    function scan() {
      var all = [].filter.call(document.body.querySelectorAll('*'), function (el) {
        if (el === dock || dock.contains(el) || el.contains(dock) || el.closest(SKIP)) return false;
        return getComputedStyle(el).position === 'fixed';
      });
      // a fixed layer inside another one moves with its parent; moving both would move it twice. A parent with no
      // size of its own (an app's empty wrapper) never gets measured as covering, so there the child is the mover.
      var sized = all.filter(function (el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; });
      cands = all.filter(function (el) { return !sized.some(function (o) { return o !== el && o.contains(el); }); });
      moved.forEach(function (v, el) { if (cands.indexOf(el) < 0) cands.push(el); });
      scanned = true;
    }
    // the shift lives in one generated stylesheet keyed by a data attribute, not in an inline style: an app that
    // re-renders its own style attribute (the Trusted Shops badge does, constantly) wiped an inline translate at once
    var ids = 0, rules = new Map(), sheet = null, stuck = {};
    function write() {
      if (!sheet) { sheet = document.createElement('style'); sheet.id = 'v2-dodge-css'; document.head.appendChild(sheet); }
      var css = '';
      rules.forEach(function (v, id) {
        // a layer that will not move (the Trusted Shops badge ignores translate) steps out of sight instead
        css += '[data-v2-dodge="' + id + '"]{translate:' + v + 'px 0 !important' + (stuck[id] ? ';visibility:hidden !important' : '') + '}';
      });
      sheet.textContent = css;
    }
    function set(el, from, to) {
      if (!el.hasAttribute('data-v2-dodge')) el.setAttribute('data-v2-dodge', String(++ids));
      var id = el.getAttribute('data-v2-dodge');
      if (to) { rules.set(id, to); moved.set(el, to); } else { rules['delete'](id); moved['delete'](el); delete stuck[id]; }
      var x0 = el.getBoundingClientRect().left;
      write();
      if (to && !stuck[id]) {
        setTimeout(function () {
          if (!rules.has(id)) return;
          var x1 = el.getBoundingClientRect().left;
          if (Math.abs(x1 - (x0 - from + to)) > 40 && Math.abs(x1 - x0) < 4) { stuck[id] = true; write(); }
        }, 480);
      }
      if (el.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.animate([{ translate: from + 'px 0' }, { translate: to + 'px 0' }], { duration: 420, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' });
      }
    }
    function apply() {
      raf = 0;
      var open = isOpen();
      document.documentElement.classList.toggle('v2-dock-open', open);
      if (open && !scanned) scan();
      var d = open ? dock.getBoundingClientRect() : null, vw = window.innerWidth;
      cands.forEach(function (el) {
        var cur = moved.get(el) || 0, want = 0;
        if (cur && !el.hasAttribute('data-v2-dodge')) { rules.forEach(function (v, id) { if (v === cur) rules['delete'](id); }); moved['delete'](el); cur = 0; }
        // once moved it stays moved until the panel closes: some layers report their shifted place late, and
        // re-measuring them read as "clear of the panel" and took the shift back
        if (open && cur && el.isConnected) want = cur;
        else if (open && el.isConnected) {
          var cs = getComputedStyle(el);
          if (cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05) {
            var r = el.getBoundingClientRect();
            var L = r.left - cur, R = r.right - cur; // where it sits without our shift
            if (r.width > 0 && r.width < vw * 0.6 && R > d.left - 12 && L < d.right && r.bottom > d.top && r.top < d.bottom) {
              want = Math.round(d.left - 16 - R);
              if (L + want < 8) want = Math.round(8 - L); // never off the left edge
              if (want > 0) want = 0;
            }
          }
        }
        if (want !== cur) set(el, cur, want);
      });
    }
    function soon() { if (!raf) raf = requestAnimationFrame(apply); }
    // layers that arrive or appear while the panel is open (the sticky bar shows on scroll, an app injects late)
    var was = false;
    new MutationObserver(function (recs) {
      var open = isOpen();
      if (open !== was) { was = open; scanned = false; soon(); return; } // the panel itself opened or closed
      if (!open && !moved.size) return;
      var added = recs.some(function (r) { return r.addedNodes && r.addedNodes.length; });
      clearTimeout(t);
      t = setTimeout(function () { if (added) scanned = false; soon(); }, 120);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'data-v2-dodge'] });
    window.addEventListener('scroll', function () { if (isOpen() || moved.size) soon(); }, { passive: true });
    window.addEventListener('resize', function () { scanned = false; soon(); });
  }

  /* STICKY BARS JOIN THE ISLAND: a page's own sticky bar (the sale page's filters, a landing page's brand tabs, the
     customer-service tabs) used to stick full width, square, half under the floating header. Once one is stuck it
     takes the island's shape instead: the same width, radius and shadow, parked just below it, and a row of options
     that overflows gets arrows. Nothing is named: any bar pinned to the top of the page qualifies, so a new section
     is covered without touching this. Unstuck, a bar is exactly what its section drew.
     Everything is written into one generated stylesheet keyed by a data attribute, never into a style attribute a
     section's own script may rewrite. */
  function initSubbars() {
    var isl = document.querySelector('.v2-hdr__island');
    if (!isl) return;
    var SKIP = '.shopify-section-group-header-group, .shopify-section--swb-v2-header, .v2-chat__dock, #PBarNextFrameWrapper, [id^="trustbadge"], .v2-qs, .v2-slpop, .v2-subarr, .v2-sl__bar, [data-v2-own-layer], [data-v2-no-subbar], [aria-modal="true"], dialog';
    var bars = [], raf = 0, t = 0, ids = 0, sheet = null, arrows = null, GAP = 8, lastIb = -1;
    /* candidates only: a full-page querySelectorAll('*') + getComputedStyle per element was a ~300 ms task on a phone.
       Every sticky bar found by the 30-template sweep (sale rail, bestseller chips, materials rail, all-straps nav,
       bundle builder steps) matches one of these; a new bar named like them is picked up too. */
    var CAND = 'safe-sticky, nav, [class*="sticky"], [class*="rail"], [class*="chips"], [class*="tabs"], [class*="toolbar"], [class*="nav"], [class*="__prog"], [class*="filter-bar"], [style*="sticky"]';
    function scan() {
      var vw = window.innerWidth;
      var all = [].filter.call(document.body.querySelectorAll(CAND), function (el) {
        if (el.closest(SKIP)) return false;
        var cs = getComputedStyle(el);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') return false;
        if (cs.top === 'auto' || parseFloat(cs.top) > 320) return false; // pinned to the top, not a bottom bar
        if (cs.display === 'none') return false;
        var r = el.getBoundingClientRect();
        // a bar already taken keeps its place while a panel inside it is open and it is taller than 200 (QA 2026-10-03:
        // dropping it mid-open removed its island shape and it fell 126px below the island)
        if (el.hasAttribute('data-v2-sub')) return r.width >= vw * 0.55 && r.height >= 24;
        return r.width >= vw * 0.55 && r.height >= 24 && r.height <= 200;
      });
      var next = all.filter(function (el) { return !all.some(function (o) { return o !== el && o.contains(el); }); });
      next.forEach(function (el) {
        if (el.hasAttribute('data-v2-sub')) return;
        el.setAttribute('data-v2-sub', String(++ids));
        var cs = getComputedStyle(el);
        el.__v2sub = { fixed: cs.position === 'fixed', top: parseFloat(cs.top) || 0, ml: parseFloat(cs.marginLeft) || 0, mr: parseFloat(cs.marginRight) || 0, on: false, shift: 0, row: null };
      });
      bars = next;
      write();
      soon();
    }
    // the widest row inside the bar that scrolls sideways, if its options do not fit
    function rowOf(el) {
      var best = null, bw = 0;
      [el].concat([].slice.call(el.querySelectorAll('*'))).forEach(function (n) {
        var ox = getComputedStyle(n).overflowX;
        if ((ox === 'auto' || ox === 'scroll') && n.scrollWidth > n.clientWidth + 4 && n.clientWidth > bw) { best = n; bw = n.clientWidth; }
      });
      return best;
    }
    function write() {
      if (!sheet) { sheet = document.createElement('style'); sheet.id = 'v2-sub-css'; document.head.appendChild(sheet); }
      var ir = isl.getBoundingClientRect(), vw = document.documentElement.clientWidth, css = '';
      bars.forEach(function (el) {
        var s = el.__v2sub;
        if (!s) return;
        var sel = '[data-v2-sub="' + el.getAttribute('data-v2-sub') + '"]';
        /* a bar whose own offset would park it UNDER the island sticks below it from the start: caught only once
           stuck, it first slid up behind the island and then jumped down (the bundle builder's step rail) */
        if (!s.fixed && s.top < ir.bottom + GAP) css += sel + '{top:' + Math.round(ir.bottom + GAP) + 'px !important}';
        if (!s.on) return;
        var l = Math.round(ir.left), rr = Math.round(vw - ir.right);
        var shape = 'border-radius:var(--v2-r-lg) !important;box-shadow:0 12px 32px -18px rgb(20 20 20 / 0.45),0 0 0 1px rgb(20 20 20 / 0.05) !important;background-color:#fff !important;border-color:transparent !important;';
        var place = s.fixed
          ? 'left:' + l + 'px !important;right:' + rr + 'px !important;width:auto !important;max-width:none !important;top:' + Math.round(ir.bottom + GAP) + 'px !important;'
          : 'margin-left:' + Math.round(s.ml + Math.max(0, l - s.baseL)) + 'px !important;margin-right:' + Math.round(s.mr + Math.max(0, rr - s.baseR)) + 'px !important;width:auto !important;max-width:none !important;' +
'';
        css += sel + '{' + shape + place + 'transition:margin 0.35s var(--v2-ease-open),border-radius 0.35s var(--v2-ease-open),box-shadow 0.35s var(--v2-ease-open) !important}';
        if (s.row) {
          var rs = '[data-v2-subrow="' + el.getAttribute('data-v2-sub') + '"]';
          css += rs + '{padding-inline:44px !important;scroll-padding-inline:44px !important;scrollbar-width:none' + (s.row !== el ? ';background:transparent !important;border-color:transparent !important;box-shadow:none !important' : '') + '}' + rs + '::-webkit-scrollbar{display:none}';
        }
      });
      if (sheet.textContent !== css) sheet.textContent = css;
    }
    function arrowsFor() {
      if (arrows) return arrows;
      arrows = ['prev', 'next'].map(function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'v2-subarr v2-subarr--' + dir;
        b.hidden = true;
        b.setAttribute('aria-label', dir === 'prev' ? '<' : '>');
        b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        b.addEventListener('click', function () {
          var row = b.__row;
          if (row) row.scrollBy({ left: (dir === 'prev' ? -1 : 1) * Math.max(160, row.clientWidth * 0.7), behavior: 'smooth' });
        });
        document.body.appendChild(b);
        return b;
      });
      return arrows;
    }
    function placeArrows() {
      var host = null;
      bars.forEach(function (el) { if (!host && el.__v2sub.on && el.__v2sub.row) host = el; });
      if (!host && !arrows) return;
      var a = arrowsFor();
      if (!host) { a[0].hidden = a[1].hidden = true; return; }
      var row = host.__v2sub.row, r = row.getBoundingClientRect(), br = host.getBoundingClientRect();
      var cy = Math.round(r.top + r.height / 2 - 16);
      var atStart = row.scrollLeft <= 2, atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      a[0].__row = a[1].__row = row;
      a[0].style.top = a[1].style.top = cy + 'px';
      a[0].style.left = Math.round(Math.max(br.left, r.left) + 6) + 'px';
      a[1].style.left = Math.round(Math.min(br.right, r.right) - 38) + 'px';
      a[0].hidden = atStart;
      a[1].hidden = atEnd;
      if (!row.__v2subL) { row.__v2subL = true; row.addEventListener('scroll', soon, { passive: true }); }
    }
    function tick() {
      raf = 0;
      var ib = isl.getBoundingClientRect().bottom, changed = false, flips = [];
      bars.forEach(function (el) {
        var s = el.__v2sub;
        if (!s || !el.isConnected) return;
        var cs = getComputedStyle(el);
        var shown = cs.display !== 'none' && cs.visibility !== 'hidden';
        var r = el.getBoundingClientRect();
        var want;
        if (!shown || r.height === 0) want = false;
        else if (s.fixed) want = r.bottom > 0;
        else {
          // stuck = sitting at its sticky offset (ours or its own), within a few pixels
          var at = s.top < ib + GAP ? ib + GAP : s.top;
          want = Math.abs(r.top - at) < 3 || (s.on && r.top <= at + 1);
        }
        if (want && !s.on) {
          var rr = r;
          s.baseL = rr.left; s.baseR = document.documentElement.clientWidth - rr.right;
          var row = rowOf(el);
          if (s.row && s.row !== row) flips.push({ off: s.row });
          s.row = row;
          if (row) flips.push({ row: row, id: el.getAttribute('data-v2-sub') });
        }
        if (want !== s.on) { s.on = want; changed = true; flips.push(el); }
      });
      // written after the loop: toggling inside it dirtied the style the next bar's getComputedStyle then had to flush
      flips.forEach(function (f) {
        if (f.off) f.off.removeAttribute('data-v2-subrow');
        else if (f.row) f.row.setAttribute('data-v2-subrow', f.id);
        else f.toggleAttribute('data-v2-sub-on', f.__v2sub.on);
      });
      if (Math.abs(ib - lastIb) > 1) {
        lastIb = ib;
        changed = true;
        document.documentElement.style.setProperty('--v2-isl-b', Math.round(ib) + 'px');
      }
      if (changed) write();
      placeArrows();
    }
    function soon() { if (!raf) raf = requestAnimationFrame(tick); }
    window.addEventListener('scroll', soon, { passive: true });
    /* only a WIDTH change re-measures: a phone's URL bar collapsing fires resize with the same width, and resetting
       every bar then made a stuck bar drop its shape mid-scroll (QA 2026-10-03) */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) { soon(); return; }
      lastW = window.innerWidth;
      bars.forEach(function (el) { if (el.__v2sub) el.__v2sub.on = false; }); write(); clearTimeout(t); t = setTimeout(scan, 200);
    });
    /* rescan only when an ELEMENT arrives outside the places that churn by design (our own sections, cards, drawers,
       the chat): text swaps (hero copy, countdowns) and card insertions no longer trigger a sweep */
    var QUIET = '.v2-root, .v2-hdr, .v2-chat__dock, .product-card, .nr-i, cart-drawer, x-drawer, .v2mi, [data-v2-sub]';
    new MutationObserver(function (recs) {
      var hit = false;
      for (var i = 0; i < recs.length && !hit; i++) {
        var r = recs[i];
        if (!r.addedNodes || !r.addedNodes.length) continue;
        if (r.target.nodeType === 1 && r.target.closest && r.target.closest(QUIET)) continue;
        for (var k = 0; k < r.addedNodes.length; k++) if (r.addedNodes[k].nodeType === 1) { hit = true; break; }
      }
      if (!hit) return;
      clearTimeout(t);
      t = setTimeout(scan, 900);
    }).observe(document.body, { childList: true, subtree: true });
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 300); };
    idle(scan);
    window.addEventListener('load', function () { setTimeout(scan, 600); });
  }

  /* THE BLOG (sections/swb-v2-blog.liquid). Search, the filter chips and the "for your watch" strip all go through
     the store search (/search?type=article&view=swb-articles), which covers every article rather than the 24 on
     screen and answers with the blog's own card markup. A preview theme must be named in the URL: a preview covers
     the document only, and the live theme has no swb-articles view. */
  function initBlog() {
    var root = document.querySelector('[data-v2-blog]');
    if (!root || root.hasAttribute('data-ready')) return;
    root.setAttribute('data-ready', '');
    var blogPath = (root.getAttribute('data-blog') || '').replace(/\/$/, '');
    var input = root.querySelector('[data-v2-blog-q]');
    var clearB = root.querySelector('[data-v2-blog-clear]');
    var list = root.querySelector('[data-v2-blog-list]');
    var res = root.querySelector('[data-v2-blog-results]');
    var rhead = root.querySelector('[data-v2-blog-rhead]');
    var chips = [].slice.call(root.querySelectorAll('[data-v2-blog-chip]'));
    var T = function (k) { return root.getAttribute('data-t-' + k) || ''; };
    var prev = '';
    try {
      var pv2 = (location.search.match(/[?&]preview_theme_id=(\d+)/) || [])[1]; if (pv2 || window.swbPreviewId) prev = '&preview_theme_id=' + (pv2 || Shopify.theme.id);
    } catch (e) {}
    var cache = {};
    function search(q) {
      var key = q.toLowerCase();
      if (cache[key]) return cache[key];
      var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search?type=article&view=swb-articles&q=' + encodeURIComponent(q) + prev;
      return (cache[key] = fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html || html.indexOf('<html') > -1) return [];
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          // this blog only (a store can have more than one), and each article once: search can list the same
          // article under two URLs (with and without its tracking parameters)
          var seenT = {};
          var out = [].slice.call(tpl.content.querySelectorAll('[data-v2-bcard]')).filter(function (c) {
            var t = c.getAttribute('data-title');
            if (seenT[t]) return false;
            seenT[t] = 1;
            return !blogPath || (c.getAttribute('href') || '').split('?')[0].indexOf(blogPath + '/') === 0;
          });
          var box = tpl.content.querySelector('[data-v2-bres]');
          out.total = Math.max(out.length, parseInt(box && box.getAttribute('data-count'), 10) || 0);
          return out;
        })
        ['catch'](function () { return []; }));
    }

    /* ---- search and chips: the result grid replaces the paginated list, "all" brings it back ---- */
    var token = 0;
    function show(q, chip) {
      var mine = ++token;
      chips.forEach(function (c) { c.classList.toggle('is-on', c === chip); });
      if (clearB) clearB.hidden = !q;
      if (!q) {
        res.hidden = true;
        rhead.hidden = true;
        list.hidden = false;
        return;
      }
      root.classList.add('is-busy');
      search(q).then(function (cards) {
        if (mine !== token) return;
        root.classList.remove('is-busy');
        res.innerHTML = '';
        var grid = document.createElement('div');
        grid.className = 'v2-blog__grid';
        cards.forEach(function (c) { grid.appendChild(c.cloneNode(true)); });
        res.appendChild(grid);
        rhead.textContent = cards.length ? T('res').replace('%n', cards.total || cards.length) : T('none');
        rhead.hidden = false;
        res.hidden = !cards.length;
        list.hidden = true;
      });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        if (input) input.value = '';
        show(c.getAttribute('data-v2-blog-chip') || '', c.getAttribute('data-v2-blog-chip') ? c : chips[0]);
      });
    });
    var deb = 0;
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(deb);
        var q = input.value.trim();
        deb = setTimeout(function () { show(q.length >= 2 ? q : '', q.length >= 2 ? null : chips[0]); }, 320);
      });
      var form = root.querySelector('[data-v2-blog-form]');
      if (form) form.addEventListener('submit', function (ev) { ev.preventDefault(); show(input.value.trim(), null); });
    }
    if (clearB) clearB.addEventListener('click', function () { if (input) input.value = ''; show('', chips[0]); if (input) input.focus(); });

    /* ---- for your watch: store-search results for the brand, ranked by how well the TITLE names the watch ---- */
    var mineBox = root.querySelector('[data-v2-blog-mine]');
    var mineRow = root.querySelector('[data-v2-blog-minerow]');
    var mineL = root.querySelector('[data-v2-blog-minel]');
    function norm(s) { return (s || '').toLowerCase().replace(/[()\[\],.:]/g, ' ').replace(/\s+/g, ' ').trim(); }
    function fillMine() {
      if (!mineBox) return;
      var w = readWatch();
      var brand = w && (w.brand || '').trim();
      var label = w ? watchLabel(w) : '';
      var render = function (cards, head) {
        mineRow.innerHTML = '';
        cards.slice(0, 4).forEach(function (c) { mineRow.appendChild(c.cloneNode(true)); });
        mineL.textContent = head;
        mineBox.hidden = !cards.length;
      };
      var starters = function () {
        return search(root.getAttribute('data-q-guide') || 'best').then(function (cards) { render(cards, T('start')); });
      };
      /* no watch: the server's four starter cards stay (swapping them for a search result a second later was a visible
         change, 2026-10-19); only an empty row is filled */
      if (!brand) { if (mineRow.querySelector('a')) return; return starters(); }
      // the model's distinctive part: "Watch GT 7 - 46mm" -> "gt 7", "Apple Watch Series 10" -> "10"
      var core = norm((w.model || '').replace(new RegExp('^' + brand.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*', 'i'), ''))
        .replace(/\b\d+\s?mm\b/g, '').replace(/\bwatch\b|\bseries\b|\s-\s|^-|-$/g, ' ').replace(/\s+/g, ' ').trim();
      var extra = /apple/i.test(brand) ? 'iphone' : /samsung|google|pixel/i.test(brand) ? 'android' : '';
      var qs = [brand + (core ? ' ' + core : ''), brand].concat(extra ? [extra] : []);
      Promise.all(qs.map(search)).then(function (sets) {
        var seen = {}, scored = [];
        var nb = norm(brand), coreRe = core ? new RegExp('(^|\\s)' + core.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(\\s|$)') : null;
        sets.forEach(function (cards) {
          cards.forEach(function (c) {
            var href = c.getAttribute('data-title');
            if (seen[href]) return;
            seen[href] = 1;
            var t = norm(c.getAttribute('data-title'));
            var s = (t.indexOf(nb) > -1 ? 2 : 0) + (coreRe && coreRe.test(t) ? 4 : 0) + (extra && t.indexOf(extra) > -1 ? 1 : 0);
            if (s > 0) scored.push({ c: c, s: s });
          });
        });
        scored.sort(function (x, y) { return y.s - x.s; });
        if (!scored.length) return starters();
        render(scored.map(function (x) { return x.c; }), T('for').replace('%s', label));
      });
    }
    fillMine();
    document.addEventListener(EVENT, fillMine);
  }

  /* OCCASION AND MATERIAL LINKS ANYWHERE ON THE PAGE go straight to the market's own page with ?mat=. The theme's
     cart drawer links "/pages/occasions?occ=..." : the English handle redirects (and Shopify caches that redirect
     with another visitor's query, so a tap opened a different occasion) and the page ignores ?occ=, so every tile
     opened All Day. Rewritten here, never in the drawer's own file, and again whenever the drawer re-renders. */
  function initOccLinks() {
    var hdr = document.querySelector('[data-v2-occ-url]');
    if (!hdr) return;
    var occ = hdr.getAttribute('data-v2-occ-url'), mat = hdr.getAttribute('data-v2-mat-url');
    var MAP = { outdoor: 'sport' };
    function fix(root) {
      (root || document).querySelectorAll('a[href*="/pages/occasions"], a[href*="/pages/materials"]').forEach(function (a) {
        var h = a.getAttribute('href') || '';
        var m = h.match(/\/pages\/(occasions|materials)\/?(?:\?([^#]*))?/);
        if (!m) return;
        var base = m[1] === 'occasions' ? occ : mat;
        if (!base || base.indexOf('/pages/' + m[1]) > -1 && !m[2]) return;
        var q = new URLSearchParams(m[2] || '');
        var key = q.get('mat') || q.get('occ') || '';
        key = MAP[key] || key;
        var next = base.split('?')[0] + (key ? '?mat=' + encodeURIComponent(key) : '');
        if (next !== h) a.setAttribute('href', next);
      });
    }
    fix();
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(fix, 150); }).observe(document.body, { childList: true, subtree: true });
  }

  /* A DRAWER TAKES THE STAGE: the cart, filters, quick buy and every other theme drawer open from the same right edge
     the chat panel sits on, and stacked on top of it they read as a mess. While any drawer is open the chat steps
     aside (faded, not closed, so the conversation is kept) and comes back when the drawer closes. */
  /* ONE STAGE AT A TIME (2026-10-12, asked: "a proper system for these popups so ugly overlaps do not happen", after
     the mega menu stayed open on top of the cart while the chat was open). Every surface now follows one order:
       - a drawer (cart, filters, quick buy, ...) opening clears the header: mega menus, the phone sheet, the watch
         popover, the search bar and the guide close, and the chat steps aside (kept, not closed);
       - a header panel opened ON PURPOSE (a click or tap) while a drawer is open closes that drawer first; merely
         passing the pointer over the header never opens a menu over a drawer;
       - the mega menu and the chat may share the screen: that pair is laid out side by side by design.
     The header announces its panels on PANEL_EVENT already; drawers join the same bus as 'drawer'. */
  function initDrawerYield() {
    var de = document.documentElement;
    var SEL = 'cart-drawer, x-drawer, facet-drawer, quick-buy-drawer, search-drawer, header-drawer, account-drawer';
    function openOnes() { return [].slice.call(document.querySelectorAll(SEL)).filter(function (d) { return d.hasAttribute('open'); }); }
    window.swbV2DrawerOpen = function () { return openOnes().length > 0; };
    var was = false;
    function check() {
      var open = openOnes().length > 0;
      de.classList.toggle('v2-chat-yield', open);
      if (open && !was) announcePanel('drawer');
      was = open;
    }
    document.addEventListener(PANEL_EVENT, function (ev) {
      if (ev.detail === 'drawer') return;
      openOnes().forEach(function (d) {
        try { if (typeof d.hide === 'function') d.hide(); else d.removeAttribute('open'); } catch (e) { d.removeAttribute('open'); }
      });
    });
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        if (recs[i].attributeName === 'open' && recs[i].target.matches && recs[i].target.matches(SEL)) { check(); return; }
      }
    }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    check();
  }

  /* LOYALTY IN THE MENU: the balance Spotler's beacon provides (window.BWJLoyalty.data, event "bwj:loyalty"), shown
     as points and a bar to the next reward, or "ready" when a voucher waits. Nothing is fetched here. */
  function initLoyaltyCard() {
    var cards = document.querySelectorAll('[data-v2-loy]');
    var pts = document.querySelectorAll('[data-v2-loy-pts]');
    if (!cards.length && !pts.length) return;
    function paint() {
      var d = window.BWJLoyalty && window.BWJLoyalty.data;
      if (!d || d.balance === undefined || d.balance === null || d.balance === '') return;
      var bal = Math.max(0, parseInt(d.balance, 10) || 0);
      var vouchers = parseInt(d.vouchers, 10) || 0;
      cards.forEach(function (c) {
        var per = parseInt(c.getAttribute('data-per'), 10) || 25;
        var money = c.getAttribute('data-money') || '';
        var p = c.querySelector('[data-v2-loy-pts]');
        var line = c.querySelector('[data-v2-loy-line]');
        var bar = c.querySelector('[data-v2-loy-bar]');
        if (p) { p.textContent = (c.getAttribute('data-t-pts') || '%s').replace('%s', bal); p.hidden = false; }
        var rest = per - (bal % per);
        if (line) {
          line.textContent = vouchers > 0
            ? (c.getAttribute('data-t-ready') || '').replace('%v', money)
            : (c.getAttribute('data-t-next') || '').replace('%s', rest).replace('%v', money);
        }
        if (bar) {
          bar.hidden = false;
          bar.firstElementChild.style.width = Math.round(((bal % per) / per) * 100) + '%';
        }
        c.classList.add('is-member');
        c.classList.toggle('is-ready', vouchers > 0);
      });
      pts.forEach(function (p) {
        if (p.closest('[data-v2-loy]')) return;
        p.textContent = String(bal);
        p.hidden = false;
      });
    }
    paint();
    document.addEventListener('bwj:loyalty', paint);
  }

  function initSheetTabs(root) {
    (root || document).querySelectorAll('[data-v2-stabs]:not([data-v2-ready])').forEach(function (bar) {
      bar.setAttribute('data-v2-ready', '');
      var scope = bar.parentElement;
      bar.addEventListener('click', function (ev) {
        var tab = ev.target.closest ? ev.target.closest('[data-v2-stab]') : null;
        if (!tab) return;
        ev.preventDefault();
        var key = tab.getAttribute('data-v2-stab');
        bar.querySelectorAll('[data-v2-stab]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', String(on));
        });
        scope.querySelectorAll('[data-v2-spanel]').forEach(function (pn) {
          pn.hidden = pn.getAttribute('data-v2-spanel') !== key;
        });
        // a tab change starts a new list: begin it at the top rather than wherever the last one was left
        var body = scope.closest('.v2-sheet__body') || scope;
        if (body.scrollTop > bar.offsetTop) body.scrollTop = bar.offsetTop;
      });
    });
  }

  function initGuide(root) {
    var box = (root || document).querySelector('[data-v2-guide]:not([data-v2-guide-ready])');
    if (!box) return;
    box.setAttribute('data-v2-guide-ready', '');

    var card = box.querySelector('.v2-guide__box');
    var titleEl = box.querySelector('[data-v2-guide-title]');
    var backBtn = box.querySelector('[data-v2-guide-back]');
    var brandsView = box.querySelector('[data-v2-guide-view="brands"]');
    var contentView = box.querySelector('[data-v2-guide-view="content"]');
    var bodyEl = box.querySelector('[data-v2-guide-body]');
    var brandsWrap = box.querySelector('[data-v2-guide-brands]');
    var mapEl = box.querySelector('[data-v2-guide-map]');
    var homeTitle = titleEl ? titleEl.textContent : '';
    var loadingText = box.getAttribute('data-guide-loading') || '';
    var lastFocus = null;

    var MAP = [];
    try {
      MAP = JSON.parse(mapEl.textContent) || [];
    } catch (e) {
      MAP = [];
    }

    function esc(t) {
      return String(t).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    /* The picker's brand reads "Apple Watch" while the map is keyed "apple", so match on the START of the name. That
       is the same rule the bundle builder uses, which is why the two agree on every brand the shop sells. */
    function entryFor(name) {
      var n = String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
      if (!n) return null;
      for (var i = 0; i < MAP.length; i++) {
        if (n.indexOf(MAP[i].k) === 0) return MAP[i];
      }
      return null;
    }

    /* Which brand is the visitor looking at right now. The switch module they clicked from wins, because that is the
       one on screen; only if it is empty do we fall back to the watch stored for the session. */
    function currentBrand(opener) {
      var pick = opener && opener.closest ? opener.closest('[data-v2-pick]') : null;
      if (pick) {
        var sel = pick.querySelector('[data-v2-brand]');
        if (sel && sel.selectedIndex > 0) {
          var o = sel.options[sel.selectedIndex];
          if (o && o.textContent) return o.textContent;
        }
      }
      var w = readWatch();
      return w && w.brand ? w.brand : '';
    }

    // ---- the brand chooser ----
    function paintBrands() {
      if (!brandsWrap || brandsWrap.childNodes.length) return;
      brandsWrap.innerHTML = MAP.map(function (m) {
        return (
          '<button type="button" class="v2-guide__brand" data-v2-guide-brand="' + esc(m.k) + '">' +
          '<span>' + esc(m.n) + '</span>' +
          '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>'
        );
      }).join('');
    }

    function showBrands() {
      paintBrands();
      if (titleEl) titleEl.textContent = homeTitle;
      if (brandsView) brandsView.hidden = false;
      if (contentView) contentView.hidden = true;
      if (backBtn) backBtn.hidden = true;
      if (card) card.scrollTop = 0;
    }

    /* Read the brand's own guide page and keep only the instructional blocks. The page's layout is
       `section.tracker-section`; the trailing one is a product picker, identified by carrying an interactive control,
       which is pointless here. A block with no heading and no steps is scene-setting copy (Samsung opens with one),
       so it is dropped and every brand's guide starts the same way. Same parse as assets/swb-bundle.js. */
    var cache = {};
    function loadGuide(handle) {
      if (cache[handle]) return Promise.resolve(cache[handle]);
      return fetch('/pages/' + encodeURIComponent(handle), { headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['script', 'style', 'noscript'].forEach(function (t) {
            [].forEach.call(doc.querySelectorAll(t), function (n) {
              n.remove();
            });
          });
          var out = [];
          [].forEach.call(doc.querySelectorAll('section.tracker-section'), function (sec) {
            if (sec.querySelector('form, select, input, button')) return;
            var h = sec.querySelector('h1, h2, h3');
            var steps = [].map.call(sec.querySelectorAll('table tr'), function (tr) {
              return tr.textContent.replace(/\s+/g, ' ').trim();
            }).filter(Boolean);
            var body = '';
            if (!steps.length) {
              var clone = sec.cloneNode(true);
              var hc = clone.querySelector('h1, h2, h3');
              if (hc) hc.remove();
              body = clone.textContent.replace(/\s+/g, ' ').trim();
            }
            if (!h && !steps.length) return;
            var img = sec.querySelector('img');
            out.push({
              title: h ? h.textContent.replace(/\s+/g, ' ').trim() : '',
              steps: steps,
              body: body,
              img: img ? (img.getAttribute('src') || '') : ''
            });
          });
          if (!out.length) throw new Error('empty');
          cache[handle] = out;
          return out;
        });
    }

    function showGuide(entry) {
      if (titleEl) titleEl.textContent = entry.n;
      if (brandsView) brandsView.hidden = true;
      if (contentView) contentView.hidden = false;
      if (backBtn) backBtn.hidden = false;
      if (card) card.scrollTop = 0;
      if (bodyEl) bodyEl.innerHTML = '<p class="v2-guide__load">' + esc(loadingText) + '</p>';

      loadGuide(entry.h)
        .then(function (secs) {
          if (box.hidden || !bodyEl) return;
          bodyEl.innerHTML = secs.map(function (x) {
            return (
              '<div class="v2-guide__sec">' +
              (x.title ? '<p class="v2-guide__h">' + esc(x.title) + '</p>' : '') +
              (x.steps.length
                ? '<ol class="v2-guide__list">' + x.steps.map(function (t) {
                    return '<li>' + esc(t.replace(/^\d+\s*/, '')) + '</li>';
                  }).join('') + '</ol>'
                : x.body ? '<p class="v2-guide__p">' + esc(x.body) + '</p>' : '') +
              (x.img
                ? '<img class="v2-guide__img" src="' + esc(x.img) + '" alt="" loading="lazy" decoding="async">'
                : '') +
              '</div>'
            );
          }).join('');
        })
        .catch(function () {
          /* Never a dead dialog. If that brand's page is missing on this market, fall back to the generic three
             steps that are already in the markup rather than showing an empty box. */
          if (box.hidden) return;
          showBrands();
          var other = box.querySelector('.v2-guide__other');
          if (other) other.open = true;
        });
    }

    // ---- open / close ----
    function open(opener) {
      lastFocus = document.activeElement;
      announcePanel('guide');
      box.hidden = false;
      void box.offsetWidth;
      box.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';

      var entry = entryFor(currentBrand(opener));
      if (entry) showGuide(entry);
      else showBrands();

      var x = box.querySelector('[data-v2-guide-close]');
      if (x && x.focus) {
        try {
          x.focus();
        } catch (e) {
          /* ignore */
        }
      }
    }
    function close() {
      if (box.hidden) return;
      box.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        box.hidden = true;
      }, 300);
      if (lastFocus && lastFocus.focus) {
        try {
          lastFocus.focus();
        } catch (e) {
          /* ignore */
        }
      }
    }

    document.addEventListener('click', function (ev) {
      if (!ev.target.closest) return;
      var o = ev.target.closest('[data-v2-guide-open]');
      if (o) {
        ev.preventDefault();
        open(o);
        return;
      }
      if (!box.contains(ev.target)) return;
      if (ev.target.closest('[data-v2-guide-close]')) {
        close();
        return;
      }
      if (ev.target.closest('[data-v2-guide-back]')) {
        showBrands();
        return;
      }
      var b = ev.target.closest('[data-v2-guide-brand]');
      if (b) {
        var key = b.getAttribute('data-v2-guide-brand');
        for (var i = 0; i < MAP.length; i++) {
          if (MAP[i].k === key) {
            showGuide(MAP[i]);
            return;
          }
        }
      }
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') close();
    });
    document.addEventListener(PANEL_EVENT, function (ev) {
      if (ev.detail !== 'guide') close();
    });
  }
  /* -------------------------------------------------------------------------------------------------------------- */
  /* PRODUCT PAGE DRAWERS LIVE AT THE TOP OF THE PAGE (2026-10-02). The information drawers (description, specs,
     delivery, which model, size guide; snippets/swb-v2-accordion.liquid) are rendered inside the product section. With
     the chat open as a side panel the page is moved with a transform, and a fixed element inside a transformed one is
     placed against THAT box: the drawer landed mid page with half a backdrop. Moved under <body>, like the theme's own
     cart drawer, they always cover the window. The rows find them by id, so nothing else changes. */
  // the cart drawer rebuilds its add-ons on every cart change: flip each pop-up to the right side as it is tapped
  if (!LIVE_COMPAT) document.addEventListener('click', function (ev) {
    var t = ev.target.closest && ev.target.closest('[aria-controls^="x-drawer"]');
    if (!t) return;
    var d = document.getElementById(t.getAttribute('aria-controls'));
    if (d && d.classList.contains('x-drawer--upsell')) d.setAttribute('open-from', 'right');
  }, true);
  function initPdpDrawers(root) {
    // the theme's add-on pop-ups (cart drawer) open from the left; every sheet on this site comes from the right
    (root || document).querySelectorAll('x-drawer.x-drawer--upsell[open-from="left"]').forEach(function (d) { d.setAttribute('open-from', 'right'); });
    (root || document).querySelectorAll('x-drawer.v2-pdpdrawer, x-drawer.v2-upq').forEach(function (d) {
      if (d.parentElement !== document.body) document.body.appendChild(d);
      // the add-on quick view: a thumbnail switches the large photo
      if (d.classList.contains('v2-upq') && !d.v2Upq) {
        d.v2Upq = true;
        d.addEventListener('click', function (ev) {
          var th = ev.target.closest && ev.target.closest('[data-v2-upq-th]');
          if (!th) return;
          var k = th.getAttribute('data-v2-upq-th');
          d.querySelectorAll('[data-v2-upq-img]').forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-v2-upq-img') === k); });
          d.querySelectorAll('[data-v2-upq-th]').forEach(function (b) { b.classList.toggle('is-on', b === th); });
        });
      }
    });
  }

  /* the PDP add-ons show three; one link opens the rest in place (2026-10-02) */
  function initUpsellMore(root) {
    (root || document).querySelectorAll('.shopify-section--swb-v2-main-product .productpage-upsells:not([data-v2-upm])').forEach(function (u) {
      u.setAttribute('data-v2-upm', '');
      var n = u.querySelectorAll('.horizontal-product').length;
      if (n <= 3) return;
      var lang = String(document.documentElement.lang || 'en').slice(0, 2);
      var lbl = ({ nl: 'Toon nog %n', de: '%n weitere zeigen', fr: 'Voir %n de plus', es: 'Ver %n más' }[lang] || 'Show %n more').replace('%n', n - 3);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'v2-upmore';
      b.textContent = lbl;
      b.addEventListener('click', function () { u.classList.add('is-all'); b.remove(); });
      (u.querySelector('.upsell__recommendations') || u).appendChild(b);
    });
  }

  /* the menu sheet's search field had no suggestions; a tap on it hands over to the header search, which has them
     (watches, materials, products as you type). Done inside the same tap so a phone keeps the keyboard open. */
  function initSheetSearch(root) {
    (root || document).querySelectorAll('.v2-ssearch input:not([data-v2-ss])').forEach(function (inp) {
      inp.setAttribute('data-v2-ss', '');
      var busy = 0;
      var hand = function (ev) {
        var openBtn = document.querySelector('[data-v2-search-open]');
        var bar = document.querySelector('[data-v2-search-input]');
        if (!openBtn || !bar) return;
        ev.preventDefault();
        /* one tap fires pointerdown AND focus, and the header button is a toggle: it opened and closed again (2026-10-16) */
        if (Date.now() - busy < 800) return;
        busy = Date.now();
        var sb = document.querySelector('[data-v2-searchbar]');
        var x = document.querySelector('[data-v2-sheet-close]');
        if (x) x.click();
        if (!sb || sb.hidden) openBtn.click();
        bar.focus();
        try { bar.click(); } catch (e) {}
      };
      /* on the tap's click, inside the gesture, so a phone raises the keyboard; the click must not travel on to the
         search's "click outside closes it" listener, which shut the bar again in the same tap (2026-10-15, asked).
         The field itself never takes focus, so no keyboard flashes up for the menu that is about to close. */
      inp.readOnly = true;
      inp.addEventListener('click', function (ev) { ev.stopPropagation(); hand(ev); });
      inp.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.stopPropagation(); hand(ev); } });
    });
  }

  /* deal of the day: a different review on every visit, then one every 7s (several real reviews from the market's own
     feed are rendered; this only chooses which one shows). Paused while the visitor hovers it. */
  function initDealReviews(root) {
    (root || document).querySelectorAll('[data-v2-ddrev]:not([data-v2-ddrev-on])').forEach(function (box) {
      box.setAttribute('data-v2-ddrev-on', '');
      var bubs = [].slice.call(box.querySelectorAll('.v2-bub'));
      if (!bubs.length) return;
      var at = Math.floor(Math.random() * bubs.length);
      var show = function () { bubs.forEach(function (b, k) { b.classList.toggle('is-on', k === at); }); };
      show();
      if (bubs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var paused = false;
      box.addEventListener('pointerenter', function () { paused = true; });
      box.addEventListener('pointerleave', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        at = (at + 1) % bubs.length;
        show();
      }, 7000);
    });
  }

  /* remembers which collections this visit has opened, so the product page can leave out its "all N straps for
     your watch" pill for someone who has already seen that range (snippets/swb-v2-pdp-collection-link) */
  (function () {
    if (!/\/collections\/[^/]+\/?$/.test(location.pathname)) return;
    try {
      var p = location.pathname.replace(/\/$/, '');
      var l = JSON.parse(sessionStorage.getItem('swb_v2_colls') || '[]');
      if (l.indexOf(p) < 0) { l.push(p); sessionStorage.setItem('swb_v2_colls', JSON.stringify(l.slice(-30))); }
    } catch (e) {}
  })();

  /* COLOUR SWATCHES ANSWER AT ONCE (2026-10-03, asked: "choose your colour is slow"). Every colour is its own
     product, so a tap is a full page load. The page is fetched the moment a finger touches the swatch (or a mouse
     rests on it), so by the time the tap lands the browser usually has it. Once per URL, product pages only. */
  (function () {
    var done = {};
    function warm(ev) {
      var a = ev.target && ev.target.closest && ev.target.closest('.variants-slider a[href*="/products/"], .v2-set a[href*="/products/"]');
      if (!a) return;
      var href = a.href;
      if (!href || done[href]) return;
      done[href] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = href;
      document.head.appendChild(l);
    }
    document.addEventListener('pointerdown', warm, { passive: true, capture: true });
    document.addEventListener('mouseover', warm, { passive: true });
  })();

  function boot(root) {
    initDealReviews(root);
    initSheetSearch(root);
    if (!LIVE_COMPAT) initPdpDrawers(root);
    if (!LIVE_COMPAT) initUpsellMore(root);
    initReveal(root);
    // once per page, whatever boot() is handed (it is called with document, so a bare !root check never ran)
    if (!document.documentElement.hasAttribute('data-v2-once')) { document.documentElement.setAttribute('data-v2-once', ''); initWarmImages(); initPhoneChrome(); initNavFeedback(); initImageFade(); initFootAware(); }
    initMotionPass(root);
    initTilt(root);
    initPicker(root);
    initRail(root);
    initCarousel(root);
    initLife(root);
    initStage(root);
    initHero(root);
    initViewed(root);
    initHeader(root);
    initBrandIndex(root);
    initOccasions(root);
    initSheetPicker(root);
    initSheetDevice(root);
    initSheetDrill(root);
    initQuickAdd(root);
    initAnnounce(root);
    initSearch(root);
    initGuide(root);
    initAccFit(root);
    initSheetBrands(root);
    initSheetTabs(root);
    initAnnContrast();
    initAnnFit();
    /* started once the page has loaded and gone quiet (2026-10-03): during load every app injects nodes and the guard
       re-checked all of them, ~175ms of a phone's busiest second, for pop-ups that only ever appear seconds later */
    (function () {
      var go = function () { (window.requestIdleCallback || setTimeout)(initOverlayGuard, { timeout: 2500 }); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    })();
    if (!LIVE_COMPAT) initDockDodge();
    initSubbars();
    initBlog();
    initDrawerYield(); // also the one-stage rule between the header panels and the cart, which this theme needs too
    initOccLinks();
    initLoyaltyCard();
    initPickBand();
    if (!LIVE_COMPAT) initChatStart();
    syncClear(readWatch());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  // the theme editor re-renders one section at a time
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });

  /* COMPACT STICKY FILTER BARS (2026-10-05, "sticky header for filters on sales page / occasions page don't look clean
     with 2 rows, needs to be compact"). Once the sale rail or the materials/occasions rail is pinned AND takes two
     rows, its second row (Straps/Accessories on the sale page, the count and the chosen-watch chip on the browse
     pages) folds away; it comes back at the top. The height it gave up is added back as margin under the bar, so the
     products below never jump. */
  (function compactStick() {
    var FOLD = { 'swb-sp__rail': '.swb-sp__seg', 'mb-rail': '.mb-rail__meta' };
    var bars = [];
    function collect() {
      bars = Array.prototype.slice.call(document.querySelectorAll('.swb-sp__rail, .mb-rail'));
    }
    var queued = false;
    function update() {
      queued = false;
      bars.forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position !== 'sticky') return;
        var top = parseFloat(cs.top) || 0;
        var pinned = window.scrollY > 120 && el.getBoundingClientRect().top <= top + 1;
        var on = el.classList.contains('is-stuck');
        if (pinned === on) return;
        if (pinned) {
          var key = el.classList.contains('mb-rail') ? 'mb-rail' : 'swb-sp__rail';
          var row = el.querySelector(FOLD[key]);
          if (!row || !row.getClientRects().length) return;
          var h0 = el.offsetHeight;
          if (h0 < 60) return; // already one row
          el.classList.add('is-stuck');
          var lost = h0 - el.offsetHeight;
          el.style.marginBottom = lost > 0 ? lost + 'px' : '';
        } else {
          el.classList.remove('is-stuck');
          el.style.marginBottom = '';
        }
      });
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }
    function start() {
      collect();
      if (!bars.length) return;
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', function () {
        bars.forEach(function (el) { el.classList.remove('is-stuck'); el.style.marginBottom = ''; });
        queue();
      });
      queue();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  /* A FULL-WIDTH BANNER FIRST ON THE PAGE BECOMES A CARD UNDER THE MENU (2026-10-05, asked: "an empty part behind
     the menu"). The island floats with page background around it; a banner running edge to edge right below it left
     a strip of nothing above the picture. The Nomad way: the first full-width banner of a page is inset to the
     island's own edges, rounded, 12px under it, so menu and banner read as one stack on any page. Found by shape,
     not by name, so a new landing page is covered too. Not on the homepage (its hero is built for the island), and
     never on pages whose content is kept exactly as live (window.swbLiveContent). */
  (function heroInset() {
    if (window.swbLiveContent || document.documentElement.classList.contains('v2-home')) return;
    if (/^\/(\w{2}\/)?$/.test(location.pathname)) return;
    function run() {
      var isl = document.querySelector('.v2-hdr__island');
      var main = document.querySelector('main');
      if (!isl || !main) return;
      var ib = isl.getBoundingClientRect(), vw = document.documentElement.clientWidth;
      var limit = ib.bottom + scrollY + 60;
      var walk = main.querySelectorAll('*');
      for (var i = 0; i < walk.length; i++) {
        var e = walk[i], b = e.getBoundingClientRect();
        if (!b.height) continue;
        if (b.top + scrollY > limit) { if (b.height < innerHeight * 1.05) return; continue; } // the page does not open with a banner
        if (b.width < vw * 0.97 || b.height < 180 || b.height > innerHeight * 1.05) continue; // a banner, not a page wrapper
        var hasMedia = e.querySelector('img, video, picture') || getComputedStyle(e).backgroundImage !== 'none';
        if (!hasMedia) continue;
        document.documentElement.style.setProperty('--v2-inset-x', Math.max(8, Math.round(ib.left)) + 'px');
        e.classList.add('v2-hero-inset');
        return;
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    window.addEventListener('resize', function () {
      var isl = document.querySelector('.v2-hdr__island');
      if (isl) document.documentElement.style.setProperty('--v2-inset-x', Math.max(8, Math.round(isl.getBoundingClientRect().left)) + 'px');
    });
  })();

  /* ACCESSORY PAGES FOLLOW YOUR WATCH (2026-10-05, asked: "some accessory pages work with the switch module, others
     don't"). Accessories have no collection per model like straps do; they are filtered on one facet,
     custom.collection_filter_suitable_for, whose values are "Brand Model" ("Samsung Galaxy Watch 6 Classic (47mm)").
     The old switch module only applied it on the collections in one menu, and only with a value it had stored itself.
     Now every accessory collection (any market's handle) matches the chosen watch to that facet on the page itself,
     filters once, and says so above the products, with "another watch" and "show all accessories". A visitor who
     asks for everything keeps everything on that page for the visit. */
  (function accFit() {
    var m = location.pathname.match(/\/collections\/([^/?#]+)/);
    if (!m) return;
    /* an accessory page is one the accessories section lists (its tiles' collections, this market's URLs) or one
       whose handle says so. The category handles alone (smartwatch-cases, smartwatch-opladers) said nothing, so only
       the hub ever filtered (2026-10-14). Not memoised: the list is parsed with the page, after this script. */
    function isAccPage() {
      if (/accessor|accessoir|accesor|zubeh|xoxo|bandz|strap-?it|reqior|reqoir/i.test(m[1]) && document.querySelector('.collection__results')) return true;
      try {
        var lst = document.querySelector('script[data-v2-acc-pages]');
        var here = location.pathname.replace(/\/+$/, '');
        return !!lst && (JSON.parse(lst.textContent) || []).some(function (u) { return String(u).split('?')[0].replace(/\/+$/, '') === here; });
      } catch (e) { return false; }
    }
    /* ONLY a real accessory page (2026-10-30, owner: on a XoXo collection the watch panel said "Bekijk accessoires" and
       its button did nothing): isAccPage also counts the strap brands' own pages (xoxo, bandz, strap-it, reqior) for
       the filter above, but the pickers there are about straps. Here: the handle says accessories, or the page is one
       of the accessories section's own category collections. */
    function isAccOnly() {
      if (/accessor|accessoir|accesor|zubeh/i.test(m[1]) && document.querySelector('.collection__results')) return true;
      try {
        var lst = document.querySelector('script[data-v2-acc-pages]');
        var here = location.pathname.replace(/\/+$/, '');
        return !!lst && (JSON.parse(lst.textContent) || []).some(function (u) { return String(u).split('?')[0].replace(/\/+$/, '') === here; });
      } catch (e) { return false; }
    }
    window.swbIsAccPage = isAccOnly; /* the watch pickers word themselves for accessories here (2026-10-29) */
    /* and the header's watch panel says what it does HERE: accessories, not straps */
    (function () {
      var ps = { nl: 'Dan zie je hier alleen de accessoires die op jouw smartwatch passen.', de: 'Dann siehst du hier nur das Zubehör, das zu deiner Smartwatch passt.', fr: 'Vous ne verrez ici que les accessoires compatibles avec votre smartwatch.', es: 'Aquí verás solo los accesorios que encajan con tu smartwatch.', en: 'Then this page only shows the accessories that fit your smartwatch.' };
      var set = function () {
        if (!isAccOnly()) return;
        var lg = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
        document.querySelectorAll('.v2-watchpop__s').forEach(function (p) { p.textContent = ps[lg] || ps.en; });
        document.querySelectorAll('[data-v2-go]').forEach(function (g) {
          var lbl = g.querySelector('[data-v2-go-label]'), bn = g.getAttribute('data-v2-brand-name'), txt;
          if (bn) {
            /* a brand restored before this page was known to be an accessory page: re-word and re-point it */
            var T2 = { nl: 'Alle %b accessoires', de: 'Alles %b Zubehör', fr: 'Tous les accessoires %b', es: 'Todos los accesorios %b', en: 'All %b accessories' };
            txt = (T2[lg] || T2.en).replace('%b', bn);
            g.setAttribute('data-v2-brand-url', location.pathname + '?filter.p.m.custom.brand_collection_filter=' + encodeURIComponent(bn));
          } else if (!g.disabled) {
            var T3 = { nl: 'Bekijk accessoires', de: 'Zubehör ansehen', fr: 'Voir les accessoires', es: 'Ver accesorios', en: 'View accessories' };
            txt = T3[lg] || T3.en;
          }
          if (!txt) return;
          if (lbl) lbl.textContent = txt; else g.textContent = txt;
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', set); else set();
    })();
    var PARAM = 'filter.p.m.custom.collection_filter_suitable_for';
    var SUP = 'swb_acc_all:' + m[1];
    var L = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var TX = {
      nl: ['Alle %n accessoires voor je %m', 'Er zijn nog geen accessoires speciaal voor je %m. Hieronder zie je ons hele aanbod.', 'Je ziet alle accessoires.', 'Kies je smartwatch en zie alleen wat past.', 'Andere smartwatch', 'Toon alle accessoires', 'Alleen voor mijn %m', 'Kies je smartwatch', 'Deze accessoires passen op de %m.', 'Accessoires voor mijn %m', 'Zoek je model', 'Staat je smartwatch er niet bij?', 'Merk', 'Model'],
      de: ['Alle %n Zubehörteile für deine %m', 'Für deine %m gibt es noch kein eigenes Zubehör. Unten siehst du unser ganzes Sortiment.', 'Du siehst das gesamte Zubehör.', 'Wähle deine Smartwatch und sieh nur, was passt.', 'Andere Smartwatch', 'Alles Zubehör zeigen', 'Nur für meine %m', 'Smartwatch wählen', 'Dieses Zubehör passt zur %m.', 'Zubehör für meine %m', 'Modell suchen', 'Deine Smartwatch ist nicht dabei?', 'Marke', 'Modell'],
      fr: ['Les %n accessoires pour votre %m', 'Nous n’avons pas encore d’accessoires dédiés à votre %m. Voici toute notre gamme.', 'Vous voyez tous les accessoires.', 'Choisissez votre smartwatch et ne voyez que ce qui convient.', 'Autre smartwatch', 'Voir tous les accessoires', 'Seulement pour ma %m', 'Choisir ma smartwatch', 'Ces accessoires conviennent à la %m.', 'Accessoires pour ma %m', 'Rechercher votre modèle', 'Votre smartwatch n’est pas dans la liste ?', 'Marque', 'Modèle'],
      es: ['Los %n accesorios para tu %m', 'Aún no tenemos accesorios específicos para tu %m. Aquí ves toda nuestra gama.', 'Estás viendo todos los accesorios.', 'Elige tu smartwatch y ve solo lo que encaja.', 'Otro smartwatch', 'Ver todos los accesorios', 'Solo para mi %m', 'Elige tu smartwatch', 'Estos accesorios son para el %m.', 'Accesorios para mi %m', 'Busca tu modelo', '¿Tu smartwatch no está en la lista?', 'Marca', 'Modelo'],
      en: ['All %n accessories for your %m', 'We don’t have accessories made for your %m yet. Here is our full range.', 'You are seeing all accessories.', 'Choose your smartwatch and see only what fits.', 'Another smartwatch', 'Show all accessories', 'Only for my %m', 'Choose your smartwatch', 'These accessories fit the %m.', 'Accessories for my %m', 'Search your model', 'Smartwatch not listed?', 'Brand', 'Model']
    };
    var T = TX[L] || TX.en;
    /* the xoxo collections get the same pre-filter and strip (2026-10-15, asked), worded for straps */
    /* the house brands' grids get the same pre-filter and strip, worded for straps (xoxo 2026-10-15, then Bandz, Strap-it,
       REQIOR); the brand landing pages themselves carry a template suffix and are left alone by layout/theme.liquid */
    var BRAND = /xoxo/i.test(m[1]) ? 'xoxo' : /bandz/i.test(m[1]) ? 'Bandz' : /strap-?it/i.test(m[1]) ? 'Strap-it' : /reqior|reqoir/i.test(m[1]) ? 'REQIOR' : '';
    var XO = !!BRAND;
    function xoWords(s) {
      if (!XO) return s;
      var b = BRAND;
      var f = {
        nl: function (x) { return x.replace(/accessoires/gi, b + ' bandjes').replace(/accessoire/gi, b + ' bandje'); },
        de: function (x) { return x.replace(/Zubehörteile?/gi, b + ' Armbänder').replace(/Zubehör/gi, b + ' Armbänder'); },
        fr: function (x) { return x.replace(/accessoires/gi, 'bracelets ' + b).replace(/accessoire/gi, 'bracelet ' + b); },
        es: function (x) { return x.replace(/accesorios/gi, 'correas ' + b).replace(/accesorio/gi, 'correa ' + b); }
      }[L] || function (x) { return x.replace(/accessories/gi, b + ' straps').replace(/accessory/gi, b + ' strap'); };
      return f(s);
    }
    T = T.map(xoWords);
    /* one product is "1 accessoire voor je X", not "Alle 1 accessoires" (2026-10-14, asked) */
    var ONE = { nl: '1 accessoire voor je %m', de: '1 Zubeh\u00f6rteil f\u00fcr deine %m', fr: '1 accessoire pour votre %m', es: '1 accesorio para tu %m' }[L] || '1 accessory for your %m';
    ONE = xoWords(ONE);
    function countLine(n, model) { return (n === 1 ? ONE : T[0].replace('%n ', n ? n + ' ' : '')).replace('%m', model); }
    /* the name the filter really matched: "Apple Watch" when only the brand value matched, so the strip never claims
       "for your Apple Watch Series 10" over Ultra cases and 41mm protectors (2026-10-19, pre-launch audit) */
    function fitName(v, model) { return v && !/\d/.test(v) ? v : model; }
    // the market's "all accessories" collection (handles are translated per market)
    var ACC_ALL = { nl: 'smartwatch-accessoires', de: 'smartwatch-zubehoer', fr: 'accessoires', es: 'accesorios' }[L] || 'accessories';
    function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    function nums(s) { return (norm(s).match(/\d+(mm)?/g) || []).join(','); }
    function options() {
      var seen = {}, out = [];
      document.querySelectorAll('input[name="' + PARAM + '"]').forEach(function (i) {
        if (seen[i.value]) return;
        seen[i.value] = 1;
        var lab = document.querySelector('label[for="' + i.id + '"]');
        var c = lab && lab.textContent.match(/\((\d+)\)\s*$/);
        out.push({ v: i.value, n: c ? +c[1] : 0 });
      });
      return out;
    }
    function match(w, opts) {
      if (!w || !w.model) return null;
      var a = norm(w.model), b = norm((w.brand || '') + ' ' + w.model), wn = nums(w.model);
      var core = b.split(' ').filter(function (t) { return !/^\d+mm$/.test(t); }); // the watch without its case size
      var best = null, bs = 0;
      opts.forEach(function (o) {
        var v = norm(o.v), vn = nums(o.v), s = 0;
        if (vn === wn) {
          s = (v === a || v === b) ? 100 : 0;
          if (!s) {
            var at = b.split(' ');
            var hit = at.filter(function (t) { return (' ' + v + ' ').indexOf(' ' + t + ' ') > -1; }).length;
            s = hit / Math.max(at.length, v.split(' ').length) * 90;
          }
        } else if (vn && wn.indexOf(vn + ',') === 0) {
          /* the value names the model without a size (2026-10-08: a Fenix 9 (47mm) found nothing, the accessories are
             tagged "Garmin Fenix 9"). Only when it is the SAME watch: every word of the watch bar its size. 6 vs 7
             and 44mm vs 47mm are still never a near miss. */
          var vt = ' ' + v + ' ';
          if (v.split(' ').length === core.length && core.every(function (t) { return vt.indexOf(' ' + t + ' ') > -1; })) s = 85;
        } else if (!vn && v === 'apple watch' && /^apple/.test(b)) {
          s = 80; // every Apple accessory is tagged plain "Apple Watch"
        }
        if (s > bs) { bs = s; best = o; }
      });
      return bs >= 70 ? best : null;
    }
    /* Shopify lists only the first 100 models in this filter; the rest still filter, they are just not shown. A watch
       that is not in the list is looked up by asking the collection itself how many products a candidate value has
       (?view=mb-facets: counts only, no products). Remembered for the visit. */
    function resolve(w, done) {
      var hit = match(w, options());
      if (hit || !w || !w.model) return done(hit);
      /* the head script's answer for this page and watch (one request, kept a day): no second round of requests,
         and a page whose own filter list does not name the watch has no match to find (2026-10-16) */
      try { var lc = JSON.parse(localStorage.getItem('swb_fit:' + m[1] + ':' + (w.url || '')) || 'null'); if (lc && !lc.v && Date.now() - lc.t < 864e5) return done(null); } catch (e) {}
      if (options().length > 2) return done(null);
      var key = 'swb_accv:' + m[1] + ':' + (w.brand || '') + '|' + w.model, c = null;
      try { c = sessionStorage.getItem(key); } catch (e) {}
      if (c !== null) return done(c ? JSON.parse(c) : null);
      var full = ((w.brand || '') + ' ' + w.model).trim(), bare = full.replace(/\s*\([^)]*\)/g, '').trim();
      var cands = [full, bare];
      if (/^apple/i.test(full)) cands.push('Apple Watch');
      cands = cands.filter(function (x, i) { return x && cands.indexOf(x) === i; });
      (function next(i) {
        if (i >= cands.length) { try { sessionStorage.setItem(key, ''); } catch (e) {} return done(null); }
        fetch(location.pathname + '?view=mb-facets&' + PARAM + '=' + encodeURIComponent(cands[i]), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (j && j.products > 0) {
              var h = { v: cands[i], n: j.products };
              try { sessionStorage.setItem(key, JSON.stringify(h)); } catch (e) {}
              return done(h);
            }
            next(i + 1);
          })
          .catch(function () { next(i + 1); });
      })(0);
    }
    /* ONLY WATCHES WE HAVE ACCESSORIES FOR (2026-10-28, asked: "ensure that models don't appear which don't have
       accessories"). The picker borrows the header's full watch list. Brands: only those the page's brand filter lists
       with products. Models: once a brand is chosen, the page is asked for its filter counts with that brand applied
       (?view=mb-facets, counts only; Shopify lists the values that have products first, so the 100-value cap does not
       hide any), and only models one of those values fits stay (the same match the strip uses: sizes, plain "Apple
       Watch"). A brand whose accessories name no model (Suunto, Withings) goes straight to that brand's accessories.
       No answer: the full list stays. */
    function onlyWithAcc(pk) {
      var bs = pk.querySelector('[data-v2-brand]'), ms = pk.querySelector('[data-v2-model]');
      if (!bs || !ms) return;
      var BP = 'filter.p.m.custom.brand_collection_filter';
      var bvals = [];
      document.querySelectorAll('input[name="' + BP + '"]').forEach(function (i) {
        var lab = document.querySelector('label[for="' + i.id + '"]');
        var c = lab && lab.textContent.match(/\((\d+)\)\s*$/);
        if ((!c || +c[1] > 0) && bvals.indexOf(i.value) < 0) bvals.push(i.value);
      });
      function bfacet(name) {
        var n = norm(name), hit = '';
        bvals.forEach(function (v) { var x = norm(v); if (!hit && x === n) hit = v; });
        bvals.forEach(function (v) { var x = norm(v); if (!hit && x && (n.indexOf(x + ' ') === 0 || x.indexOf(n + ' ') === 0)) hit = v; });
        return hit;
      }
      if (bvals.length) [].slice.call(bs.options).forEach(function (o) { if (o.value && !bfacet(o.textContent)) o.remove(); });
      var MEMO = window.__v2AccBrand || (window.__v2AccBrand = {});
      bs.addEventListener('change', function () {
        var name = bs.value !== '' && bs.options[bs.selectedIndex] ? bs.options[bs.selectedIndex].textContent.trim() : '';
        var fv = name && bfacet(name);
        if (!fv) return;
        var u = location.pathname + '?view=mb-facets&' + BP + '=' + encodeURIComponent(fv);
        ms.disabled = true;
        (MEMO[u] || (MEMO[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })['catch'](function () { return null; })))
          .then(function (j) {
            var now = bs.value !== '' && bs.options[bs.selectedIndex] ? bs.options[bs.selectedIndex].textContent.trim() : '';
            if (now !== name) return; // another brand was chosen meanwhile
            ms.disabled = false;
            var rows = j && j.filters && j.filters[PARAM];
            if (!rows) return;
            var vals = rows.filter(function (x) { return x.c > 0; }).map(function (x) { return { v: x.v, n: x.c }; });
            if (!vals.length) {
              if (!(j.products > 0)) return;
              var bu = new URL(location.href);
              bu.searchParams.delete(PARAM); bu.searchParams.delete(BP); bu.searchParams.delete('page');
              bu.searchParams.append(BP, fv);
              location.href = bu.toString();
              return;
            }
            [].slice.call(ms.querySelectorAll('option')).forEach(function (o) {
              if (o.value && !match({ brand: name, model: o.textContent }, vals)) o.remove();
            });
            [].slice.call(ms.querySelectorAll('optgroup')).forEach(function (g) { if (!g.querySelector('option')) g.remove(); });
          });
      });
    }
    var PICK_BRAND = '', noGo = false;
    function go(val) {
      var u = new URL(location.href);
      u.searchParams.delete(PARAM);
      u.searchParams.delete('page');
      /* not on top of a brand filter with the same label (2026-10-16: two "Apple Watch" chips); a MODEL inside a brand
         filter (Withings + ScanWatch 2) is added (2026-10-19) */
      var bfv = u.searchParams.getAll('filter.p.m.custom.brand_collection_filter');
      if (val && !bfv.some(function (b) { return norm(b) === norm(val); })) u.searchParams.set(PARAM, val);
      if (u.href !== location.href) { document.documentElement.classList.add('v2-nav'); location.replace(u.href); }
    }
    function openPicker() {
      var pill = document.querySelector('[data-v2-watch-open]');
      if (pill && pill.getClientRects().length) { setTimeout(function () { pill.click(); }, 0); return; } /* the header's own picker on every screen (2026-10-16, asked) */
      var burger = document.querySelector('.v2-hdr__burger');
      if (burger) {
        burger.click();
        setTimeout(function () { var dp = document.querySelector('.v2-sdev__pill'); if (dp) dp.click(); }, 450);
      }
    }
    function run() {
      if (!isAccPage()) return;
      var opts = options();
      var w = readWatch();
      /* the page is filtered to ANOTHER brand than the saved watch (a "Samsung" tile tapped with an Apple Watch saved):
         nothing here is about that watch, so no strip and no "nothing for your watch" line (2026-10-17, asked) */
      var bf = new URL(location.href).searchParams.getAll('filter.p.m.custom.brand_collection_filter');
      PICK_BRAND = bf.length ? bf[0] : '';
      if (bf.length && w && w.brand) {
        var wb = norm(w.brand).split(' ')[0];
        /* another brand than the saved watch: the page offers a model of THAT brand right here (2026-10-19, asked: "missing
           a model selector") instead of saying nothing */
        if (!bf.some(function (v) { var n = norm(v); return n.split(' ')[0] === wb || n.indexOf(wb) > -1; })) {
          /* a grid without its fit list (too big to print one) still gets the picker; the choice resolves through the
             count-only view like everywhere else */
          return decide(opts.length > 2 ? opts : [{ v: '', n: 0 }, { v: '', n: 0 }, { v: '', n: 0 }], null, new URL(location.href).searchParams.getAll(PARAM), false, null);
        }
      }
      var cur = new URL(location.href).searchParams.getAll(PARAM);
      var sup = false;
      try { sup = !!sessionStorage.getItem(SUP); } catch (e) {}
      /* a big brand grid (Bandz, over 5,000 products) prints no fit facet, so the page has no options to read; once the
         head script has filtered it, the strip still says so, counted from the count-only view (2026-10-15) */
      if (!opts.length) {
        if (!w || !w.model) return;
        if (cur.length !== 1) { if (XO) decide([{ v: '', n: 0 }, { v: '', n: 0 }, { v: '', n: 0 }], w, [], sup, null); return; } /* a brand grid too big to filter: offer the watch's own collection with this brand */
        fetch(location.pathname + '?view=mb-facets&' + PARAM + '=' + encodeURIComponent(cur[0])).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
          if (!j || !j.products) return;
          /* above 5,000 products Shopify ignores the filter (the count comes back unfiltered): drop the dead parameter and
             offer the watch's own collection with this brand instead */
          if (j.products > 5000) {
            try { var u0 = new URL(location.href); u0.searchParams.delete(PARAM); history.replaceState(history.state, '', u0.pathname + u0.search + u0.hash); } catch (e) {}
            decide([{ v: '', n: 0 }, { v: '', n: 0 }, { v: '', n: 0 }], w, [], sup, null);
            return;
          }
          decide([{ v: cur[0], n: j.products }, { v: '', n: 0 }, { v: '', n: 0 }], w, cur, sup, { v: cur[0], n: j.products });
        }).catch(function () {});
        return;
      }
      resolve(w, function (hit) { decide(opts, w, cur, sup, hit); });
    }
    /* the category carousel sits under the watch module (2026-10-16, asked), so the page reads: your watch, then
       what kind of accessory, then the products */
    function subsUnder(bar) {
      var acc = document.querySelector('.shopify-section--swb-v2-accessories .v2-acc');
      if (!acc || !bar || !bar.parentNode) return;
      var sec = acc.closest('.shopify-section');
      var box = document.createElement('div');
      box.className = 'v2-root v2-acc-under';
      box.appendChild(acc);
      bar.parentNode.insertBefore(box, bar.nextSibling);
      if (sec) sec.classList.add('v2-acc-moved');
    }
    function decide(opts, w, cur, sup, hit) {
      /* the answer for an older watch arrived after the page switched to another one (opening "Bip 6 accessoires" from the
         menu makes Bip 6 the watch while the lookup for the previous Redmi was still out): start again with the watch
         that is saved now, never draw a strip for the old one (2026-10-28, asked) */
      var nowW = w && readWatch();
      if (w && nowW && nowW.url && w.url && nowW.url !== w.url) { noGo = true; run(); return; }
      try { if (w && w.url && !sup) sessionStorage.setItem('swb_accgo:' + m[1] + ':' + w.url, hit && opts.length > 2 ? hit.v : ''); } catch (e) {}
      /* a collection made for ONE model (accessories-fitbit-charge-4 and the like): no filtering; say which watch
         it is for, and lead a visitor with another watch to theirs */
      var single = opts.length <= 2;
      if (single) {
        var main = opts.slice().sort(function (x, y) { return y.n - x.n; })[0];
        var res1 = document.querySelector('.collection__results');
        if (!res1 || document.querySelector('.v2-accbar')) return;
        var mine = hit && hit.v === main.v;
        var bar1 = document.createElement('div');
        bar1.className = 'v2-accbar';
        bar1.innerHTML = '<span class="v2-accbar__ico" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="7" y="7" width="10" height="10" rx="3" stroke="currentColor" stroke-width="2"/><path d="M9 7V4h6v3M9 17v3h6v-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span><p class="v2-accbar__t"></p><span class="v2-accbar__acts"></span>';
        bar1.querySelector('.v2-accbar__t').textContent = mine ? countLine(main.n, fitName(main.v, w.model)) : T[8].replace('%m', main.v);
        /* REQIOR is made for two Apple Watch sizes only: say which, not just "the Apple Watch" (2026-10-19, pre-launch audit) */
        if (BRAND === 'REQIOR' && !mine) bar1.querySelector('.v2-accbar__t').textContent = ({ nl: 'REQIOR past op de Apple Watch 7, 8 en 9 (45mm) en de Ultra (49mm).', de: 'REQIOR passt zur Apple Watch 7, 8 und 9 (45mm) und zur Ultra (49mm).', fr: 'REQIOR convient à l’Apple Watch 7, 8 et 9 (45mm) et à l’Ultra (49mm).', es: 'REQIOR encaja en el Apple Watch 7, 8 y 9 (45mm) y en el Ultra (49mm).' }[L] || 'REQIOR fits the Apple Watch 7, 8 and 9 (45mm) and the Ultra (49mm).');
        if (!mine && w && w.model) {
          var l1 = document.createElement('a');
          l1.className = 'v2-accbar__b v2-accbar__b--mine';
          l1.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'collections/' + ACC_ALL;
          l1.textContent = T[9].replace('%m', w.model);
          /* a house brand made for one watch (REQIOR: Apple Watch only) has nothing for this visitor's watch: offer THEIR
             watch's own straps, not "<brand> straps for my <watch>" pointing at the accessories (2026-10-17, asked) */
          if (XO && w.url) {
            l1.href = w.url;
            l1.textContent = ({ nl: 'Bandjes voor mijn %m', de: 'Armbänder für meine %m', fr: 'Bracelets pour ma %m', es: 'Correas para mi %m' }[L] || 'Straps for my %m').replace('%m', w.model);
          }
          bar1.querySelector('.v2-accbar__acts').appendChild(l1);
        }
        res1.insertBefore(bar1, res1.firstChild);
        subsUnder(bar1);
        return;
      }
      /* never reload under a visitor who is already reading (2026-10-16, asked: on brand pages the products changed after
         scrolling). Only straight away and before any scroll; later the bar offers the filter as a button. */
      var late = false;
      if (hit && !cur.length && !sup) {
        if (!noGo && window.scrollY < 120 && performance.now() < 2500) { go(hit.v); return; }
        late = true;
      }
      var res = document.querySelector('.collection__results');
      if (!res || document.querySelector('.v2-accbar')) return;
      var model = w && (typeof watchLabel === 'function' ? watchLabel(w) : w.model); /* "Fitbit Air", not "Air" (2026-10-19) */
      var txt, acts;
      if (cur.length === 1 && hit && cur[0] === hit.v) {
        txt = countLine(hit.n, fitName(hit.v, model));
        acts = [['alt', T[4]], ['all', T[5]]];
      } else if (late && model) {
        var FIT = { nl: 'Toon alleen wat past', de: 'Nur Passendes zeigen', fr: 'Afficher ce qui est compatible', es: 'Mostrar solo lo compatible' }[L] || 'Show only what fits';
        txt = countLine(hit.n, fitName(hit.v, model));
        acts = [['fit', FIT], ['alt', T[4]]];
      } else if (model && !hit) {
        txt = T[1].replace('%m', model);
        // on the all-accessories page itself that button would only reload it
        /* on an xoxo page the better way out is the watch's own strap collection, not accessories (2026-10-15, asked) */
        var XO_L = { nl: 'Alle bandjes voor mijn %m', de: 'Alle Armbänder für meine %m', fr: 'Tous les bracelets pour ma %m', es: 'Todas las correas para mi %m' }[L] || 'All straps for my %m';
        acts = (XO && w && w.url) ? [['xolink', BRAND === 'xoxo' ? XO_L.replace('%m', model) : T[9].replace('%m', model)], ['alt', T[4]]] : m[1] === ACC_ALL ? [['alt', T[4]]] : [['link', T[9].replace('%m', model)], ['alt', T[4]]];
      } else if (model && hit && sup) {
        txt = T[2];
        acts = [['mine', T[6].replace('%m', model)], ['alt', T[4]]];
      } else if (!model) {
        txt = T[3];
        if (PICK_BRAND) txt = ({ nl: 'Welke %b heb je? Kies je model en zie alleen wat past.', de: 'Welche %b hast du? Wähle dein Modell und sieh nur, was passt.', fr: 'Quelle %b avez-vous ? Choisissez votre modèle et ne voyez que ce qui convient.', es: '¿Qué %b tienes? Elige tu modelo y ve solo lo que encaja.' }[L] || 'Which %b do you have? Pick your model and see only what fits.').replace('%b', PICK_BRAND);
        /* the picker ON the page (2026-10-14, asked: "a small selection module there"): brand and model right here,
           no trip to the header. The header's own component, fed by the brand list the header already prints; a
           chosen model is written like any other pick (cart, island, every page) and this page filters on the event
           below. Without that list (no v2 header on the page) the button that opens the header's picker stays. */
        acts = document.querySelector('script[id^="v2-brands-"]') ? [['inline', '']] : [['pick', T[7]]];
      } else {
        return;
      }
      var bar = document.createElement('div');
      bar.className = 'v2-accbar';
      bar.innerHTML = '<span class="v2-accbar__ico" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="7" y="7" width="10" height="10" rx="3" stroke="currentColor" stroke-width="2"/><path d="M9 7V4h6v3M9 17v3h6v-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span><p class="v2-accbar__t"></p><span class="v2-accbar__acts"></span>';
      bar.querySelector('.v2-accbar__t').textContent = txt;
      acts.forEach(function (a) {
        if (a[0] === 'inline') {
          bar.classList.add('v2-accbar--pick');
          var pk = document.createElement('div');
          pk.className = 'v2-root v2-pick v2-pick--compact v2-pick--acc';
          pk.setAttribute('data-v2-pick', '');
          pk.setAttribute('data-v2-source', 'auto');
          pk.innerHTML = '<div class="v2-pick__row">' +
            '<div class="v2-pick__field"><label class="v2-sr" for="v2-accb">' + T[12] + '</label><select class="v2-pick__select" id="v2-accb" data-v2-brand><option value="">' + T[12] + '</option></select></div>' +
            '<div class="v2-pick__field"><label class="v2-sr" for="v2-accm">' + T[13] + '</label><select class="v2-pick__select" id="v2-accm" data-v2-model data-placeholder="' + T[13] + '" disabled><option value="">' + T[13] + '</option></select></div>' +
            '</div>';
          bar.querySelector('.v2-accbar__acts').appendChild(pk);
          initPicker(bar);
          onlyWithAcc(pk);
          /* the brand of the page's brand filter is already chosen: only the model is left to pick */
          if (PICK_BRAND) {
            var bs = pk.querySelector('[data-v2-brand]');
            var want = norm(PICK_BRAND), hitOpt = null;
            if (bs) [].forEach.call(bs.options, function (o) { if (!hitOpt && o.value && (norm(o.textContent) === want || norm(o.textContent).indexOf(want) === 0 || want.indexOf(norm(o.textContent)) === 0)) hitOpt = o; });
            if (hitOpt) { bs.value = hitOpt.value; bs.dispatchEvent(new Event('change', { bubbles: true })); }
          }
          return;
        }
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'v2-accbar__b v2-accbar__b--' + a[0];
        btn.textContent = a[1];
        btn.addEventListener('click', function (ev) {
          ev.stopPropagation();
          if (a[0] === 'alt' || a[0] === 'pick') { openPicker(); return; }
          if (a[0] === 'fit') { go(hit.v); return; }
          if (a[0] === 'xolink') { location.href = BRAND === 'xoxo' ? w.url : w.url + '?filter.p.vendor=' + encodeURIComponent(BRAND); return; }
          if (a[0] === 'link') { location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'collections/' + ACC_ALL; return; }
          if (a[0] === 'all') {
            try { sessionStorage.setItem(SUP, '1'); } catch (e) {}
            // the old switch module would put its own filter back: its stored value goes too
            postCartAttributes({ 'switch-module-filter': '' });
            setTimeout(function () { go(null); }, 150);
            return;
          }
          if (a[0] === 'mine') {
            try { sessionStorage.removeItem(SUP); } catch (e) {}
            go(hit.v);
          }
        });
        bar.querySelector('.v2-accbar__acts').appendChild(btn);
      });
      // inside the results column, above the products (not as a sibling in the filters' grid)
      res.insertBefore(bar, res.firstChild);
      subsUnder(bar);
    }
    // a new watch, from any picker: this page follows it
    document.addEventListener(EVENT, function (ev) {
      if (!isAccPage()) return;
      /* a quiet change (the watch taken over from the page or another picker) never reloads, but the strip must name the
         new watch: it said "Accessoires voor mijn Redmi Watch 2 Lite" under a header pill already showing Bip 6
         (2026-10-28, asked) */
      if (writingQuietly) {
        if (!document.querySelector('.v2-accbar')) return;
        setTimeout(function () {
          document.querySelectorAll('.v2-accbar').forEach(function (b) { b.remove(); });
          noGo = true;
          run(); // noGo stays on: the answer can arrive later and must not reload either
        }, 0);
        return;
      }
      try { sessionStorage.removeItem(SUP); } catch (e) {}
      resolve(ev.detail, function (hit) {
        if (hit) { go(hit.v); return; }
        /* nothing here for that watch: a filtered page reloads unfiltered (and says so on load); an unfiltered one
           says so now, in the bar, so a pick in the bar's own selects never looks ignored */
        if (new URL(location.href).searchParams.getAll(PARAM).length) { go(null); return; }
        document.querySelectorAll('.v2-accbar').forEach(function (b) { b.remove(); });
        decide(options(), ev.detail, [], false, null);
      });
    });
    function facetSearch() {
      if (!isAccPage()) return;
      document.querySelectorAll('details[id$="collection_filter_suitable_for"]').forEach(function (d) {
        if (d.querySelector('.v2-accsearch')) return;
        var first = d.querySelector('input[name="' + PARAM + '"]');
        var list = first && (first.closest('ul') || first.closest('.accordion__content'));
        if (!list) return;
        var box = document.createElement('div');
        box.className = 'v2-accsearch';
        box.innerHTML = '<input type="search" class="v2-accsearch__in" autocomplete="off" enterkeyhint="search"><p class="v2-accsearch__none" hidden></p>';
        var inp = box.querySelector('input'), none = box.querySelector('.v2-accsearch__none');
        inp.placeholder = T[10];
        inp.setAttribute('aria-label', T[10]);
        none.textContent = T[11] + ' ';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'v2-accsearch__pick';
        b.textContent = T[7];
        b.addEventListener('click', function (ev) { ev.preventDefault(); openPicker(); });
        none.appendChild(b);
        inp.addEventListener('input', function () {
          var q = norm(inp.value).split(' ').filter(Boolean), shown = 0;
          list.querySelectorAll('input[name="' + PARAM + '"]').forEach(function (i) {
            var row = i.closest('li') || i.parentNode;
            var nm = ' ' + norm(i.value) + ' '; // the model name only: the label also carries a product count
            var ok = q.every(function (t, k) { return k === q.length - 1 ? nm.indexOf(' ' + t) > -1 : nm.indexOf(' ' + t + ' ') > -1; });
            row.style.display = ok ? '' : 'none';
            if (ok) shown++;
          });
          none.hidden = !(q.length && shown < 3);
        });
        list.parentNode.insertBefore(box, list);
      });
    }
    facetSearch();
    var fsRaf = 0; // the filter drawer is re-rendered after every filter change: put the search back, once per frame
    new MutationObserver(function () { if (!fsRaf) fsRaf = requestAnimationFrame(function () { fsRaf = 0; facetSearch(); }); }).observe(document.body, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();


  /* UNIVERSAL PRODUCT PAGE EXTRAS (2026-10-14, asked: "the features the live product page has"): the shortlist heart on
     the photo for the strap on screen, and the points line following the price (sections/universal-product-page) */
  (function uppExtras() {
    var root = document.querySelector('.upp');
    if (!root) return;
    var pts = root.querySelector('[data-v2-upp-points]');
    document.addEventListener('swb-v2:upp-price', function (ev) {
      if (!pts) return;
      var n = Math.round((ev.detail && ev.detail.price) || 0);
      pts.hidden = !n;
      pts.querySelectorAll('.lr-points__amt').forEach(function (a) { a.textContent = '+' + n; });
    });
    var heart = null;
    function place(h) {
      var wrap = root.querySelector('.upp__stage') || root.querySelector('.upp__stagewrap');
      if (!wrap || !h || !window.swbShortlist) return;
      if (!heart) {
        heart = document.createElement('button');
        heart.type = 'button';
        heart.className = 'v2-heart v2-heart--pdpimg v2-heart--upp';
        heart.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3l-1.3-1.2C5.9 14.8 3 12.1 3 8.8 3 6.1 5.1 4 7.8 4c1.6 0 3.1.8 4.2 2 1.1-1.2 2.6-2 4.2-2C18.9 4 21 6.1 21 8.8c0 3.3-2.9 6-7.7 10.3z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>';
        heart.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); var on = window.swbShortlist.toggle(heart.getAttribute('data-v2-heart')); heart.classList.remove('is-pop'); void heart.offsetWidth; if (on) heart.classList.add('is-pop'); });
        if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
        wrap.appendChild(heart);
        window.swbShortlist.onChange(paint);
      }
      if (!heart.isConnected) wrap.appendChild(heart); // the page redraws its photo stage on a colour change
      heart.setAttribute('data-v2-heart', h);
      paint();
    }
    function paint() { if (!heart) return; var on = window.swbShortlist.has(heart.getAttribute('data-v2-heart')); heart.classList.toggle('is-on', on); heart.setAttribute('aria-pressed', on ? 'true' : 'false'); }
    document.addEventListener('swb-v2:upp-product', function (ev) { place(ev.detail && ev.detail.handle); });
    new MutationObserver(function () { if (heart && !heart.isConnected) late(); }).observe(root, { childList: true, subtree: true });
    function late() { if (root.getAttribute('data-v2-handle')) place(root.getAttribute('data-v2-handle')); }
    late(); window.addEventListener('load', late); setTimeout(late, 2500); // the shortlist script loads after this one
  })();

  /* phone promises: one at a time (see PHONE PROMISES, ONE AT A TIME in swb-v2.css) */
  (function initUspFade() {
    var list = document.querySelector('.shopify-section--swb-v2-usp .v2-usp:not(.v2-usp--clone)');
    if (!list || reduceMotion || !window.matchMedia('(max-width: 749px)').matches) return;
    var items = list.querySelectorAll('.v2-usp__i');
    if (items.length < 2) return;
    var i = 0;
    var vp = list.parentElement;
    if (vp) { vp.scrollLeft = 0; vp.addEventListener('scroll', function () { vp.scrollLeft = 0; }); }
    list.classList.add('is-fading');
    items[0].classList.add('is-on');
    setInterval(function () {
      if (document.hidden) return;
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 3200);
  })();

  /* phone materials grid: a tile is a link to its material page (no in-place video) */
  document.addEventListener('click', function (ev) {
    if (!window.matchMedia('(max-width: 899px)').matches) return;
    var sl = ev.target.closest && ev.target.closest('.v2-stage.is-grid .v2-stage__slide');
    if (!sl) return;
    var a = sl.querySelector('a.v2-stage__capgo, a[href*="/pages/materials"]');
    if (!a) return;
    ev.preventDefault();
    ev.stopPropagation();
    location.href = a.href;
  }, true);

  /* THE WATCH IN THE MODEL BOX (2026-10-06, asked: "an image of a watch somewhere in the model searcher"). Once a
     model is chosen, its collection's own image appears inside the model box of every picker (hero, header pop-up,
     the picker at the foot of the page). One fetch per model, cached; no image, no change. */
  (function pickThumbs() {
    return; // no photo next to the chosen model any more (2026-10-15, asked)
    var cache = {};
    function imgFor(url) {
      if (!url || url.indexOf('/collections/') < 0) return Promise.resolve(null);
      var path = url.split('?')[0].replace(/\/$/, '');
      if (cache[path]) return cache[path];
      cache[path] = fetch(path + '.json', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d && d.collection && d.collection.image ? d.collection.image.src : null; })
        ['catch'](function () { return null; });
      return cache[path];
    }
    function paint(sel) {
      var field = sel && sel.closest('.v2-pick__field');
      if (!field) return;
      var url = sel.value;
      var old = field.querySelector('.v2-pick__thumb');
      if (!url) {
        if (old) old.remove();
        field.classList.remove('has-thumb');
        return;
      }
      imgFor(url).then(function (src) {
        if (sel.value !== url) return; // changed again meanwhile
        if (!src) { if (old) old.remove(); field.classList.remove('has-thumb'); return; }
        var t = field.querySelector('.v2-pick__thumb');
        if (!t) {
          t = document.createElement('span');
          t.className = 'v2-pick__thumb';
          t.setAttribute('aria-hidden', 'true');
          t.innerHTML = '<img alt="" width="44" height="44" decoding="async">';
          field.appendChild(t);
        }
        t.querySelector('img').src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        field.classList.add('has-thumb');
      });
    }
    function all() {
      document.querySelectorAll('.v2-pick__field select[data-v2-model]').forEach(paint);
    }
    document.addEventListener('change', function (ev) {
      var s = ev.target;
      if (s && s.matches && s.matches('.v2-pick__field select[data-v2-model]')) paint(s);
      if (s && s.matches && s.matches('.v2-pick__field select[data-v2-brand]')) setTimeout(all, 0);
    });
    document.addEventListener(EVENT, function () { setTimeout(all, 60); });
    if (document.readyState === 'complete') setTimeout(all, 300); else window.addEventListener('load', function () { setTimeout(all, 300); });
  })();

  /* A PINNED BAR LEAVES QUIETLY (2026-10-07, asked: "the bundle builder sticky header glitches"). When the section
     holding a pinned bar ends, the browser pushes the bar up, through the island. Any bar under the island
     (data-v2-sub-on) fades out the moment it starts being pushed, and fades back when it is pinned again. */
  (function subLeave() {
    var queued = false;
    function check() {
      queued = false;
      document.querySelectorAll('[data-v2-sub]').forEach(function (el) {
        var leaving = false;
        if (el.hasAttribute('data-v2-sub-on')) {
          var top = parseFloat(getComputedStyle(el).top) || 0;
          leaving = el.getBoundingClientRect().top < top - 2;
        }
        el.classList.toggle('v2-sub-leaving', leaving);
      });
    }
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(check);
    }, { passive: true });
  })();

  /* FAQ ANSWERS LINK ONWARD (2026-10-08, asked: "these type of faqs can be smarter with the hyperlinks already in the
     answer so they dont need to go and find ... useful for most pages with faqs except pdps"). Every FAQ answer on
     the site (customer service, collection and size-guide accordions, materials and landing pages) gets its key
     phrase turned into a link to the page that answers it: returns, shipping and tracking, contact, payment, the
     model finder, the size guide, the bundle builder. At most two links per answer, one per destination, never to
     the page you are on, never inside an existing link. Product pages and the cart are left alone on purpose: there
     the visitor should stay. The homepage FAQ already carries its links in its HTML and is skipped. */
  (function faqLinks() {
    var path = location.pathname;
    if (/\/(products|cart)(\/|$)/.test(path) || document.querySelector('[class*="upp__"]')) return;
    var L = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var MODEL = { nl: 'welk-smartwatch-model-heb-ik', de: 'welche-smartwatch-modell-habe-ich', fr: 'quel-est-mon-modele-smartwatch', es: 'que-modelo-de-smartwatch-tengo', en: 'which-smartwatch-model-do-i-have' };
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function pg(h) { return root.replace(/\/$/, '') + '/pages/' + h; }
    // phrases as they are actually written in the FAQ answers (read from the customer service pages, 2026-10-08)
    var R = {
      nl: [
        ['portal', /retourportaal/i],
        ['model', /welk (smartwatch ?)?model heb ik|je smartwatch-?model|modelnummer/i],
        ['contact', /neem (dan |gerust |alsjeblieft |nu )?contact( met ons)? op/i],
        ['orders', /track ?(en|&) ?trace(-code)?|trackingnummer|trackinginformatie|verzendkosten|levertijd/i],
        ['returns', /retourtermijn( van 100 dagen)?|100 dagen bedenktijd|retourneren|ruilen/i],
        ['payment', /klarna( \(achteraf betalen\))?|achteraf betalen|betaalmethoden?/i],
        ['size', /maattabel|maatgids|polsomtrek|welke maat/i],
        ['bundle', /2 ?\+ ?1( actie| deal)?|bundelkorting/i]
      ],
      de: [
        ['portal', /retourenportal/i],
        ['model', /welches (smartwatch-?)?modell habe ich|dein smartwatch-?modell|modellnummer/i],
        ['contact', /kontaktiere uns|nimm (bitte )?kontakt mit uns auf/i],
        ['orders', /track ?(und|&) ?trace(-nummer)?|sendungsverfolgung|versandkosten|lieferzeit(en)?/i],
        ['returns', /100-tägige rückgabefrist|100 tage (bedenkzeit|rückgaberecht)|rücksendung|umtausch/i],
        ['payment', /klarna( \(kauf auf rechnung\))?|zahlungsmethoden?|zahlungsarten?/i],
        ['size', /größentabelle|größenratgeber|handgelenkumfang/i],
        ['bundle', /2 ?\+ ?1( aktion| angebot)?/i]
      ],
      fr: [
        ['portal', /portail de retour/i],
        ['model', /quel (est mon )?modèle( ai-je)?|le modèle de votre (smartwatch|montre)|numéro de modèle/i],
        ['contact', /nous contacter|contactez-nous/i],
        ['orders', /numéro de suivi|suivi de (colis|commande)|frais de (port|livraison)|délais? de livraison/i],
        ['returns', /politique de retour( de 100 jours)?|100 jours|échanger/i],
        ['payment', /klarna( \(paiement différé\))?|moyens? de paiement|modes? de paiement/i],
        ['size', /guide des tailles|tour de poignet/i],
        ['bundle', /offre 2 ?\+ ?1|2 ?\+ ?1/i]
      ],
      es: [
        ['portal', /portal de devoluciones/i],
        ['model', /qué modelo (de smartwatch )?tengo|el modelo de tu (smartwatch|smartwatch)|número de modelo/i],
        ['contact', /formulario de contacto|contáctanos/i],
        ['orders', /número de seguimiento|herramienta de seguimiento|gastos de envío|tiempos de entrega|plazo de entrega/i],
        ['returns', /política de devolución( de 100 días)?|100 días/i],
        ['payment', /klarna( \(pago aplazado\))?|métodos? de pago|formas? de pago/i],
        ['size', /guía de tallas|contorno de (la )?muñeca/i],
        ['bundle', /3x2|2 ?\+ ?1/i]
      ],
      en: [
        ['portal', /return portal/i],
        ['model', /which (smartwatch )?model do i have|your smartwatch model|model number/i],
        ['contact', /contact us|reach out to us/i],
        ['orders', /tracking number|tracking tool|track ?(and|&) ?trace|delivery times?|standard delivery/i],
        ['returns', /100-day return policy|return policy|100 days/i],
        ['payment', /klarna( \(pay later\))?|payment methods?|pay later/i],
        ['size', /size guide|size chart|wrist size/i],
        ['bundle', /buy 2,? get 1( free)?|2 ?\+ ?1/i]
      ]
    };
    var PORTAL = { nl: 'https://smartwatchbanden.returnless.com/nl/', de: 'https://smartwatcharmbaender.returnless.com/de/', fr: 'https://braceletsmartwatch.returnless.com/fr', es: 'https://smartwatch-straps.returnless.com/es', en: 'https://smartwatch-straps.returnless.com/en' };
    var URLS = {
      portal: PORTAL[L] || PORTAL.en,
      model: pg(MODEL[L] || MODEL.en), size: pg('size-guide'), returns: pg('customer-service-returns'),
      orders: pg('customer-service-orders'), payment: pg('customer-service-payment'), bundle: pg('bundel-builder'),
      contact: pg('customer-service-contact')
    };
    var rules = R[L] || R.en;
    var here = path.replace(/\/$/, '');
    var SEL = '.faq-answer, .accordion__content, .mb-faq__a, .lp-faq__a';
    function link(ans) {
      if (ans.hasAttribute('data-v2-faqlinked') || ans.closest('cart-drawer, x-drawer, form, .v2-hfaq, .v2-chat__dock')) return;
      ans.setAttribute('data-v2-faqlinked', '');
      function abs(u) { try { return new URL(u, location.href).href.replace(/\/$/, ''); } catch (e) { return u; } }
      var have = [].map.call(ans.querySelectorAll('a[href]'), function (a) { return abs(a.href); });
      var made = 0;
      for (var r = 0; r < rules.length && made < 2; r++) {
        var url = URLS[rules[r][0]];
        if (here === url || have.indexOf(abs(url)) > -1) continue;
        var tw = document.createTreeWalker(ans, NodeFilter.SHOW_TEXT, {
          acceptNode: function (n) { return n.parentNode.closest('a, button, summary, h1, h2, h3, h4, h5, h6, script, style') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
        });
        var n, m;
        while ((n = tw.nextNode())) {
          m = rules[r][1].exec(n.nodeValue);
          if (!m) continue;
          var hit = n.splitText(m.index);
          hit.splitText(m[0].length);
          var a = document.createElement('a');
          a.href = url;
          a.className = 'v2-faqlink';
          a.textContent = hit.nodeValue;
          hit.parentNode.replaceChild(a, hit);
          if (/^https?:/.test(url)) { a.target = '_blank'; a.rel = 'noopener'; }
          have.push(abs(url));
          made++;
          break;
        }
      }
    }
    function run() { document.querySelectorAll(SEL).forEach(link); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    // answers that arrive later (tabs, collection grids the theme re-renders after filtering)
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
        var x = ms[i].addedNodes[j];
        if (x.nodeType === 1 && (x.matches(SEL) || x.querySelector(SEL))) { run(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  window.swbV2 = {
    get: readWatch,
    set: writeWatch,
    event: EVENT,
    // true only while a quiet write (a restore, or an echo of a pick the page made itself) is being broadcast
    quiet: function () {
      return writingQuietly;
    },
    // for anything that becomes sticky after load and needs to sit under the island
    restick: function () {
      if (window.swbV2Restick) window.swbV2Restick();
    }
  };
})();

/* POPUPS HANG FROM THE ISLAND ON PHONES (2026-10-15, asked): the watch picker and the loyalty "how it works" box open
   as part of the menu island, flush under it at its width with the island's lower corners squared, so the two read as
   one card unrolling downwards. Not the cart, the filters or the menu sheet. */
(function () {
  var mq = window.matchMedia('(max-width: 989px)');
  var root = document.documentElement, on = {};
  function pop(key, open, el) {
    if (open) on[key] = 1; else delete on[key];
    var isl = document.querySelector('.v2-hdr__island');
    if (!isl || !mq.matches || !Object.keys(on).length) { root.classList.remove('v2-islpop'); return; }
    var b = isl.getBoundingClientRect();
    /* an island scrolled away (the universal page lets the header go): hanging from it put the card at top -1381px,
       with only its backdrop on screen, swallowing the next tap (2026-10-20 sweep); the popup keeps its own place then */
    if (b.bottom < 8 || b.top > window.innerHeight * 0.5 || !b.width) { root.classList.remove('v2-islpop'); return; }
    root.style.setProperty('--v2-islpop-l', b.left + 'px');
    root.style.setProperty('--v2-islpop-w', b.width + 'px');
    root.style.setProperty('--v2-islpop-b', b.bottom + 'px');
    var op = el && el.offsetParent;
    if (op) root.style.setProperty('--v2-islpop-top', (b.bottom - op.getBoundingClientRect().top) + 'px');
    root.classList.add('v2-islpop');
  }
  window.swbV2IslandPop = pop;
  // the loyalty info box is a native <dialog> (top layer); outside the cart drawer it hangs from the island too
  function watchDialogs() {
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        var d = m.target;
        if (!d.matches || !d.matches('.lr-cart-info__dialog') || d.closest('cart-drawer, .cart-drawer, #CartDrawer')) return;
        return; /* the loyalty explainer is a modal in the top layer: hung from the island it slid under the island's own shadow and corners on phones (2026-10-15, asked), centred it reads cleanly with the backdrop over everything */
      });
    }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }
  if (document.body) watchDialogs(); else document.addEventListener('DOMContentLoaded', watchDialogs);
  // the universal product page's added-to-cart and product popups hang from the island too (2026-10-15, asked)
  function watchUpp() {
    [].slice.call(document.querySelectorAll('#upp-main [data-pop], #upp-main [data-qv]')).forEach(function (el, i) {
      new MutationObserver(function () { pop('upp' + i, !el.hidden); }).observe(el, { attributes: true, attributeFilter: ['hidden'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchUpp); else watchUpp();
})();

/* PRODUCT PAGE (2026-10-15, asked): a tap on a photo opens the full-screen zoom; the colour row scrolls freely with
   momentum instead of the slow 700 ms page steps */
(function () {
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var img = t.closest && t.closest('.product-gallery__media img');
    if (!img || t.closest('a, button, video, model-viewer')) return;
    var gal = img.closest('.product-gallery');
    // phones: our own native-scroll viewer (the theme's JS viewer lagged on real phones, 2026-10-15, asked)
    if (gal && window.matchMedia('(hover: none)').matches && openViewer(gal, img)) { ev.preventDefault(); return; }
    var z = gal && gal.querySelector('button[is=product-zoom-button]');
    if (z) { ev.preventDefault(); z.click(); }
  });
  var CLOSE = ({ nl: 'Sluiten', de: 'Schließen', fr: 'Fermer', es: 'Cerrar' })[String(document.documentElement.lang || 'en').slice(0, 2)] || 'Close';
  function big(src) {
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/([?&])width=\d+/, '$1width=1400').replace(/([?&])height=\d+&?/, '$1');
  }
  function openViewer(gal, tapped) {
    var imgs = Array.prototype.slice.call(gal.querySelectorAll('.product-gallery__media[data-media-type=image] img'));
    if (!imgs.length) return false;
    var at = Math.max(0, imgs.indexOf(tapped));
    var v = document.createElement('div');
    v.className = 'v2-zoom';
    v.setAttribute('role', 'dialog');
    v.setAttribute('aria-modal', 'true');
    v.setAttribute('data-v2-own-layer', '');
    v.innerHTML = '<div class="v2-zoom__bar"><span class="v2-zoom__n"></span><button type="button" class="v2-zoom__x" aria-label="' + CLOSE + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button></div><div class="v2-zoom__track"></div>';
    var track = v.querySelector('.v2-zoom__track'), n = v.querySelector('.v2-zoom__n');
    imgs.forEach(function (im, i) {
      var s = document.createElement('div'); s.className = 'v2-zoom__s';
      var b = document.createElement('img'); b.alt = im.alt || ''; b.decoding = 'async';
      b.loading = Math.abs(i - at) < 2 ? 'eager' : 'lazy';
      b.src = big(im.currentSrc || im.src);
      s.appendChild(b); track.appendChild(s);
      // double tap: twice the size, panned natively; again to fit
      var last = 0;
      s.addEventListener('click', function (e) {
        var now = Date.now();
        if (now - last < 320) {
          var on = !s.classList.contains('is-zoomed');
          s.classList.toggle('is-zoomed', on);
          if (on) { s.scrollLeft = (e.offsetX / s.clientWidth) * s.clientWidth; s.scrollTop = (e.offsetY / s.clientHeight) * s.clientHeight; }
          last = 0;
        } else last = now;
      });
    });
    function count() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      n.textContent = (i + 1) + ' / ' + imgs.length;
      return i;
    }
    track.addEventListener('scroll', function () {
      count();
      Array.prototype.forEach.call(track.querySelectorAll('.is-zoomed'), function (s) { s.classList.remove('is-zoomed'); });
    }, { passive: true });
    document.body.appendChild(v);
    var root = document.documentElement, prevOv = root.style.overflow;
    root.style.overflow = 'hidden';
    track.scrollLeft = at * track.clientWidth;
    count();
    var closed = false;
    function close(fromPop) {
      if (closed) return; closed = true;
      var i = count();
      v.classList.remove('is-on');
      root.style.overflow = prevOv;
      window.removeEventListener('popstate', onPop);
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { v.remove(); }, 220);
      // the page's carousel follows to the photo the shopper ended on
      var car = gal.querySelector('media-carousel');
      if (car && typeof car.select === 'function') { try { car.select(i); } catch (e) {} }
      if (!fromPop && history.state && history.state.v2zoom) history.back();
    }
    function onPop() { close(true); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    v.querySelector('.v2-zoom__x').addEventListener('click', function () { close(); });
    // the phone's back button closes the viewer instead of leaving the product
    try { history.pushState({ v2zoom: 1 }, ''); } catch (e) {}
    window.addEventListener('popstate', onPop);
    document.addEventListener('keydown', onKey);
    requestAnimationFrame(function () { v.classList.add('is-on'); });
    return true;
  }
  var tries = 0;
  (function smooth() {
    var el = document.querySelector('.variants-slider');
    var sw = el && el.swiper;
    if (!sw) { if (tries++ < 60 && document.querySelector('.product-gallery')) setTimeout(smooth, 250); return; }
    sw.params.speed = 320;
    // the theme's styles.css pins each tile at 75px while Swiper sized them for 4 per row (72.5px), so its end stop fell
    // short and the last colours could never be reached (2026-10-15, asked); 'auto' makes Swiper measure the real tiles
    sw.params.slidesPerView = 'auto';
    if (sw.params.breakpoints) Object.keys(sw.params.breakpoints).forEach(function (k) { if (sw.params.breakpoints[k].slidesPerView) sw.params.breakpoints[k].slidesPerView = 'auto'; });
    if (sw.params.freeMode && typeof sw.params.freeMode === 'object') {
      sw.params.freeMode.enabled = true;
      sw.params.freeMode.momentum = true;
      sw.params.freeMode.momentumRatio = 0.7;
      sw.params.freeMode.sticky = false;
    }
    sw.update();
  })();
})();

/* STICKY BARS NEVER COVER THE FOOTER, on every page (2026-10-15, asked): as the footer comes into view, any fixed
   bar along the bottom (add-to-cart bar, customer-service tabs, floating filter, ...) is measured once and the
   footer gets that much room below its last line. Bubbles (chat, back to top) are narrow and left alone. */
(function () {
  var foot = document.querySelector('.shopify-section--swb-v2-footer') || document.querySelector('footer');
  if (!foot || !('IntersectionObserver' in window)) return;
  // the room goes on the element that paints the footer's colour, so it reads as more footer, not a grey band
  var pad = foot.querySelector('.v2-foot') || foot; // the navy footer itself, not its transparent section wrapper (2026-10-15: a grey band showed under the footer)
  while (pad.firstElementChild && getComputedStyle(pad).backgroundColor === 'rgba(0, 0, 0, 0)' && getComputedStyle(pad).backgroundImage === 'none') pad = pad.firstElementChild;
  var base = parseFloat(getComputedStyle(pad).paddingBottom) || 0;
  function room() {
    var vh = window.innerHeight, vw = window.innerWidth, need = 0;
    /* only the elements that can be a fixed bar, not every node on the page (7,000 rects at the bottom of a collection) */
    var all = document.querySelectorAll('body > *, body > * > *, [class*="sticky"], [class*="fab"], [class*="float"], [class*="bar"], product-quick-add');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (foot.contains(el) || el.closest('x-drawer, cart-drawer, dialog, .v2-toast, #PBarNextFrameWrapper, #preview-bar-iframe, [id^="trustbadge-container"]')) continue;
      var b = el.getBoundingClientRect();
      /* a bar is at least 300px or half the screen wide (2026-10-28: the desktop product page's floating add-to-cart is
         560px of 1440, under the old half-screen rule, and covered the payment icons); bubbles stay narrower */
      if (b.width < Math.min(vw * 0.5, 300) || b.height < 24 || b.height > vh * 0.4 || b.bottom < vh - 48 || b.top > vh) continue;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.visibility === 'hidden' || cs.opacity === '0' || cs.display === 'none') continue;
      need = Math.max(need, vh - b.top);
    }
    pad.style.paddingBottom = need ? (base + need + 12) + 'px' : '';
  }
  /* measured again while the footer is in view, not once (2026-10-28, asked: "onnodige whitespace helemaal onderaan op
     mobiel, ensure this can never happen"): a cookie banner or pop-up sitting at the bottom when the footer first came
     into view left its room behind after it closed. Now the room follows what is really there. */
  var seen = false, tick = 0, iv = 0;
  function soon() { if (!tick) tick = setTimeout(function () { tick = 0; if (seen) room(); }, 150); }
  new IntersectionObserver(function (es) {
    seen = es[0].isIntersecting;
    clearInterval(iv);
    if (seen) { room(); iv = setInterval(room, 1500); }
  }, { rootMargin: '0px 0px 400px 0px' }).observe(foot);
  window.addEventListener('scroll', soon, { passive: true });
  window.addEventListener('resize', soon);
  document.addEventListener('click', function () { setTimeout(soon, 400); }, true);
})();

/* EMPTY FOR YOUR WATCH (2026-10-15, asked): one friendly empty state wherever a page finds nothing for the saved watch.
   swbV2EmptyForWatch(box, watch) fills box with the line and two ways out: choose another watch, or every strap for
   this one. Used by the materials/occasions browse and by collection pages that come back empty. */
(function () {
  var L = {
    nl: ['Nog niets voor je %m in deze stijl.', 'Kies hierboven een andere stijl, of een andere smartwatch.', 'Andere smartwatch kiezen', 'Alle bandjes voor je %m'],
    de: ['Noch nichts für deine %m in diesem Stil.', 'Wähle oben einen anderen Stil oder eine andere Smartwatch.', 'Andere Smartwatch wählen', 'Alle Armbänder für deine %m'],
    fr: ['Rien pour votre %m dans ce style pour le moment.', 'Choisissez un autre style ci-dessus, ou une autre smartwatch.', 'Changer de smartwatch', 'Tous les bracelets pour votre %m'],
    es: ['Todavía nada para tu %m en este estilo.', 'Elige otro estilo arriba, u otro smartwatch.', 'Cambiar de smartwatch', 'Todas las correas para tu %m'],
    en: ['Nothing for your %m in this style yet.', 'Pick another style above, or another smartwatch.', 'Change smartwatch', 'All straps for your %m']
  };
  window.swbV2EmptyForWatch = function (box, w, sub) {
    var t = L[String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase()] || L.en;
    var m = w.model;
    box.classList.add('v2-empty');
    box.innerHTML = '';
    var h = document.createElement('p'); h.className = 'v2-empty__h'; h.textContent = t[0].replace('%m', m); box.appendChild(h);
    var s = document.createElement('p'); s.className = 'v2-empty__s'; s.textContent = sub || t[1]; box.appendChild(s);
    var row = document.createElement('div'); row.className = 'v2-empty__acts'; box.appendChild(row);
    var b = document.createElement('button'); b.type = 'button'; b.className = 'v2-empty__btn'; b.textContent = t[2];
    b.addEventListener('click', function () {
      var pill = document.querySelector('[data-v2-watch-open]');
      if (pill && pill.getClientRects().length) pill.click();
      else { var c = document.querySelector('.choose__watch'); if (c) c.click(); }
    });
    row.appendChild(b);
    if (w.url) {
      var a = document.createElement('a'); a.className = 'v2-empty__btn v2-empty__btn--go'; a.href = w.url; a.textContent = t[3].replace('%m', m);
      row.appendChild(a);
    }
  };
})();

/* THE ANNOUNCEMENT BAR NEVER CUTS A MESSAGE (2026-10-15, asked): a message wider than the bar shrinks its own text
   just enough to fit (never under 11px); measured again when the bar's width changes */
(function () {
  var stage = document.querySelector('.v2-ann__stage');
  if (!stage) return;
  function fit() {
    var w = stage.clientWidth;
    if (!w) return;
    stage.querySelectorAll('.v2-ann__txt, .v2-ann__dealtxt').forEach(function (t) {
      t.style.fontSize = ''; t.style.whiteSpace = ''; t.style.lineHeight = ''; t.style.textAlign = '';
      var box = t.parentElement && t.parentElement !== stage ? t.parentElement : t; // the message incl. its stars/badge
      var extra = Math.max(0, box.scrollWidth - t.scrollWidth);
      var room = w - extra - 6;
      var sw = t.scrollWidth;
      if (!sw || sw <= room) return;
      var fs = parseFloat(getComputedStyle(t).fontSize);
      t.style.fontSize = Math.max(11, Math.floor(fs * room / sw * 10) / 10) + 'px';
      // still too long at the floor (long DE/FR lines on a small phone): two short lines, never a cut word
      if (t.scrollWidth > room) { t.style.whiteSpace = 'normal'; t.style.lineHeight = '1.15'; t.style.textAlign = 'center'; }
    });
  }
  fit();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  if ('ResizeObserver' in window) new ResizeObserver(fit).observe(stage);
  else window.addEventListener('resize', fit);
})();

/* UNIVERSAL PRODUCT PAGE BADGES (2026-10-15, asked): the strap on screen gets the same badges as its product page
   ("Onze keuze", "Bespaar 26%"), top left on the photo; fetched once per strap from the v2badges product view */
(function () {
  var cache = {};
  function place(handle) {
    var stage = document.querySelector('#upp-main .upp__stage');
    if (!stage || !handle) return;
    var box = stage.querySelector('.v2-uppbadges');
    if (!box) { box = document.createElement('div'); box.className = 'v2-uppbadges'; stage.appendChild(box); }
    /* the server already printed this strap's badges (universal-product-page.liquid): nothing to fetch or swap */
    if (box.getAttribute('data-for') === handle && box.children.length) { stage.classList.add('has-v2badges'); return; }
    box.setAttribute('data-for', handle);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var p = cache[handle] || (cache[handle] = fetch(root + 'products/' + handle + '?view=v2badges').then(function (r) { return r.ok ? r.text() : ''; })['catch'](function () { return ''; }));
    p.then(function (html) {
      if (box.getAttribute('data-for') !== handle) return;
      // only the badge chips, never a whole page (a missing view answers with the full product page)
      var tmp = document.createElement('div'); tmp.innerHTML = /<html/i.test(html) ? '' : html;
      var chips = tmp.querySelectorAll('.badge');
      box.innerHTML = '';
      Array.prototype.forEach.call(chips, function (c) { box.appendChild(c); });
      stage.classList.toggle('has-v2badges', chips.length > 0);
    });
  }
  document.addEventListener('swb-v2:upp-product', function (ev) { place(ev.detail && ev.detail.handle); });
  var r0 = document.getElementById('upp-main');
  var h0 = document.querySelector('[data-v2-handle]');
  if (r0 && h0) place(h0.getAttribute('data-v2-handle'));
})();

/* UNIVERSAL PRODUCT PAGE: SWIPE THE PHOTO (2026-10-15, asked: "can't scroll the images, only press"). The photo
   follows the finger and a swipe steps to the next/previous thumbnail (the page's own switch), sliding in from the
   side it was pushed from; vertical scrolling stays the page's */
(function () {
  var stage = document.querySelector('#upp-main .upp__stage');
  if (!stage) return;
  var x0 = 0, y0 = 0, dx = 0, dir = 0, on = false, img = null;
  function thumbs() { return Array.prototype.slice.call(document.querySelectorAll('#upp-main [data-thumbs] .upp__thumb')).filter(function (t) { return !t.hidden; }); }
  stage.style.touchAction = 'pan-y';
  stage.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1 || e.target.closest('button, a')) return;
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; dir = 0; on = true;
    img = stage.querySelector('.upp__stage-img');
    if (img) img.style.transition = 'none';
  }, { passive: true });
  stage.addEventListener('touchmove', function (e) {
    if (!on) return;
    var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
    if (!dir) { if (Math.abs(mx) < 8 && Math.abs(my) < 8) return; dir = Math.abs(mx) > Math.abs(my) ? 1 : 2; }
    if (dir !== 1) { on = false; return; }
    dx = mx;
    if (img) img.style.transform = 'translateX(' + (dx * 0.6) + 'px)';
  }, { passive: true });
  stage.addEventListener('touchend', function () {
    if (!on) return; on = false;
    var list = thumbs();
    var back = function () { if (img) { img.style.transition = 'transform 0.25s cubic-bezier(0.22, 1, 0.36, 1)'; img.style.transform = ''; } };
    if (Math.abs(dx) < 44 || list.length < 2) { back(); return; }
    var at = list.findIndex(function (t) { return t.classList.contains('active'); });
    var step = dx < 0 ? 1 : -1;
    var next = list[(Math.max(0, at) + step + list.length) % list.length];
    if (img) { img.style.transform = ''; img.style.transition = ''; }
    next.click();
    // the new photo slides in from the side it was pushed from
    requestAnimationFrame(function () {
      var ni = stage.querySelector('.upp__stage-img');
      if (!ni || !ni.animate) return;
      ni.animate([{ transform: 'translateX(' + (step * 36) + 'px)', opacity: 0.35 }, { transform: 'none', opacity: 1 }], { duration: 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    });
    next.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  });
})();

/* SCROLL MOTION (2026-10-15, asked: option 2). Homepage sections rise and fade in a little further and softer, and
   product cards in every vertical grid (collections, search, sale, materials, bestsellers grid) do the same as they
   come into view, a beat apart along the row. Only cards below the first screen move, so nothing on screen at load
   jumps; cards in sideways rails are left alone. Transform and opacity only (smooth on phones); off with reduce motion. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var de = document.documentElement;
  de.classList.add('v2-motion');
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      e.target.classList.add('v2-mo-in');
    });
  }, { rootMargin: '0px 0px 30% 0px', threshold: 0.01 }); /* reveal ahead of the scroll (2026-10-15) */
  function inRail(el) { return !!el.closest('.scroll-area, .na-track, .newrow-carousel, [class*="carousel"], .v2-rvrow, .v2-occ__row, .swiper'); }
  function scan(root) {
    var cards = (root || document).querySelectorAll('.product-card:not([data-v2-mo])');
    var vh = window.innerHeight;
    var row = 0, lastTop = null;
    Array.prototype.forEach.call(cards, function (c) {
      c.setAttribute('data-v2-mo', '');
      if (inRail(c)) return;
      var r = c.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) return; // already on screen: no motion
      if (lastTop === null || Math.abs(r.top - lastTop) > 4) { row = 0; lastTop = r.top; } else row++;
      c.style.setProperty('--mo-d', Math.min(row, 3) * 70 + 'ms');
      c.classList.add('v2-mo');
      io.observe(c);
    });
  }
  function start() {
    scan();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) if (list[i].addedNodes.length) { (window.requestIdleCallback || setTimeout)(function () { scan(); }); return; }
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* BRAND-GATED SECTIONS (2026-10-15, asked: "people that have an Apple Watch preselected see a REQIOR product on the home
   page"): a section with data-v2-only-brand renders hidden and shows only while the saved watch is that brand. */
(function () {
  function norm(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function current() {
    try {
      var w = window.swbV2 && typeof window.swbV2.get === 'function' ? window.swbV2.get() : null;
      if (!w) w = JSON.parse(sessionStorage.getItem('swbV2Watch') || 'null');
      return w && w.brand ? w : null;
    } catch (e) { return null; }
  }
  /* and, where set, only for some MODELS of that brand (2026-10-19, pre-launch audit: REQIOR cases fit the Apple Watch
     7/8/9 45mm and the Ultra, so a Series 10 or a 41mm watch must not be told "premium for your Apple Watch") */
  function list(el, attr) { return String(el.getAttribute(attr) || '').split('|').map(norm).filter(Boolean); }
  function apply() {
    var w = current(), b = norm(w && w.brand), m = norm(w && ((w.brand || '') + ' ' + (w.model || '')));
    document.querySelectorAll('[data-v2-only-brand]').forEach(function (el) {
      var want = norm(el.getAttribute('data-v2-only-brand'));
      var ok = !!(b && want && (b === want || b.indexOf(want) === 0 || want.indexOf(b) === 0));
      var only = list(el, 'data-v2-only-models'), except = list(el, 'data-v2-except-models');
      if (ok && only.length) ok = only.some(function (t) { return m.indexOf(t) > -1; });
      if (ok && except.length) ok = !except.some(function (t) { return m.indexOf(t) > -1; });
      el.hidden = !ok;
    });
  }
  apply();
  document.addEventListener('swb-v2:watch', apply);
  window.addEventListener('swb-v2:watch', apply);
  window.addEventListener('pageshow', apply);
  window.addEventListener('storage', apply);
})();

/* PHONES: lazy images start loading about one and a half screens ahead of the finger (2026-10-15, asked: images load
   slower than the scroll). Chrome's own distance is shorter on a slow connection; this makes it the same everywhere. */
(function () {
  if (!('IntersectionObserver' in window) || !window.matchMedia('(max-width: 999px)').matches) return;
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; var t = e.target; if (!e.boundingClientRect.width || t.closest('[hidden], [aria-hidden="true"], .v2-sheet, .v2-mega, x-drawer, cart-drawer')) return; t.loading = 'eager'; io.unobserve(t); }); }, { rootMargin: '0px 0px 160% 0px' }); /* never the closed menu or hidden tabs (about 1 MB on home, 2026-10-16) */
  function scan() { document.querySelectorAll('img[loading="lazy"]').forEach(function (i) { if (!i._v2eager) { i._v2eager = 1; io.observe(i); } }); }
  scan();
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 300); }).observe(document.body, { childList: true, subtree: true });
})();

/* THE LIVE PRODUCT PAGE ADD (2026-10-15, asked: "the notification is not nice, the button disappears"): the theme's
   form still submits (its events and tracking stay), but the drawer no longer slides open on its own: our toast with
   the product photo confirms at once and "Bekijk" opens the drawer. The cart icon opens it as always. */
(function () {
  return; /* OFF 2026-10-16 (asked: the cart opens when the button is pressed, as on live, which is what the tests measured) */
  if (!document.querySelector('.shopify-section--main-product')) return;
  var suppressUntil = 0, pending = null;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var t = document.querySelector('.product-info__title, .product-info h1, h1');
    var im = document.querySelector('.product-gallery img, .product-gallery__media img, .product-gallery__media-list-wrapper img');
    pending = { title: t ? t.textContent.trim() : '', img: im ? String(im.currentSrc || im.src || '').split('?')[0] : '' };
    suppressUntil = Date.now() + 8000;
    if (window.swbV2Toast) window.swbV2Toast(pending.title, pending.img);
  }, true);
  function hold() { return pending && Date.now() < suppressUntil; }
  var dr = document.querySelector('cart-drawer');
  if (dr) {
    if (typeof dr.show === 'function') { var os = dr.show; dr.show = function () { if (hold()) return Promise.resolve(); return os.apply(this, arguments); }; }
    var proto = dr, desc = null;
    while (proto && !desc) { desc = Object.getOwnPropertyDescriptor(proto, 'open'); if (!desc) proto = Object.getPrototypeOf(proto); }
    if (desc && desc.set) {
      Object.defineProperty(dr, 'open', { configurable: true, get: function () { return desc.get ? desc.get.call(this) : this.hasAttribute('open'); }, set: function (v) { if (v && hold()) return; desc.set.call(this, v); } });
    }
  }
  document.documentElement.addEventListener('cart:change', function (e) {
    var d = e.detail || {};
    if (!pending || d.baseEvent !== 'variant:add') return;
    setTimeout(function () { pending = null; suppressUntil = 0; }, 1500);
  });
  document.addEventListener('click', function (e) {
    var x = e.target && e.target.closest ? e.target.closest('.v2-hdr__cart, a[href$="/cart"], [aria-controls*="cart-drawer"]') : null;
    if (x) { pending = null; suppressUntil = 0; }
  }, true);
})();

/* DAGDEAL LINK (2026-10-15, asked: the menu link landed at the top of the homepage): #dagdeal scrolls to the deal once
   the page has settled, and a tap on it while already on the homepage closes the menu and scrolls there */
(function () {
  function go() {
    var d = document.getElementById('dagdeal'), sec = d && (d.closest('.shopify-section') || d);
    if (!sec) return;
    var top = sec.getBoundingClientRect().top + window.scrollY - 140;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }
  if (location.hash === '#dagdeal') { window.addEventListener('load', function () { setTimeout(go, 150); setTimeout(go, 1200); }); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#dagdeal"]');
    if (!a || !document.getElementById('dagdeal')) return;
    e.preventDefault();
    var x = document.querySelector('.v2-sheet .v2-sheet__x, [data-v2-sheet-close]');
    if (x) x.click();
    history.replaceState(history.state, '', '#dagdeal');
    setTimeout(go, 350);
  }, true);
})();

/* HOUSE BRAND PAGES FOLLOW THE SAVED WATCH: moved to snippets/swb-v2-house-watch.liquid (2026-10-17) so it runs while
   the page parses instead of after the load event plus 900 ms */

/* ONE BACKGROUND BEHIND THE MENU (2026-10-16, asked): where a page starts with its own colour below the floating menu,
   the body's grey stayed visible behind the menu. Compare the colour behind the menu with the page's first colour just
   under it; when they differ, the top of the page is painted in the page's colour (scrolls with the page). */
(function () {
  var NONE = 'rgba(0, 0, 0, 0)';
  function colourAt(x, y) {
    var e = document.elementFromPoint(x, y);
    for (; e && e !== document.documentElement; e = e.parentElement) {
      if (e.closest && e.closest('[data-v2-hdr], .shopify-section-group-header-group')) return null;
      var b = getComputedStyle(e).backgroundColor;
      if (b !== NONE) return { c: b, el: e };
    }
    return null;
  }
  function fix() {
    if (window.scrollY > 40) return;
    var isl = document.querySelector('.v2-hdr__island');
    if (!isl) return;
    var bottom = isl.getBoundingClientRect().bottom;
    var page = colourAt(12, bottom + 36), behind = colourAt(12, Math.max(8, bottom - 30));
    var body = getComputedStyle(document.body).backgroundColor;
    if (!page || page.el === document.body || page.c === body) return;
    if (behind && behind.c === page.c) return;
    var h = Math.round(bottom + 60 + window.scrollY);
    document.body.style.backgroundImage = 'linear-gradient(' + page.c + ', ' + page.c + ')';
    document.body.style.backgroundSize = '100% ' + h + 'px';
    document.body.style.backgroundRepeat = 'no-repeat';
  }
  if (document.readyState === 'complete') fix(); else window.addEventListener('load', fix);
  document.addEventListener('DOMContentLoaded', fix);
})();

/* DESKTOP WATCH POPUP: the brand pills fill exactly one centred row (2026-10-16, asked: "fill in more brands until the row
   gets filled", Garmin was cut at some widths). Popular brands come first in the markup; any pill that would start a
   second row is hidden. Re-measured when the popup opens and on resize. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(min-width: 1000px)').matches) return;
  function fit() {
    document.querySelectorAll('.v2-watchpop .v2-quick--all').forEach(function (q) {
      if (!q.offsetParent) return;
      var bs = [].slice.call(q.children).filter(function (b) { return b.classList.contains('v2-quick__b'); });
      bs.forEach(function (b) { b.classList.remove('is-cut'); });
      if (!bs.length) return;
      /* the row is one line that would scroll: a pill that does not fit inside the popup's padding is hidden whole,
         never shown half (ICE was cut at the edge, 2026-10-19); measured left to right */
      var qr = q.getBoundingClientRect(), padR = parseFloat(getComputedStyle(q).paddingRight) || 0, hide = false, top = bs[0].offsetTop;
      /* one row only: whether the row wraps (desktop) or would scroll, a pill that starts a second line or sticks out on
         the right is hidden whole (ICE was cut at the edge, 2026-10-19) */
      bs.forEach(function (b) { if (hide || b.offsetTop > top + 4 || b.getBoundingClientRect().right > qr.right - padR + 1) { hide = true; b.classList.add('is-cut'); } });
      /* the selected brand always shows: swap it in for the last visible one */
      var on = q.querySelector('.v2-quick__b.is-on.is-cut, .v2-quick__b[aria-pressed="true"].is-cut');
      if (on) { var vis = bs.filter(function (b) { return !b.classList.contains('is-cut'); }); var last = vis[vis.length - 1]; if (last) { last.classList.add('is-cut'); on.classList.remove('is-cut'); } }
    });
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-v2-watch-open]')) setTimeout(fit, 60); });
  window.addEventListener('resize', function () { clearTimeout(fit._t); fit._t = setTimeout(fit, 150); });
})();


/* THE TRUSTED SHOPS BADGE STEPS ASIDE (2026-10-20, asked after the desktop sweep): the app's floating badge (93x171 on
   desktop, 147px above the corner; a tab on phones) sat over carousel arrows, hearts, "Bekijk alles" links, the second
   size button on the phone PDP and the bundle tray's price, and a click there opened the badge instead. Same position as
   live, but the new pages put controls along the right edge. It now fades out while a control (a button, an arrow, a
   small link, a field) is under it, and back in once that has scrolled past. Whole product cards do not count, so over
   ordinary content it stays. Checked per animation frame on scroll, resize and inner scrolling, a handful of
   elementsFromPoint calls. */
(function () {
  var de = document.documentElement, raf = 0, box = null;
  var CTRL = 'a[href],button,input,select,textarea,summary,label,[role="button"],[tabindex]:not([tabindex="-1"])';
  var PTS = [];
  [0.1, 0.5, 0.9].forEach(function (x) { [0.06, 0.28, 0.5, 0.72, 0.94].forEach(function (y) { PTS.push([x, y]); }); });
  function badge() {
    if (box && box.isConnected) return box;
    var c = document.querySelector('[id^="trustbadge-container"]');
    box = c && c.querySelector(':scope > div > div');
    return box;
  }
  function check() {
    raf = 0;
    var b = badge(); if (!b) return;
    var c = b.closest('[id^="trustbadge-container"]');
    var r = b.getBoundingClientRect();
    if (r.width < 10 || r.height < 10) return;
    var hide = false;
    for (var i = 0; i < PTS.length && !hide; i++) {
      var els = document.elementsFromPoint(r.left + r.width * PTS[i][0], r.top + r.height * PTS[i][1]);
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        if (c.contains(el)) continue;
        var ctl = el.closest && el.closest(CTRL);
        if (ctl) { var q = ctl.getBoundingClientRect(); if (q.width <= 260 && q.height <= 140) hide = true; }
        break; /* only the top thing under the badge counts */
      }
    }
    de.classList.toggle('v2-tsb-yield', hide);
  }
  function soon() { if (!raf) raf = requestAnimationFrame(check); }
  /* scrolling: once it pauses, not every frame (2026-10-28, asked: "scrolling felt buggy for product carousels and the menu
     on a OnePlus"): fifteen elementsFromPoint hit tests per frame of every carousel or menu swipe cost a mid-range phone
     frames; the badge still steps aside 120ms after the scroll stops */
  var stopT = 0;
  window.addEventListener('scroll', function () { clearTimeout(stopT); stopT = setTimeout(soon, 120); }, { passive: true, capture: true });
  window.addEventListener('resize', soon, { passive: true });
  document.addEventListener('transitionend', soon, true);
  /* card photo arrows only appear on hover */
  var hov = 0; document.addEventListener('pointerover', function () { if (!hov) hov = setTimeout(function () { hov = 0; soon(); }, 120); }, { passive: true });
  /* the badge arrives late (app embed); look for it for a while, then keep in step with clicks that open or close things */
  var tries = 0, iv = setInterval(function () { soon(); if (badge() || ++tries > 30) clearInterval(iv); }, 500);
  document.addEventListener('click', function () { setTimeout(soon, 350); }, true);
})();

/* MEGA MENU: a model's own pages (2026-10-20, SEO restore). The small toggle beside a model opens its material and
   accessory pages in place; one open at a time per column. */
document.addEventListener('click', function (e) {
  var t = e.target.closest && e.target.closest('[data-v2-msub-t]');
  if (!t) return;
  e.preventDefault(); e.stopPropagation();
  var list = document.getElementById(t.getAttribute('aria-controls'));
  if (!list) return;
  var open = t.getAttribute('aria-expanded') !== 'true';
  var col = t.closest('.v2-mega__col') || document;
  col.querySelectorAll('[data-v2-msub-t][aria-expanded="true"]').forEach(function (o) {
    if (o === t) return;
    o.setAttribute('aria-expanded', 'false');
    var l = document.getElementById(o.getAttribute('aria-controls')); if (l) l.hidden = true;
  });
  t.setAttribute('aria-expanded', open ? 'true' : 'false');
  list.hidden = !open;
  /* ACCESSORIES PER BRAND (2026-10-22, asked: "the way the brand opens isn't that clean"): on desktop the brands are a
     five-column row, and a brand's 50 models opened inside its own narrow column as one long strip. The open list now
     moves into one full-width panel under the row; the panel shows only while a list in it is open. */
  var accb = t.closest('.v2-accb');
  if (accb && window.matchMedia('(min-width: 990px)').matches) {
    var pan = accb.querySelector('.v2-accb__panel');
    if (!pan) { pan = document.createElement('div'); pan.className = 'v2-accb__panel'; accb.appendChild(pan); }
    if (list.parentNode !== pan) pan.appendChild(list);
    /* WHICH BRAND THIS IS (2026-10-28, asked: "the pills open beneath, kind of confusing, I missed it at first"): the
       panel names the brand, links to all its accessories, can be closed, and points up at the brand that opened it */
    if (open) {
      var row = t.closest('.v2-msub__row');
      var lnk = row && row.querySelector('.v2-bx__l');
      var name = lnk ? lnk.textContent.trim() : '';
      var L = String(document.documentElement.lang || 'nl').slice(0, 2);
      var W = { nl: ['Kies je model', 'Alle %s accessoires', 'Sluiten'], de: ['Wähle dein Modell', 'Alles Zubehör für %s', 'Schließen'], fr: ['Choisissez votre modèle', 'Tous les accessoires %s', 'Fermer'], es: ['Elige tu modelo', 'Todos los accesorios %s', 'Cerrar'], en: ['Choose your model', 'All %s accessories', 'Close'] }[L] || ['Choose your model', 'All %s accessories', 'Close'];
      var hd = pan.querySelector('.v2-accb__ph');
      if (!hd) {
        hd = document.createElement('div');
        hd.className = 'v2-accb__ph';
        hd.innerHTML = '<p class="v2-accb__pt"><b></b> <span></span></p><a class="v2-accb__pa"></a><button type="button" class="v2-accb__px"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>';
        pan.insertBefore(hd, pan.firstChild);
        hd.querySelector('.v2-accb__px').addEventListener('click', function () {
          var on = accb.querySelector('[data-v2-msub-t][aria-expanded="true"]');
          if (on) on.click();
        });
      }
      hd.querySelector('b').textContent = name;
      hd.querySelector('span').textContent = W[0];
      var all = hd.querySelector('.v2-accb__pa');
      if (lnk && lnk.getAttribute('href')) { all.href = lnk.getAttribute('href'); all.textContent = W[1].replace('%s', name) + ' →'; all.hidden = false; } else { all.hidden = true; }
      hd.querySelector('.v2-accb__px').setAttribute('aria-label', W[2]);
      if (row) {
        var x = row.getBoundingClientRect(), y = accb.getBoundingClientRect();
        pan.style.setProperty('--v2-accb-x', Math.round(x.left - y.left + Math.min(x.width / 2, 60)) + 'px');
      }
      pan.classList.remove('is-in');
      void pan.offsetWidth;
      pan.classList.add('is-in');
    }
  }
}, true);

/* CART QUANTITY STEP BUTTONS (2026-10-21, usability audit). snippets/swb-v2-qty-btn.liquid sits beside the theme's
   quantity input; set the input and fire the `change` the theme's <line-item-quantity> already listens for. */
document.addEventListener('click', function (ev) {
  var b = ev.target.closest && ev.target.closest('[data-v2-qb]');
  if (!b) return;
  ev.preventDefault();
  var inp = b.parentElement && b.parentElement.querySelector('input[data-line-key]');
  if (!inp) return;
  var v = (parseInt(inp.value, 10) || 0) + parseInt(b.getAttribute('data-v2-qb'), 10);
  var max = parseInt(inp.getAttribute('max'), 10);
  if (v < 0) v = 0;
  if (max && v > max) v = max;
  if (String(v) === inp.value) return;
  inp.value = String(v);
  inp.dispatchEvent(new Event('change', { bubbles: true }));
});

/* CHOOSE YOUR SIZE FIRST (2026-10-21, usability audit: a strap arrived with its first size already ticked, so a 46mm
   owner could add the 40mm without noticing). On a product page whose watch-size option has two or more sizes, and
   when the visitor did not arrive on a chosen variant (?variant=), the size starts unchosen: the ticked one looks
   like the others, a "Which size do I have?" link opens the model guide, and add to cart (also the sticky bar)
   asks for the size first instead of adding a size nobody picked. The form itself is untouched; the theme keeps its
   default variant, the check only waits for one tap on a size. */
(function () {
  var vp = document.querySelector('.product-info__variant-picker variant-picker');
  if (!vp || /[?&]variant=/.test(location.search)) return;
  var formId = vp.getAttribute('form');
  var form = formId && document.getElementById(formId);
  if (!form) return;
  var SIZE = /maat|size|gr(ö|oe|o)(ß|ss)e|taille|talla|tama(ñ|n)o/i;
  var fs = null;
  vp.querySelectorAll('fieldset.variant-picker__option').forEach(function (f) {
    if (fs) return;
    var lg = f.querySelector('legend');
    var live = f.querySelectorAll('input[type=radio]:not([disabled])');
    if (lg && SIZE.test(lg.textContent) && live.length > 1) fs = f;
  });
  if (!fs) return;
  var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var T = {
    nl: ['Welke maat heb ik?', 'Kies eerst je maat'],
    de: ['Welche Größe habe ich?', 'Bitte zuerst deine Größe wählen'],
    fr: ['Quelle taille ai-je ?', "Choisissez d'abord votre taille"],
    es: ['¿Qué talla tengo?', 'Elige primero tu talla'],
    en: ['Which size do I have?', 'Please choose your size first']
  }[lang] || ['Which size do I have?', 'Please choose your size first'];

  fs.classList.add('v2-sz', 'is-pending');
  var info = fs.querySelector('.variant-picker__option-info');
  if (info) {
    var help = document.createElement('button');
    help.type = 'button';
    help.className = 'v2-sz__help';
    help.setAttribute('data-v2-guide-open', '');
    help.textContent = T[0];
    info.appendChild(help);
  }
  var msg = document.createElement('p');
  msg.className = 'v2-sz__msg';
  msg.setAttribute('role', 'alert');
  msg.hidden = true;
  msg.textContent = T[1];
  fs.appendChild(msg);

  function chosen() {
    fs.classList.remove('is-pending', 'is-error');
    msg.hidden = true;
  }
  fs.addEventListener('click', function (ev) {
    if (ev.target.closest('label.block-swatch, input[type=radio]')) chosen();
  });
  fs.addEventListener('change', chosen);

  function blocks(ev) {
    if (!fs.classList.contains('is-pending')) return false;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    fs.classList.add('is-error');
    msg.hidden = false;
    try {
      fs.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } catch (e) {
      fs.scrollIntoView();
    }
    var first = fs.querySelector('input[type=radio]:not([disabled])');
    if (first) {
      try {
        first.focus({ preventScroll: true });
      } catch (e) {
        /* ignore */
      }
    }
    return true;
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('button[type=submit], input[type=submit]');
    if (!b) return;
    var f = b.getAttribute('form') ? document.getElementById(b.getAttribute('form')) : b.form;
    if (f === form) blocks(ev);
  }, true);
  document.addEventListener('submit', function (ev) {
    if (ev.target === form) blocks(ev);
  }, true);
})();

/* MENU VARIANT "search" (2026-10-21): the visible phone search field opens the header's own search bar */
document.addEventListener('click', function (ev) {
  if (!ev.target.closest || !ev.target.closest('[data-v2-search-proxy]')) return;
  ev.preventDefault();
  ev.stopPropagation();
  var b = document.querySelector('[data-v2-search-open]');
  if (b) setTimeout(function () { b.click(); }, 0);
});

/* ACCESSORIES MENU, PER BRAND (2026-10-21, asked: "if you press the brand it should open the pop up and not redirect
   you"): a brand name with a model list opens that list, like its arrow; the list's first entry still goes to all of
   the brand's accessories. Brands without a list keep their plain link. */
document.addEventListener('click', function (ev) {
  var a = ev.target.closest && ev.target.closest('.v2-accb .v2-msub__row > a.v2-bx__l');
  if (!a || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button > 0) return;
  var t = a.parentElement.querySelector(':scope > [data-v2-msub-t]');
  if (!t) return;
  ev.preventDefault();
  t.click();
}, true);

/* ALL BRANDS AND MODELS (2026-10-21, asked: "the way Fitbit opens should be the same for every brand"): the brand you
   open moves to the front of the grid and opens full width there, the others close, and the grid's top is brought
   into view, so every brand opens in the same place as the first one. */
document.addEventListener('toggle', function (ev) {
  var d = ev.target;
  if (!d || !d.classList || !d.classList.contains('v2-mindex__b')) return;
  // closed again: back to its own place in the A to Z order (2026-10-21, asked)
  if (!d.open) { d.style.order = ''; return; }
  var grid = d.parentElement;
  [].forEach.call(grid.children, function (o) {
    if (o !== d) { o.style.order = ''; if (o.open) o.open = false; }
  });
  d.style.order = '-1';
  var top = grid.getBoundingClientRect().top;
  var hdr = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--v2-hdr-h'), 10) || 80;
  if (top < hdr + 10 || top > window.innerHeight * 0.6) {
    window.scrollTo({ top: window.scrollY + top - hdr - 24, behavior: 'smooth' });
  }
}, true);

/* CUSTOM DROPDOWN (2026-10-21, the finder band: "the dropdown which opens, not the default one"). Any
   <select data-v2-cdd> gets a button and our own panel; the <select> stays (visually hidden) and remains the source of
   truth: the panel is drawn from its options and optgroups, a choice sets its value and fires `change`, so whatever
   already listens to the select (the picker) works unchanged. data-cdd-grid draws the options as a grid (brands),
   data-cdd-search adds a search box (models, grouped by series). After a brand is chosen the model panel opens. */
(function () {
  var CHEV = '<svg class="v2-cdd__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var n = 0;
  function closeAll(except) {
    document.querySelectorAll('.v2-cdd.is-open').forEach(function (w) {
      if (w !== except && w._cddClose) w._cddClose();
    });
  }
  function enhance(sel) {
    if (sel._cdd) return;
    sel._cdd = true;
    var wrap = document.createElement('div');
    wrap.className = 'v2-cdd';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('v2-cdd__native');
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');
    var id = 'v2-cdd-' + ++n;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'v2-cdd__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    btn.innerHTML = '<span class="v2-cdd__cap"></span><span class="v2-cdd__val"></span>' + CHEV;
    btn.querySelector('.v2-cdd__cap').textContent = sel.getAttribute('data-cdd-label') || '';
    var pan = document.createElement('div');
    pan.className = 'v2-cdd__panel' + (sel.hasAttribute('data-cdd-grid') ? ' v2-cdd__panel--grid' : '');
    pan.id = id;
    pan.hidden = true;
    var search = null;
    if (sel.getAttribute('data-cdd-search')) {
      search = document.createElement('input');
      search.type = 'search';
      search.className = 'v2-cdd__q';
      search.placeholder = sel.getAttribute('data-cdd-search');
      search.setAttribute('aria-label', sel.getAttribute('data-cdd-search'));
      search.autocomplete = 'off';
      pan.appendChild(search);
    }
    var list = document.createElement('div');
    list.className = 'v2-cdd__list';
    list.setAttribute('role', 'listbox');
    if (sel.getAttribute('data-cdd-label')) list.setAttribute('aria-label', sel.getAttribute('data-cdd-label'));
    pan.appendChild(list);
    wrap.appendChild(btn);
    wrap.appendChild(pan);

    function match(o, q) {
      return !q || o.textContent.toLowerCase().indexOf(q) > -1;
    }
    function add(o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'v2-cdd__o';
      b.setAttribute('role', 'option');
      b.setAttribute('aria-selected', o.selected && o.value !== '' ? 'true' : 'false');
      b.textContent = o.textContent;
      b.setAttribute('data-v', o.value);
      list.appendChild(b);
    }
    var lastIdx = -2;
    function label() {
      var cur = sel.options[sel.selectedIndex];
      btn.querySelector('.v2-cdd__val').textContent = cur ? cur.textContent : '';
      btn.classList.toggle('is-empty', !cur || cur.value === '');
      btn.disabled = sel.disabled;
      wrap.classList.toggle('is-disabled', sel.disabled);
      lastIdx = sel.selectedIndex;
    }
    function render() {
      label();
      if (pan.hidden) return;
      var q = search ? search.value.trim().toLowerCase() : '';
      list.innerHTML = '';
      var any = false;
      [].forEach.call(sel.children, function (ch) {
        if (ch.tagName === 'OPTGROUP') {
          var opts = [].filter.call(ch.children, function (o) { return match(o, q); });
          if (!opts.length) return;
          var h = document.createElement('p');
          h.className = 'v2-cdd__grp';
          h.textContent = ch.label;
          list.appendChild(h);
          opts.forEach(function (o) { any = true; add(o); });
        } else if (ch.value !== '' && match(ch, q)) {
          any = true;
          add(ch);
        }
      });
      if (!any) {
        var e = document.createElement('p');
        e.className = 'v2-cdd__empty';
        e.textContent = sel.getAttribute('data-cdd-empty') || '';
        list.appendChild(e);
      }
    }
    function open() {
      if (sel.disabled) return;
      closeAll(wrap);
      pan.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      if (search) search.value = '';
      render();
      setTimeout(function () {
        if (search && window.matchMedia('(pointer: fine)').matches) search.focus();
        else {
          var s = list.querySelector('[aria-selected="true"]');
          if (s) s.scrollIntoView({ block: 'nearest' });
        }
      }, 30);
    }
    function close() {
      pan.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    wrap._cddClose = close;
    sel._cddOpen = open;
    btn.addEventListener('click', function () {
      if (pan.hidden) open();
      else close();
    });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('.v2-cdd__o');
      if (!b) return;
      sel.value = b.getAttribute('data-v');
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      close();
      label();
      btn.focus();
      // brand chosen: go straight on to the model
      if (sel.hasAttribute('data-v2-brand')) {
        var scope = wrap.closest('[data-v2-pick]');
        var m = scope && scope.querySelector('select[data-v2-model]');
        if (m && m._cddOpen) setTimeout(m._cddOpen, 80);
      }
    });
    if (search) search.addEventListener('input', render);
    pan.addEventListener('keydown', function (e) {
      var opts = [].slice.call(list.querySelectorAll('.v2-cdd__o'));
      var i = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0] || {}).focus && (opts[i + 1] || opts[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) opts[i - 1].focus(); else if (search) search.focus(); }
      else if (e.key === 'Enter' && document.activeElement === search && opts[0]) { e.preventDefault(); opts[0].click(); }
      else if (e.key === 'Escape') { close(); btn.focus(); }
    });
    new MutationObserver(render).observe(sel, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    sel.addEventListener('change', render);
    // the picker also sets the value from code (a saved watch, a brand chip), which fires no event
    setInterval(function () {
      if (sel.selectedIndex !== lastIdx || btn.disabled !== sel.disabled) label();
    }, 500);
    label();
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.v2-cdd')) closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
  function init() {
    document.querySelectorAll('select[data-v2-cdd]').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  else setTimeout(init, 0);
})();

/* MODEL PICKERS STAY IN FRAME (2026-10-29, asked: "make sure that model selector stays in frame and scrolls up if it
   becomes smaller"). A tap inside a model picker (the materials/occasions "Welke smartwatch heb jij?" card and its
   "Bandjes voor je ..." bar, the product page's model gate, the shortlist picker) can swap it for something much
   shorter: a chosen model folds the open card into one line. The page below moves up, so the picker could end up
   under the header island or above the screen. After the change it is scrolled back to just under the header. */
(function () {
  if (window.__swbPickFrame) return; window.__swbPickFrame = true; /* swb-v2.js can load twice on a page: run once */
  var SEL = '.mb-ask, .mb-ask__on, [data-gate], [data-v2-spick]';
  function under() {
    var h = document.querySelector('.v2-hdr__island, .v2-hdr');
    var b = h ? h.getBoundingClientRect().bottom : 0;
    return Math.max(0, b) + 12;
  }
  function visible(el) { return el && el.isConnected && !el.hidden && el.getClientRects().length > 0; }
  function check(p, host, h0) {
    var el = visible(p) ? p : (host && host.querySelector('.mb-ask__on:not([hidden]), .mb-ask:not([hidden]), [data-gate], [data-v2-spick]'));
    if (!visible(el)) return;
    var r = el.getBoundingClientRect(), top = under();
    /* shrank and now starts behind the header or above the screen: back into view */
    if (r.top < top && (r.height < h0 - 24 || el !== p)) window.scrollBy({ top: r.top - top, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var p = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!p) return;
    var host = p.parentElement, h0 = p.getBoundingClientRect().height;
    setTimeout(function () { check(p, host, h0); }, 160);
    setTimeout(function () { check(p, host, h0); }, 700);
  }, true);
})();

/* PHONE FOOTER COLUMNS FOLD (2026-10-29): a tap on a column's heading opens or closes its links (CSS hides them on
   phones while closed); the heading acts as a button for keyboards and screen readers there too. */
(function () {
  if (window.__swbFootFold) return; window.__swbFootFold = true; /* swb-v2.js can load twice on a page: run once */
  var phone = window.matchMedia('(max-width: 749px)');
  function prep() {
    document.querySelectorAll('.v2-foot__col > .v2-foot__ct').forEach(function (h, i) {
      if (h.hasAttribute('data-v2-fold')) return;
      h.setAttribute('data-v2-fold', '');
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      /* the first column ("Snel naar") starts open, the others closed, so it is clear they open (2026-10-29, asked) */
      var open = i === 0;
      h.parentElement.classList.toggle('is-open', open);
      h.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  function toggle(h) {
    if (!phone.matches) return;
    var col = h.parentElement, open = !col.classList.contains('is-open');
    col.classList.toggle('is-open', open);
    h.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('.v2-foot__col > .v2-foot__ct');
    if (h) toggle(h);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var h = e.target.closest && e.target.closest('.v2-foot__col > .v2-foot__ct');
    if (h) { e.preventDefault(); toggle(h); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prep); else prep();
})();

/* PDP PHOTO PILLS INSIDE THE PHOTO (2026-10-30, asked: "on desktop PDP the heart icon and scroll to bundle pills go out
   of frame where the image is"). Both sit 16-20px in from the gallery wrapper's right edge, but on wide screens the
   photo stops at its own width (640px at 1920) inside a wider wrapper, so they hung over the photo's edge. The gap
   between the selected photo's right edge and the wrapper's is measured into --v2-gal-inset, which the CSS adds to
   their right offset. Re-measured on resize and when the photo changes. */
(function () {
  function fit() {
    document.querySelectorAll('.product-gallery__media-list-wrapper').forEach(function (w) {
      var m = w.querySelector('.product-gallery__media.is-selected img, .product-gallery__media img');
      if (!m) return;
      var gap = Math.round(w.getBoundingClientRect().right - m.getBoundingClientRect().right);
      w.style.setProperty('--v2-gal-inset', (gap > 0 && gap < 400 ? gap : 0) + 'px');
    });
  }
  var t = 0;
  function soon() { clearTimeout(t); t = setTimeout(fit, 60); }
  function init() {
    if (!document.querySelector('.product-gallery__media-list-wrapper')) return;
    fit();
    window.addEventListener('resize', soon, { passive: true });
    window.addEventListener('load', fit);
    document.addEventListener('carousel:change', soon, true);
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.product-gallery')) soon(); }, true);
    if (window.ResizeObserver) { var ro = new ResizeObserver(soon); document.querySelectorAll('.product-gallery__media-list-wrapper').forEach(function (w) { ro.observe(w); }); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
}
